require("core-js/modules/es6.object.assign");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.promise");

require("core-js/modules/es6.string.repeat");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.array.last-index-of");

require("core-js/modules/es6.date.now");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.name");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

module.exports = function (t) {
  var e = {};

  function n(r) {
    if (e[r]) return e[r].exports;
    var i = e[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
  }

  return n.m = t, n.c = e, n.d = function (t, e, r) {
    n.o(t, e) || Object.defineProperty(t, e, {
      enumerable: !0,
      get: r
    });
  }, n.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, n.t = function (t, e) {
    if (1 & e && (t = n(t)), 8 & e) return t;
    if (4 & e && "object" == typeof t && t && t.__esModule) return t;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: t
    }), 2 & e && "string" != typeof t) for (var i in t) {
      n.d(r, i, function (e) {
        return t[e];
      }.bind(null, i));
    }
    return r;
  }, n.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t["default"];
    } : function () {
      return t;
    };
    return n.d(e, "a", e), e;
  }, n.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, n.p = "", n(n.s = 6);
}([function (t, e) {
  t.exports = require("react");
}, function (t, e, n) {
  "use strict";

  function r(t) {
    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return t;
  }

  function i(t, e) {
    t.prototype = Object.create(e.prototype), t.prototype.constructor = t, t.__proto__ = e;
  }
  /*!
   * GSAP 3.3.4
   * https://greensock.com
   *
   * @license Copyright 2008-2020, GreenSock. All rights reserved.
   * Subject to the terms at https://greensock.com/standard-license or for
   * Club GreenSock members, the agreement issued with that membership.
   * @author: Jack Doyle, jack@greensock.com
  */


  n.r(e), n.d(e, "gsap", function () {
    return Ir;
  }), n.d(e, "default", function () {
    return Ir;
  }), n.d(e, "CSSPlugin", function () {
    return Xr;
  }), n.d(e, "TweenMax", function () {
    return jr;
  }), n.d(e, "TweenLite", function () {
    return Ve;
  }), n.d(e, "TimelineMax", function () {
    return Re;
  }), n.d(e, "TimelineLite", function () {
    return Re;
  }), n.d(e, "Power0", function () {
    return xn;
  }), n.d(e, "Power1", function () {
    return bn;
  }), n.d(e, "Power2", function () {
    return wn;
  }), n.d(e, "Power3", function () {
    return Mn;
  }), n.d(e, "Power4", function () {
    return Tn;
  }), n.d(e, "Linear", function () {
    return Sn;
  }), n.d(e, "Quad", function () {
    return Cn;
  }), n.d(e, "Cubic", function () {
    return kn;
  }), n.d(e, "Quart", function () {
    return On;
  }), n.d(e, "Quint", function () {
    return Pn;
  }), n.d(e, "Strong", function () {
    return An;
  }), n.d(e, "Elastic", function () {
    return En;
  }), n.d(e, "Back", function () {
    return Dn;
  }), n.d(e, "SteppedEase", function () {
    return Ln;
  }), n.d(e, "Bounce", function () {
    return zn;
  }), n.d(e, "Sine", function () {
    return Nn;
  }), n.d(e, "Expo", function () {
    return Bn;
  }), n.d(e, "Circ", function () {
    return Rn;
  });

  var a,
      o,
      s,
      l,
      u,
      c,
      f,
      h,
      d,
      p,
      g,
      m,
      _,
      v,
      y,
      x,
      b,
      w,
      M,
      T,
      S,
      C,
      k,
      O,
      P,
      A = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
      lineHeight: ""
    }
  },
      E = {
    duration: .5,
    overwrite: !1,
    delay: 0
  },
      D = 1e8,
      L = 2 * Math.PI,
      z = L / 4,
      N = 0,
      B = Math.sqrt,
      R = Math.cos,
      F = Math.sin,
      Y = function Y(t) {
    return "string" == typeof t;
  },
      X = function X(t) {
    return "function" == typeof t;
  },
      I = function I(t) {
    return "number" == typeof t;
  },
      j = function j(t) {
    return void 0 === t;
  },
      Z = function Z(t) {
    return "object" == typeof t;
  },
      W = function W(t) {
    return !1 !== t;
  },
      H = function H() {
    return "undefined" != typeof window;
  },
      V = function V(t) {
    return X(t) || Y(t);
  },
      U = Array.isArray,
      G = /(?:-?\.?\d|\.)+/gi,
      q = /[-+=.]*\d+[.e\-+]*\d*[e\-\+]*\d*/g,
      Q = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
      K = /[-+=.]*\d+(?:\.|e-|e)*\d*/gi,
      $ = /\(([^()]+)\)/i,
      J = /[+-]=-?[\.\d]+/,
      tt = /[#\-+.]*\b[a-z\d-=+%.]+/gi,
      et = {},
      nt = {},
      rt = function rt(t) {
    return (nt = Pt(t, et)) && fn;
  },
      it = function it(t, e) {
    return console.warn("Invalid property", t, "set to", e, "Missing plugin? gsap.registerPlugin()");
  },
      at = function at(t, e) {
    return !e && console.warn(t);
  },
      ot = function ot(t, e) {
    return t && (et[t] = e) && nt && (nt[t] = e) || et;
  },
      st = function st() {
    return 0;
  },
      lt = {},
      ut = [],
      ct = {},
      ft = {},
      ht = {},
      dt = 30,
      pt = [],
      gt = "",
      mt = function mt(t) {
    var e,
        n,
        r = t[0];

    if (Z(r) || X(r) || (t = [t]), !(e = (r._gsap || {}).harness)) {
      for (n = pt.length; n-- && !pt[n].targetTest(r);) {
        ;
      }

      e = pt[n];
    }

    for (n = t.length; n--;) {
      t[n] && (t[n]._gsap || (t[n]._gsap = new Ne(t[n], e))) || t.splice(n, 1);
    }

    return t;
  },
      _t = function _t(t) {
    return t._gsap || mt(ee(t))[0]._gsap;
  },
      vt = function vt(t, e) {
    var n = t[e];
    return X(n) ? t[e]() : j(n) && t.getAttribute(e) || n;
  },
      yt = function yt(t, e) {
    return (t = t.split(",")).forEach(e) || t;
  },
      xt = function xt(t) {
    return Math.round(1e5 * t) / 1e5 || 0;
  },
      bt = function bt(t, e) {
    for (var n = e.length, r = 0; t.indexOf(e[r]) < 0 && ++r < n;) {
      ;
    }

    return r < n;
  },
      wt = function wt(t, e, n) {
    var r,
        i = I(t[1]),
        a = (i ? 2 : 1) + (e < 2 ? 0 : 1),
        o = t[a];

    if (i && (o.duration = t[1]), o.parent = n, e) {
      for (r = o; n && !("immediateRender" in r);) {
        r = n.vars.defaults || {}, n = W(n.vars.inherit) && n.parent;
      }

      o.immediateRender = W(r.immediateRender), e < 2 ? o.runBackwards = 1 : o.startAt = t[a - 1];
    }

    return o;
  },
      Mt = function Mt() {
    var t,
        e,
        n = ut.length,
        r = ut.slice(0);

    for (ct = {}, ut.length = 0, t = 0; t < n; t++) {
      (e = r[t]) && e._lazy && (e.render(e._lazy[0], e._lazy[1], !0)._lazy = 0);
    }
  },
      Tt = function Tt(t, e, n, r) {
    ut.length && Mt(), t.render(e, n, r), ut.length && Mt();
  },
      St = function St(t) {
    var e = parseFloat(t);
    return (e || 0 === e) && (t + "").match(tt).length < 2 ? e : t;
  },
      Ct = function Ct(t) {
    return t;
  },
      kt = function kt(t, e) {
    for (var n in e) {
      n in t || (t[n] = e[n]);
    }

    return t;
  },
      Ot = function Ot(t, e) {
    for (var n in e) {
      n in t || "duration" === n || "ease" === n || (t[n] = e[n]);
    }
  },
      Pt = function Pt(t, e) {
    for (var n in e) {
      t[n] = e[n];
    }

    return t;
  },
      At = function t(e, n) {
    for (var r in n) {
      e[r] = Z(n[r]) ? t(e[r] || (e[r] = {}), n[r]) : n[r];
    }

    return e;
  },
      Et = function Et(t, e) {
    var n,
        r = {};

    for (n in t) {
      n in e || (r[n] = t[n]);
    }

    return r;
  },
      Dt = function Dt(t) {
    var e = t.parent || a,
        n = t.keyframes ? Ot : kt;
    if (W(t.inherit)) for (; e;) {
      n(t, e.vars.defaults), e = e.parent || e._dp;
    }
    return t;
  },
      Lt = function Lt(t, e, n, r) {
    void 0 === n && (n = "_first"), void 0 === r && (r = "_last");
    var i = e._prev,
        a = e._next;
    i ? i._next = a : t[n] === e && (t[n] = a), a ? a._prev = i : t[r] === e && (t[r] = i), e._next = e._prev = e.parent = null;
  },
      zt = function zt(t, e) {
    !t.parent || e && !t.parent.autoRemoveChildren || t.parent.remove(t), t._act = 0;
  },
      Nt = function Nt(t) {
    for (var e = t; e;) {
      e._dirty = 1, e = e.parent;
    }

    return t;
  },
      Bt = function Bt(t) {
    for (var e = t.parent; e && e.parent;) {
      e._dirty = 1, e.totalDuration(), e = e.parent;
    }

    return t;
  },
      Rt = function Rt(t) {
    return t._repeat ? Ft(t._tTime, t = t.duration() + t._rDelay) * t : 0;
  },
      Ft = function Ft(t, e) {
    return (t /= e) && ~~t === t ? ~~t - 1 : ~~t;
  },
      Yt = function Yt(t, e) {
    return (t - e._start) * e._ts + (e._ts >= 0 ? 0 : e._dirty ? e.totalDuration() : e._tDur);
  },
      Xt = function Xt(t) {
    return t._end = xt(t._start + (t._tDur / Math.abs(t._ts || t._rts || 1e-8) || 0));
  },
      It = function It(t, e) {
    var n;

    if ((e._time || e._initted && !e._dur) && (n = Yt(t.rawTime(), e), (!e._dur || Qt(0, e.totalDuration(), n) - e._tTime > 1e-8) && e.render(n, !0)), Nt(t)._dp && t._initted && t._time >= t._dur && t._ts) {
      if (t._dur < t.duration()) for (n = t; n._dp;) {
        n.rawTime() >= 0 && n.totalTime(n._tTime), n = n._dp;
      }
      t._zTime = -1e-8;
    }
  },
      jt = function jt(t, e, n, r) {
    return e.parent && zt(e), e._start = xt(n + e._delay), e._end = xt(e._start + (e.totalDuration() / Math.abs(e.timeScale()) || 0)), function (t, e, n, r, i) {
      void 0 === n && (n = "_first"), void 0 === r && (r = "_last");
      var a,
          o = t[r];
      if (i) for (a = e[i]; o && o[i] > a;) {
        o = o._prev;
      }
      o ? (e._next = o._next, o._next = e) : (e._next = t[n], t[n] = e), e._next ? e._next._prev = e : t[r] = e, e._prev = o, e.parent = e._dp = t;
    }(t, e, "_first", "_last", t._sort ? "_start" : 0), t._recent = e, r || It(t, e), t;
  },
      Zt = function Zt(t, e) {
    return (et.ScrollTrigger || it("scrollTrigger", e)) && et.ScrollTrigger.create(e, t);
  },
      Wt = function Wt(t, e, n, r) {
    return je(t, e), t._initted ? !n && t._pt && (t._dur && !1 !== t.vars.lazy || !t._dur && t.vars.lazy) && c !== we.frame ? (ut.push(t), t._lazy = [e, r], 1) : void 0 : 1;
  },
      Ht = function Ht(t, e, n) {
    var r = t._repeat,
        i = xt(e) || 0;
    return t._dur = i, t._tDur = r ? r < 0 ? 1e10 : xt(i * (r + 1) + t._rDelay * r) : i, t._time > i && (t._time = i, t._tTime = Math.min(t._tTime, t._tDur)), !n && Nt(t.parent), t.parent && Xt(t), t;
  },
      Vt = function Vt(t) {
    return t instanceof Re ? Nt(t) : Ht(t, t._dur);
  },
      Ut = {
    _start: 0,
    endTime: st
  },
      Gt = function t(e, n) {
    var r,
        i,
        a = e.labels,
        o = e._recent || Ut,
        s = e.duration() >= D ? o.endTime(!1) : e._dur;
    return Y(n) && (isNaN(n) || n in a) ? "<" === (r = n.charAt(0)) || ">" === r ? ("<" === r ? o._start : o.endTime(o._repeat >= 0)) + (parseFloat(n.substr(1)) || 0) : (r = n.indexOf("=")) < 0 ? (n in a || (a[n] = s), a[n]) : (i = +(n.charAt(r - 1) + n.substr(r + 1)), r > 1 ? t(e, n.substr(0, r - 1)) + i : s + i) : null == n ? s : +n;
  },
      qt = function qt(t, e) {
    return t || 0 === t ? e(t) : e;
  },
      Qt = function Qt(t, e, n) {
    return n < t ? t : n > e ? e : n;
  },
      Kt = function Kt(t) {
    return (t + "").substr((parseFloat(t) + "").length);
  },
      $t = [].slice,
      Jt = function Jt(t, e) {
    return t && Z(t) && "length" in t && (!e && !t.length || t.length - 1 in t && Z(t[0])) && !t.nodeType && t !== o;
  },
      te = function te(t, e, n) {
    return void 0 === n && (n = []), t.forEach(function (t) {
      var r;
      return Y(t) && !e || Jt(t, 1) ? (r = n).push.apply(r, ee(t)) : n.push(t);
    }) || n;
  },
      ee = function ee(t, e) {
    return !Y(t) || e || !s && Me() ? U(t) ? te(t, e) : Jt(t) ? $t.call(t, 0) : t ? [t] : [] : $t.call(l.querySelectorAll(t), 0);
  },
      ne = function ne(t) {
    return t.sort(function () {
      return .5 - Math.random();
    });
  },
      re = function re(t) {
    if (X(t)) return t;
    var e = Z(t) ? t : {
      each: t
    },
        n = Ae(e.ease),
        r = e.from || 0,
        i = parseFloat(e.base) || 0,
        a = {},
        o = r > 0 && r < 1,
        s = isNaN(r) || o,
        l = e.axis,
        u = r,
        c = r;
    return Y(r) ? u = c = {
      center: .5,
      edges: .5,
      end: 1
    }[r] || 0 : !o && s && (u = r[0], c = r[1]), function (t, o, f) {
      var h,
          d,
          p,
          g,
          m,
          _,
          v,
          y,
          x,
          b = (f || e).length,
          w = a[b];

      if (!w) {
        if (!(x = "auto" === e.grid ? 0 : (e.grid || [1, D])[1])) {
          for (v = -D; v < (v = f[x++].getBoundingClientRect().left) && x < b;) {
            ;
          }

          x--;
        }

        for (w = a[b] = [], h = s ? Math.min(x, b) * u - .5 : r % x, d = s ? b * c / x - .5 : r / x | 0, v = 0, y = D, _ = 0; _ < b; _++) {
          p = _ % x - h, g = d - (_ / x | 0), w[_] = m = l ? Math.abs("y" === l ? g : p) : B(p * p + g * g), m > v && (v = m), m < y && (y = m);
        }

        "random" === r && ne(w), w.max = v - y, w.min = y, w.v = b = (parseFloat(e.amount) || parseFloat(e.each) * (x > b ? b - 1 : l ? "y" === l ? b / x : x : Math.max(x, b / x)) || 0) * ("edges" === r ? -1 : 1), w.b = b < 0 ? i - b : i, w.u = Kt(e.amount || e.each) || 0, n = n && b < 0 ? Oe(n) : n;
      }

      return b = (w[t] - w.min) / w.max || 0, xt(w.b + (n ? n(b) : b) * w.v) + w.u;
    };
  },
      ie = function ie(t) {
    var e = t < 1 ? Math.pow(10, (t + "").length - 2) : 1;
    return function (n) {
      return Math.floor(Math.round(parseFloat(n) / t) * t * e) / e + (I(n) ? 0 : Kt(n));
    };
  },
      ae = function ae(t, e) {
    var n,
        r,
        i = U(t);
    return !i && Z(t) && (n = i = t.radius || D, t.values ? (t = ee(t.values), (r = !I(t[0])) && (n *= n)) : t = ie(t.increment)), qt(e, i ? X(t) ? function (e) {
      return r = t(e), Math.abs(r - e) <= n ? r : e;
    } : function (e) {
      for (var i, a, o = parseFloat(r ? e.x : e), s = parseFloat(r ? e.y : 0), l = D, u = 0, c = t.length; c--;) {
        (i = r ? (i = t[c].x - o) * i + (a = t[c].y - s) * a : Math.abs(t[c] - o)) < l && (l = i, u = c);
      }

      return u = !n || l <= n ? t[u] : e, r || u === e || I(e) ? u : u + Kt(e);
    } : ie(t));
  },
      oe = function oe(t, e, n, r) {
    return qt(U(t) ? !e : !0 === n ? !!(n = 0) : !r, function () {
      return U(t) ? t[~~(Math.random() * t.length)] : (n = n || 1e-5) && (r = n < 1 ? Math.pow(10, (n + "").length - 2) : 1) && Math.floor(Math.round((t + Math.random() * (e - t)) / n) * n * r) / r;
    });
  },
      se = function se(t, e, n) {
    return qt(n, function (n) {
      return t[~~e(n)];
    });
  },
      le = function le(t) {
    for (var e, n, r, i, a = 0, o = ""; ~(e = t.indexOf("random(", a));) {
      r = t.indexOf(")", e), i = "[" === t.charAt(e + 7), n = t.substr(e + 7, r - e - 7).match(i ? tt : G), o += t.substr(a, e - a) + oe(i ? n : +n[0], +n[1], +n[2] || 1e-5), a = r + 1;
    }

    return o + t.substr(a, t.length - a);
  },
      ue = function ue(t, e, n, r, i) {
    var a = e - t,
        o = r - n;
    return qt(i, function (e) {
      return n + ((e - t) / a * o || 0);
    });
  },
      ce = function ce(t, e, n) {
    var r,
        i,
        a,
        o = t.labels,
        s = D;

    for (r in o) {
      (i = o[r] - e) < 0 == !!n && i && s > (i = Math.abs(i)) && (a = r, s = i);
    }

    return a;
  },
      fe = function fe(t, e, n) {
    var r,
        i,
        a = t.vars,
        o = a[e];
    if (o) return r = a[e + "Params"], i = a.callbackScope || t, n && ut.length && Mt(), r ? o.apply(i, r) : o.call(i);
  },
      he = function he(t) {
    return zt(t), t.progress() < 1 && fe(t, "onInterrupt"), t;
  },
      de = function de(t) {
    var e = (t = !t.name && t["default"] || t).name,
        n = X(t),
        r = e && !n && t.init ? function () {
      this._props = [];
    } : t,
        i = {
      init: st,
      render: en,
      add: Xe,
      kill: rn,
      modifier: nn,
      rawVars: 0
    },
        a = {
      targetTest: 0,
      get: 0,
      getSetter: Ke,
      aliases: {},
      register: 0
    };

    if (Me(), t !== r) {
      if (ft[e]) return;
      kt(r, kt(Et(t, i), a)), Pt(r.prototype, Pt(i, Et(t, a))), ft[r.prop = e] = r, t.targetTest && (pt.push(r), lt[e] = 1), e = ("css" === e ? "CSS" : e.charAt(0).toUpperCase() + e.substr(1)) + "Plugin";
    }

    ot(e, r), t.register && t.register(fn, r, sn);
  },
      pe = {
    aqua: [0, 255, 255],
    lime: [0, 255, 0],
    silver: [192, 192, 192],
    black: [0, 0, 0],
    maroon: [128, 0, 0],
    teal: [0, 128, 128],
    blue: [0, 0, 255],
    navy: [0, 0, 128],
    white: [255, 255, 255],
    olive: [128, 128, 0],
    yellow: [255, 255, 0],
    orange: [255, 165, 0],
    gray: [128, 128, 128],
    purple: [128, 0, 128],
    green: [0, 128, 0],
    red: [255, 0, 0],
    pink: [255, 192, 203],
    cyan: [0, 255, 255],
    transparent: [255, 255, 255, 0]
  },
      ge = function ge(t, e, n) {
    return 255 * (6 * (t = t < 0 ? t + 1 : t > 1 ? t - 1 : t) < 1 ? e + (n - e) * t * 6 : t < .5 ? n : 3 * t < 2 ? e + (n - e) * (2 / 3 - t) * 6 : e) + .5 | 0;
  },
      me = function me(t, e, n) {
    var r,
        i,
        a,
        o,
        s,
        l,
        u,
        c,
        f,
        h,
        d = t ? I(t) ? [t >> 16, t >> 8 & 255, 255 & t] : 0 : pe.black;

    if (!d) {
      if ("," === t.substr(-1) && (t = t.substr(0, t.length - 1)), pe[t]) d = pe[t];else if ("#" === t.charAt(0)) 4 === t.length && (r = t.charAt(1), i = t.charAt(2), a = t.charAt(3), t = "#" + r + r + i + i + a + a), d = [(t = parseInt(t.substr(1), 16)) >> 16, t >> 8 & 255, 255 & t];else if ("hsl" === t.substr(0, 3)) {
        if (d = h = t.match(G), e) {
          if (~t.indexOf("=")) return d = t.match(q), n && d.length < 4 && (d[3] = 1), d;
        } else o = +d[0] % 360 / 360, s = +d[1] / 100, r = 2 * (l = +d[2] / 100) - (i = l <= .5 ? l * (s + 1) : l + s - l * s), d.length > 3 && (d[3] *= 1), d[0] = ge(o + 1 / 3, r, i), d[1] = ge(o, r, i), d[2] = ge(o - 1 / 3, r, i);
      } else d = t.match(G) || pe.transparent;
      d = d.map(Number);
    }

    return e && !h && (r = d[0] / 255, i = d[1] / 255, a = d[2] / 255, l = ((u = Math.max(r, i, a)) + (c = Math.min(r, i, a))) / 2, u === c ? o = s = 0 : (f = u - c, s = l > .5 ? f / (2 - u - c) : f / (u + c), o = u === r ? (i - a) / f + (i < a ? 6 : 0) : u === i ? (a - r) / f + 2 : (r - i) / f + 4, o *= 60), d[0] = ~~(o + .5), d[1] = ~~(100 * s + .5), d[2] = ~~(100 * l + .5)), n && d.length < 4 && (d[3] = 1), d;
  },
      _e = function _e(t) {
    var e = [],
        n = [],
        r = -1;
    return t.split(ye).forEach(function (t) {
      var i = t.match(Q) || [];
      e.push.apply(e, i), n.push(r += i.length + 1);
    }), e.c = n, e;
  },
      ve = function ve(t, e, n) {
    var r,
        i,
        a,
        o,
        s = "",
        l = (t + s).match(ye),
        u = e ? "hsla(" : "rgba(",
        c = 0;
    if (!l) return t;
    if (l = l.map(function (t) {
      return (t = me(t, e, 1)) && u + (e ? t[0] + "," + t[1] + "%," + t[2] + "%," + t[3] : t.join(",")) + ")";
    }), n && (a = _e(t), (r = n.c).join(s) !== a.c.join(s))) for (o = (i = t.replace(ye, "1").split(Q)).length - 1; c < o; c++) {
      s += i[c] + (~r.indexOf(c) ? l.shift() || u + "0,0,0,0)" : (a.length ? a : l.length ? l : n).shift());
    }
    if (!i) for (o = (i = t.split(ye)).length - 1; c < o; c++) {
      s += i[c] + l[c];
    }
    return s + i[o];
  },
      ye = function () {
    var t,
        e = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b";

    for (t in pe) {
      e += "|" + t + "\\b";
    }

    return new RegExp(e + ")", "gi");
  }(),
      xe = /hsl[a]?\(/,
      be = function be(t) {
    var e,
        n = t.join(" ");
    if (ye.lastIndex = 0, ye.test(n)) return e = xe.test(n), t[1] = ve(t[1], e), t[0] = ve(t[0], e, _e(t[1])), !0;
  },
      we = (_ = Date.now, v = 500, y = 33, x = _(), b = x, M = w = 1 / 240, S = function t(e) {
    var n,
        r,
        i = _() - b,
        a = !0 === e;
    i > v && (x += i - y), b += i, m.time = (b - x) / 1e3, ((n = m.time - M) > 0 || a) && (m.frame++, M += n + (n >= w ? .004 : w - n), r = 1), a || (d = p(t)), r && T.forEach(function (t) {
      return t(m.time, i, m.frame, e);
    });
  }, m = {
    time: 0,
    frame: 0,
    tick: function tick() {
      S(!0);
    },
    wake: function wake() {
      u && (!s && H() && (o = s = window, l = o.document || {}, et.gsap = fn, (o.gsapVersions || (o.gsapVersions = [])).push(fn.version), rt(nt || o.GreenSockGlobals || !o.gsap && o || {}), g = o.requestAnimationFrame), d && m.sleep(), p = g || function (t) {
        return setTimeout(t, 1e3 * (M - m.time) + 1 | 0);
      }, h = 1, S(2));
    },
    sleep: function sleep() {
      (g ? o.cancelAnimationFrame : clearTimeout)(d), h = 0, p = st;
    },
    lagSmoothing: function lagSmoothing(t, e) {
      v = t || 1 / 1e-8, y = Math.min(e, v, 0);
    },
    fps: function fps(t) {
      w = 1 / (t || 240), M = m.time + w;
    },
    add: function add(t) {
      T.indexOf(t) < 0 && T.push(t), Me();
    },
    remove: function remove(t) {
      var e;
      ~(e = T.indexOf(t)) && T.splice(e, 1);
    },
    _listeners: T = []
  }),
      Me = function Me() {
    return !h && we.wake();
  },
      Te = {},
      Se = /^[\d.\-M][\d.\-,\s]/,
      Ce = /["']/g,
      ke = function ke(t) {
    for (var e, n, r, i = {}, a = t.substr(1, t.length - 3).split(":"), o = a[0], s = 1, l = a.length; s < l; s++) {
      n = a[s], e = s !== l - 1 ? n.lastIndexOf(",") : n.length, r = n.substr(0, e), i[o] = isNaN(r) ? r.replace(Ce, "").trim() : +r, o = n.substr(e + 1).trim();
    }

    return i;
  },
      Oe = function Oe(t) {
    return function (e) {
      return 1 - t(1 - e);
    };
  },
      Pe = function t(e, n) {
    for (var r, i = e._first; i;) {
      i instanceof Re ? t(i, n) : !i.vars.yoyoEase || i._yoyo && i._repeat || i._yoyo === n || (i.timeline ? t(i.timeline, n) : (r = i._ease, i._ease = i._yEase, i._yEase = r, i._yoyo = n)), i = i._next;
    }
  },
      Ae = function Ae(t, e) {
    return t && (X(t) ? t : Te[t] || function (t) {
      var e = (t + "").split("("),
          n = Te[e[0]];
      return n && e.length > 1 && n.config ? n.config.apply(null, ~t.indexOf("{") ? [ke(e[1])] : $.exec(t)[1].split(",").map(St)) : Te._CE && Se.test(t) ? Te._CE("", t) : n;
    }(t)) || e;
  },
      Ee = function Ee(t, e, n, r) {
    void 0 === n && (n = function n(t) {
      return 1 - e(1 - t);
    }), void 0 === r && (r = function r(t) {
      return t < .5 ? e(2 * t) / 2 : 1 - e(2 * (1 - t)) / 2;
    });
    var i,
        a = {
      easeIn: e,
      easeOut: n,
      easeInOut: r
    };
    return yt(t, function (t) {
      for (var e in Te[t] = et[t] = a, Te[i = t.toLowerCase()] = n, a) {
        Te[i + ("easeIn" === e ? ".in" : "easeOut" === e ? ".out" : ".inOut")] = Te[t + "." + e] = a[e];
      }
    }), a;
  },
      De = function De(t) {
    return function (e) {
      return e < .5 ? (1 - t(1 - 2 * e)) / 2 : .5 + t(2 * (e - .5)) / 2;
    };
  },
      Le = function t(e, n, r) {
    var i = n >= 1 ? n : 1,
        a = (r || (e ? .3 : .45)) / (n < 1 ? n : 1),
        o = a / L * (Math.asin(1 / i) || 0),
        s = function s(t) {
      return 1 === t ? 1 : i * Math.pow(2, -10 * t) * F((t - o) * a) + 1;
    },
        l = "out" === e ? s : "in" === e ? function (t) {
      return 1 - s(1 - t);
    } : De(s);

    return a = L / a, l.config = function (n, r) {
      return t(e, n, r);
    }, l;
  },
      ze = function t(e, n) {
    void 0 === n && (n = 1.70158);

    var r = function r(t) {
      return t ? --t * t * ((n + 1) * t + n) + 1 : 0;
    },
        i = "out" === e ? r : "in" === e ? function (t) {
      return 1 - r(1 - t);
    } : De(r);

    return i.config = function (n) {
      return t(e, n);
    }, i;
  };

  yt("Linear,Quad,Cubic,Quart,Quint,Strong", function (t, e) {
    var n = e < 5 ? e + 1 : e;
    Ee(t + ",Power" + (n - 1), e ? function (t) {
      return Math.pow(t, n);
    } : function (t) {
      return t;
    }, function (t) {
      return 1 - Math.pow(1 - t, n);
    }, function (t) {
      return t < .5 ? Math.pow(2 * t, n) / 2 : 1 - Math.pow(2 * (1 - t), n) / 2;
    });
  }), Te.Linear.easeNone = Te.none = Te.Linear.easeIn, Ee("Elastic", Le("in"), Le("out"), Le()), C = 7.5625, O = 1 / (k = 2.75), Ee("Bounce", function (t) {
    return 1 - P(1 - t);
  }, P = function P(t) {
    return t < O ? C * t * t : t < .7272727272727273 ? C * Math.pow(t - 1.5 / k, 2) + .75 : t < .9090909090909092 ? C * (t -= 2.25 / k) * t + .9375 : C * Math.pow(t - 2.625 / k, 2) + .984375;
  }), Ee("Expo", function (t) {
    return t ? Math.pow(2, 10 * (t - 1)) : 0;
  }), Ee("Circ", function (t) {
    return -(B(1 - t * t) - 1);
  }), Ee("Sine", function (t) {
    return 1 === t ? 1 : 1 - R(t * z);
  }), Ee("Back", ze("in"), ze("out"), ze()), Te.SteppedEase = Te.steps = et.SteppedEase = {
    config: function config(t, e) {
      void 0 === t && (t = 1);
      var n = 1 / t,
          r = t + (e ? 0 : 1),
          i = e ? 1 : 0;
      return function (t) {
        return ((r * Qt(0, 1 - 1e-8, t) | 0) + i) * n;
      };
    }
  }, E.ease = Te["quad.out"], yt("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function (t) {
    return gt += t + "," + t + "Params,";
  });

  var Ne = function Ne(t, e) {
    this.id = N++, t._gsap = this, this.target = t, this.harness = e, this.get = e ? e.get : vt, this.set = e ? e.getSetter : Ke;
  },
      Be = function () {
    function t(t, e) {
      var n = t.parent || a;
      this.vars = t, this._delay = +t.delay || 0, (this._repeat = t.repeat || 0) && (this._rDelay = t.repeatDelay || 0, this._yoyo = !!t.yoyo || !!t.yoyoEase), this._ts = 1, Ht(this, +t.duration, 1), this.data = t.data, h || we.wake(), n && jt(n, this, e || 0 === e ? e : n._time, 1), t.reversed && this.reverse(), t.paused && this.paused(!0);
    }

    var e = t.prototype;
    return e.delay = function (t) {
      return t || 0 === t ? (this.parent && this.parent.smoothChildTiming && this.startTime(this._start + t - this._delay), this._delay = t, this) : this._delay;
    }, e.duration = function (t) {
      return arguments.length ? this.totalDuration(this._repeat > 0 ? t + (t + this._rDelay) * this._repeat : t) : this.totalDuration() && this._dur;
    }, e.totalDuration = function (t) {
      return arguments.length ? (this._dirty = 0, Ht(this, this._repeat < 0 ? t : (t - this._repeat * this._rDelay) / (this._repeat + 1))) : this._tDur;
    }, e.totalTime = function (t, e) {
      if (Me(), !arguments.length) return this._tTime;
      var n = this.parent || this._dp;

      if (n && n.smoothChildTiming && this._ts) {
        for (this._start = xt(n._time - (this._ts > 0 ? t / this._ts : ((this._dirty ? this.totalDuration() : this._tDur) - t) / -this._ts)), Xt(this), n._dirty || Nt(n); n.parent;) {
          n.parent._time !== n._start + (n._ts >= 0 ? n._tTime / n._ts : (n.totalDuration() - n._tTime) / -n._ts) && n.totalTime(n._tTime, !0), n = n.parent;
        }

        !this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && t < this._tDur || this._ts < 0 && t > 0 || !this._tDur && !t) && jt(this._dp, this, this._start - this._delay);
      }

      return (this._tTime !== t || !this._dur && !e || this._initted && 1e-8 === Math.abs(this._zTime) || !t && !this._initted) && (this._ts || (this._pTime = t), Tt(this, t, e)), this;
    }, e.time = function (t, e) {
      return arguments.length ? this.totalTime(Math.min(this.totalDuration(), t + Rt(this)) % this._dur || (t ? this._dur : 0), e) : this._time;
    }, e.totalProgress = function (t, e) {
      return arguments.length ? this.totalTime(this.totalDuration() * t, e) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
    }, e.progress = function (t, e) {
      return arguments.length ? this.totalTime(this.duration() * (!this._yoyo || 1 & this.iteration() ? t : 1 - t) + Rt(this), e) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
    }, e.iteration = function (t, e) {
      var n = this.duration() + this._rDelay;

      return arguments.length ? this.totalTime(this._time + (t - 1) * n, e) : this._repeat ? Ft(this._tTime, n) + 1 : 1;
    }, e.timeScale = function (t) {
      if (!arguments.length) return -1e-8 === this._rts ? 0 : this._rts;
      if (this._rts === t) return this;
      var e = this.parent && this._ts ? Yt(this.parent._time, this) : this._tTime;
      return this._rts = +t || 0, this._ts = this._ps || -1e-8 === t ? 0 : this._rts, Bt(this.totalTime(Qt(0, this._tDur, e), !0));
    }, e.paused = function (t) {
      return arguments.length ? (this._ps !== t && (this._ps = t, t ? (this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()), this._ts = this._act = 0) : (Me(), this._ts = this._rts, this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, 1 === this.progress() && (this._tTime -= 1e-8) && 1e-8 !== Math.abs(this._zTime)))), this) : this._ps;
    }, e.startTime = function (t) {
      if (arguments.length) {
        this._start = t;
        var e = this.parent || this._dp;
        return e && (e._sort || !this.parent) && jt(e, this, t - this._delay), this;
      }

      return this._start;
    }, e.endTime = function (t) {
      return this._start + (W(t) ? this.totalDuration() : this.duration()) / Math.abs(this._ts);
    }, e.rawTime = function (t) {
      var e = this.parent || this._dp;
      return e ? t && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : this._ts ? Yt(e.rawTime(t), this) : this._tTime : this._tTime;
    }, e.repeat = function (t) {
      return arguments.length ? (this._repeat = t, Vt(this)) : this._repeat;
    }, e.repeatDelay = function (t) {
      return arguments.length ? (this._rDelay = t, Vt(this)) : this._rDelay;
    }, e.yoyo = function (t) {
      return arguments.length ? (this._yoyo = t, this) : this._yoyo;
    }, e.seek = function (t, e) {
      return this.totalTime(Gt(this, t), W(e));
    }, e.restart = function (t, e) {
      return this.play().totalTime(t ? -this._delay : 0, W(e));
    }, e.play = function (t, e) {
      return null != t && this.seek(t, e), this.reversed(!1).paused(!1);
    }, e.reverse = function (t, e) {
      return null != t && this.seek(t || this.totalDuration(), e), this.reversed(!0).paused(!1);
    }, e.pause = function (t, e) {
      return null != t && this.seek(t, e), this.paused(!0);
    }, e.resume = function () {
      return this.paused(!1);
    }, e.reversed = function (t) {
      return arguments.length ? (!!t !== this.reversed() && this.timeScale(-this._rts || (t ? -1e-8 : 0)), this) : this._rts < 0;
    }, e.invalidate = function () {
      return this._initted = 0, this._zTime = -1e-8, this;
    }, e.isActive = function (t) {
      var e,
          n = this.parent || this._dp,
          r = this._start;
      return !(n && !(this._ts && (this._initted || !t) && n.isActive(t) && (e = n.rawTime(!0)) >= r && e < this.endTime(!0) - 1e-8));
    }, e.eventCallback = function (t, e, n) {
      var r = this.vars;
      return arguments.length > 1 ? (e ? (r[t] = e, n && (r[t + "Params"] = n), "onUpdate" === t && (this._onUpdate = e)) : delete r[t], this) : r[t];
    }, e.then = function (t) {
      var e = this;
      return new Promise(function (n) {
        var r = X(t) ? t : Ct,
            i = function i() {
          var t = e.then;
          e.then = null, X(r) && (r = r(e)) && (r.then || r === e) && (e.then = t), n(r), e.then = t;
        };

        e._initted && 1 === e.totalProgress() && e._ts >= 0 || !e._tTime && e._ts < 0 ? i() : e._prom = i;
      });
    }, e.kill = function () {
      he(this);
    }, t;
  }();

  kt(Be.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: !1,
    parent: null,
    _initted: !1,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -1e-8,
    _prom: 0,
    _ps: !1,
    _rts: 1
  });

  var Re = function (t) {
    function e(e, n) {
      var i;
      return void 0 === e && (e = {}), (i = t.call(this, e, n) || this).labels = {}, i.smoothChildTiming = !!e.smoothChildTiming, i.autoRemoveChildren = !!e.autoRemoveChildren, i._sort = W(e.sortChildren), i.parent && It(i.parent, r(i)), e.scrollTrigger && Zt(r(i), e.scrollTrigger), i;
    }

    i(e, t);
    var n = e.prototype;
    return n.to = function (t, e, n) {
      return new Ve(t, wt(arguments, 0, this), Gt(this, I(e) ? arguments[3] : n)), this;
    }, n.from = function (t, e, n) {
      return new Ve(t, wt(arguments, 1, this), Gt(this, I(e) ? arguments[3] : n)), this;
    }, n.fromTo = function (t, e, n, r) {
      return new Ve(t, wt(arguments, 2, this), Gt(this, I(e) ? arguments[4] : r)), this;
    }, n.set = function (t, e, n) {
      return e.duration = 0, e.parent = this, Dt(e).repeatDelay || (e.repeat = 0), e.immediateRender = !!e.immediateRender, new Ve(t, e, Gt(this, n), 1), this;
    }, n.call = function (t, e, n) {
      return jt(this, Ve.delayedCall(0, t, e), Gt(this, n));
    }, n.staggerTo = function (t, e, n, r, i, a, o) {
      return n.duration = e, n.stagger = n.stagger || r, n.onComplete = a, n.onCompleteParams = o, n.parent = this, new Ve(t, n, Gt(this, i)), this;
    }, n.staggerFrom = function (t, e, n, r, i, a, o) {
      return n.runBackwards = 1, Dt(n).immediateRender = W(n.immediateRender), this.staggerTo(t, e, n, r, i, a, o);
    }, n.staggerFromTo = function (t, e, n, r, i, a, o, s) {
      return r.startAt = n, Dt(r).immediateRender = W(r.immediateRender), this.staggerTo(t, e, r, i, a, o, s);
    }, n.render = function (t, e, n) {
      var r,
          i,
          o,
          s,
          l,
          u,
          c,
          f,
          h,
          d,
          p,
          g,
          m = this._time,
          _ = this._dirty ? this.totalDuration() : this._tDur,
          v = this._dur,
          y = this !== a && t > _ - 1e-8 && t >= 0 ? _ : t < 1e-8 ? 0 : t,
          x = this._zTime < 0 != t < 0 && (this._initted || !v);

      if (y !== this._tTime || n || x) {
        if (m !== this._time && v && (y += this._time - m, t += this._time - m), r = y, h = this._start, u = !(f = this._ts), x && (v || (m = this._zTime), (t || !e) && (this._zTime = t)), this._repeat && (p = this._yoyo, l = v + this._rDelay, ((r = xt(y % l)) > v || _ === y) && (r = v), (s = ~~(y / l)) && s === y / l && (r = v, s--), d = Ft(this._tTime, l), !m && this._tTime && d !== s && (d = s), p && 1 & s && (r = v - r, g = 1), s !== d && !this._lock)) {
          var b = p && 1 & d,
              w = b === (p && 1 & s);
          if (s < d && (b = !b), m = b ? 0 : v, this._lock = 1, this.render(m || (g ? 0 : xt(s * l)), e, !v)._lock = 0, !e && this.parent && fe(this, "onRepeat"), this.vars.repeatRefresh && !g && (this.invalidate()._lock = 1), m !== this._time || u !== !this._ts) return this;
          if (w && (this._lock = 2, m = b ? v + 1e-4 : -1e-4, this.render(m, !0), this.vars.repeatRefresh && !g && this.invalidate()), this._lock = 0, !this._ts && !u) return this;
          Pe(this, g);
        }

        if (this._hasPause && !this._forcing && this._lock < 2 && (c = function (t, e, n) {
          var r;
          if (n > e) for (r = t._first; r && r._start <= n;) {
            if (!r._dur && "isPause" === r.data && r._start > e) return r;
            r = r._next;
          } else for (r = t._last; r && r._start >= n;) {
            if (!r._dur && "isPause" === r.data && r._start < e) return r;
            r = r._prev;
          }
        }(this, xt(m), xt(r))) && (y -= r - (r = c._start)), this._tTime = y, this._time = r, this._act = !f, this._initted || (this._onUpdate = this.vars.onUpdate, this._initted = 1, this._zTime = t), m || !r || e || fe(this, "onStart"), r >= m && t >= 0) for (i = this._first; i;) {
          if (o = i._next, (i._act || r >= i._start) && i._ts && c !== i) {
            if (i.parent !== this) return this.render(t, e, n);

            if (i.render(i._ts > 0 ? (r - i._start) * i._ts : (i._dirty ? i.totalDuration() : i._tDur) + (r - i._start) * i._ts, e, n), r !== this._time || !this._ts && !u) {
              c = 0, o && (y += this._zTime = -1e-8);
              break;
            }
          }

          i = o;
        } else {
          i = this._last;

          for (var M = t < 0 ? t : r; i;) {
            if (o = i._prev, (i._act || M <= i._end) && i._ts && c !== i) {
              if (i.parent !== this) return this.render(t, e, n);

              if (i.render(i._ts > 0 ? (M - i._start) * i._ts : (i._dirty ? i.totalDuration() : i._tDur) + (M - i._start) * i._ts, e, n), r !== this._time || !this._ts && !u) {
                c = 0, o && (y += this._zTime = M ? -1e-8 : 1e-8);
                break;
              }
            }

            i = o;
          }
        }
        if (c && !e && (this.pause(), c.render(r >= m ? 0 : -1e-8)._zTime = r >= m ? 1 : -1, this._ts)) return this._start = h, Xt(this), this.render(t, e, n);
        this._onUpdate && !e && fe(this, "onUpdate", !0), (y === _ && _ >= this.totalDuration() || !y && m) && (h !== this._start && Math.abs(f) === Math.abs(this._ts) || this._lock || ((t || !v) && (y === _ && this._ts > 0 || !y && this._ts < 0) && zt(this, 1), e || t < 0 && !m || !y && !m || (fe(this, y === _ ? "onComplete" : "onReverseComplete", !0), this._prom && !(y < _ && this.timeScale() > 0) && this._prom())));
      }

      return this;
    }, n.add = function (t, e) {
      var n = this;

      if (I(e) || (e = Gt(this, e)), !(t instanceof Be)) {
        if (U(t)) return t.forEach(function (t) {
          return n.add(t, e);
        }), Nt(this);
        if (Y(t)) return this.addLabel(t, e);
        if (!X(t)) return this;
        t = Ve.delayedCall(0, t);
      }

      return this !== t ? jt(this, t, e) : this;
    }, n.getChildren = function (t, e, n, r) {
      void 0 === t && (t = !0), void 0 === e && (e = !0), void 0 === n && (n = !0), void 0 === r && (r = -D);

      for (var i = [], a = this._first; a;) {
        a._start >= r && (a instanceof Ve ? e && i.push(a) : (n && i.push(a), t && i.push.apply(i, a.getChildren(!0, e, n)))), a = a._next;
      }

      return i;
    }, n.getById = function (t) {
      for (var e = this.getChildren(1, 1, 1), n = e.length; n--;) {
        if (e[n].vars.id === t) return e[n];
      }
    }, n.remove = function (t) {
      return Y(t) ? this.removeLabel(t) : X(t) ? this.killTweensOf(t) : (Lt(this, t), t === this._recent && (this._recent = this._last), Nt(this));
    }, n.totalTime = function (e, n) {
      return arguments.length ? (this._forcing = 1, this.parent || this._dp || !this._ts || (this._start = xt(we.time - (this._ts > 0 ? e / this._ts : (this.totalDuration() - e) / -this._ts))), t.prototype.totalTime.call(this, e, n), this._forcing = 0, this) : this._tTime;
    }, n.addLabel = function (t, e) {
      return this.labels[t] = Gt(this, e), this;
    }, n.removeLabel = function (t) {
      return delete this.labels[t], this;
    }, n.addPause = function (t, e, n) {
      var r = Ve.delayedCall(0, e || st, n);
      return r.data = "isPause", this._hasPause = 1, jt(this, r, Gt(this, t));
    }, n.removePause = function (t) {
      var e = this._first;

      for (t = Gt(this, t); e;) {
        e._start === t && "isPause" === e.data && zt(e), e = e._next;
      }
    }, n.killTweensOf = function (t, e, n) {
      for (var r = this.getTweensOf(t, n), i = r.length; i--;) {
        Fe !== r[i] && r[i].kill(t, e);
      }

      return this;
    }, n.getTweensOf = function (t, e) {
      for (var n, r = [], i = ee(t), a = this._first; a;) {
        a instanceof Ve ? !bt(a._targets, i) || e && !a.isActive("started" === e) || r.push(a) : (n = a.getTweensOf(i, e)).length && r.push.apply(r, n), a = a._next;
      }

      return r;
    }, n.tweenTo = function (t, e) {
      e = e || {};
      var n = this,
          r = Gt(n, t),
          i = e,
          a = i.startAt,
          o = i.onStart,
          s = i.onStartParams,
          l = Ve.to(n, kt(e, {
        ease: "none",
        lazy: !1,
        time: r,
        duration: e.duration || Math.abs((r - (a && "time" in a ? a.time : n._time)) / n.timeScale()) || 1e-8,
        onStart: function onStart() {
          n.pause();
          var t = e.duration || Math.abs((r - n._time) / n.timeScale());
          l._dur !== t && Ht(l, t).render(l._time, !0, !0), o && o.apply(l, s || []);
        }
      }));
      return l;
    }, n.tweenFromTo = function (t, e, n) {
      return this.tweenTo(e, kt({
        startAt: {
          time: Gt(this, t)
        }
      }, n));
    }, n.recent = function () {
      return this._recent;
    }, n.nextLabel = function (t) {
      return void 0 === t && (t = this._time), ce(this, Gt(this, t));
    }, n.previousLabel = function (t) {
      return void 0 === t && (t = this._time), ce(this, Gt(this, t), 1);
    }, n.currentLabel = function (t) {
      return arguments.length ? this.seek(t, !0) : this.previousLabel(this._time + 1e-8);
    }, n.shiftChildren = function (t, e, n) {
      void 0 === n && (n = 0);

      for (var r, i = this._first, a = this.labels; i;) {
        i._start >= n && (i._start += t), i = i._next;
      }

      if (e) for (r in a) {
        a[r] >= n && (a[r] += t);
      }
      return Nt(this);
    }, n.invalidate = function () {
      var e = this._first;

      for (this._lock = 0; e;) {
        e.invalidate(), e = e._next;
      }

      return t.prototype.invalidate.call(this);
    }, n.clear = function (t) {
      void 0 === t && (t = !0);

      for (var e, n = this._first; n;) {
        e = n._next, this.remove(n), n = e;
      }

      return this._time = this._tTime = this._pTime = 0, t && (this.labels = {}), Nt(this);
    }, n.totalDuration = function (t) {
      var e,
          n,
          r,
          i,
          o = 0,
          s = this,
          l = s._last,
          u = D;
      if (arguments.length) return s.timeScale((s._repeat < 0 ? s.duration() : s.totalDuration()) / (s.reversed() ? -t : t));

      if (s._dirty) {
        for (i = s.parent; l;) {
          e = l._prev, l._dirty && l.totalDuration(), (r = l._start) > u && s._sort && l._ts && !s._lock ? (s._lock = 1, jt(s, l, r - l._delay, 1)._lock = 0) : u = r, r < 0 && l._ts && (o -= r, (!i && !s._dp || i && i.smoothChildTiming) && (s._start += r / s._ts, s._time -= r, s._tTime -= r), s.shiftChildren(-r, !1, -Infinity), u = 0), (n = Xt(l)) > o && l._ts && (o = n), l = e;
        }

        Ht(s, s === a && s._time > o ? s._time : o, 1), s._dirty = 0;
      }

      return s._tDur;
    }, e.updateRoot = function (t) {
      if (a._ts && (Tt(a, Yt(t, a)), c = we.frame), we.frame >= dt) {
        dt += A.autoSleep || 120;
        var e = a._first;

        if ((!e || !e._ts) && A.autoSleep && we._listeners.length < 2) {
          for (; e && !e._ts;) {
            e = e._next;
          }

          e || we.sleep();
        }
      }
    }, e;
  }(Be);

  kt(Re.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
  });

  var Fe,
      Ye = function Ye(t, e, n, r, i, a, o) {
    var s,
        l,
        u,
        c,
        f,
        h,
        d,
        p,
        g = new sn(this._pt, t, e, 0, 1, tn, null, i),
        m = 0,
        _ = 0;

    for (g.b = n, g.e = r, n += "", (d = ~(r += "").indexOf("random(")) && (r = le(r)), a && (a(p = [n, r], t, e), n = p[0], r = p[1]), l = n.match(K) || []; s = K.exec(r);) {
      c = s[0], f = r.substring(m, s.index), u ? u = (u + 1) % 5 : "rgba(" === f.substr(-5) && (u = 1), c !== l[_++] && (h = parseFloat(l[_ - 1]) || 0, g._pt = {
        _next: g._pt,
        p: f || 1 === _ ? f : ",",
        s: h,
        c: "=" === c.charAt(1) ? parseFloat(c.substr(2)) * ("-" === c.charAt(0) ? -1 : 1) : parseFloat(c) - h,
        m: u && u < 4 ? Math.round : 0
      }, m = K.lastIndex);
    }

    return g.c = m < r.length ? r.substring(m, r.length) : "", g.fp = o, (J.test(r) || d) && (g.e = 0), this._pt = g, g;
  },
      Xe = function Xe(t, e, n, r, i, a, o, s, l) {
    X(r) && (r = r(i || 0, t, a));
    var u,
        c = t[e],
        f = "get" !== n ? n : X(c) ? l ? t[e.indexOf("set") || !X(t["get" + e.substr(3)]) ? e : "get" + e.substr(3)](l) : t[e]() : c,
        h = X(c) ? l ? qe : Ge : Ue;
    if (Y(r) && (~r.indexOf("random(") && (r = le(r)), "=" === r.charAt(1) && (r = parseFloat(f) + parseFloat(r.substr(2)) * ("-" === r.charAt(0) ? -1 : 1) + (Kt(f) || 0))), f !== r) return isNaN(f + r) ? (!c && !(e in t) && it(e, r), Ye.call(this, t, e, f, r, h, s || A.stringFilter, l)) : (u = new sn(this._pt, t, e, +f || 0, r - (f || 0), "boolean" == typeof c ? Je : $e, 0, h), l && (u.fp = l), o && u.modifier(o, this, t), this._pt = u);
  },
      Ie = function Ie(t, e, n, r, i, a) {
    var o, s, l, u;
    if (ft[t] && !1 !== (o = new ft[t]()).init(i, o.rawVars ? e[t] : function (t, e, n, r, i) {
      if (X(t) && (t = Ze(t, i, e, n, r)), !Z(t) || t.style && t.nodeType || U(t)) return Y(t) ? Ze(t, i, e, n, r) : t;
      var a,
          o = {};

      for (a in t) {
        o[a] = Ze(t[a], i, e, n, r);
      }

      return o;
    }(e[t], r, i, a, n), n, r, a) && (n._pt = s = new sn(n._pt, i, t, 0, 1, o.render, o, 0, o.priority), n !== f)) for (l = n._ptLookup[n._targets.indexOf(i)], u = o._props.length; u--;) {
      l[o._props[u]] = s;
    }
    return o;
  },
      je = function t(e, n) {
    var r,
        i,
        o,
        s,
        l,
        u,
        c,
        f,
        h,
        d,
        p,
        g,
        m = e.vars,
        _ = m.ease,
        v = m.startAt,
        y = m.immediateRender,
        x = m.lazy,
        b = m.onUpdate,
        w = m.onUpdateParams,
        M = m.callbackScope,
        T = m.runBackwards,
        S = m.yoyoEase,
        C = m.keyframes,
        k = m.autoRevert,
        O = e._dur,
        P = e._startAt,
        A = e._targets,
        D = e.parent,
        L = D && "nested" === D.data ? D.parent._targets : A,
        z = "auto" === e._overwrite,
        N = e.timeline;

    if (N && (!C || !_) && (_ = "none"), e._ease = Ae(_, E.ease), e._yEase = S ? Oe(Ae(!0 === S ? _ : S, E.ease)) : 0, S && e._yoyo && !e._repeat && (S = e._yEase, e._yEase = e._ease, e._ease = S), !N) {
      if (g = (f = A[0] ? _t(A[0]).harness : 0) && m[f.prop], r = Et(m, lt), P && P.render(-1, !0).kill(), v) {
        if (zt(e._startAt = Ve.set(A, kt({
          data: "isStart",
          overwrite: !1,
          parent: D,
          immediateRender: !0,
          lazy: W(x),
          startAt: null,
          delay: 0,
          onUpdate: b,
          onUpdateParams: w,
          callbackScope: M,
          stagger: 0
        }, v))), y) if (n > 0) !k && (e._startAt = 0);else if (O) return;
      } else if (T && O) if (P) !k && (e._startAt = 0);else if (n && (y = !1), o = kt({
        overwrite: !1,
        data: "isFromStart",
        lazy: y && W(x),
        immediateRender: y,
        stagger: 0,
        parent: D
      }, r), g && (o[f.prop] = g), zt(e._startAt = Ve.set(A, o)), y) {
        if (!n) return;
      } else t(e._startAt, 1e-8);

      for (e._pt = 0, x = O && W(x) || x && !O, i = 0; i < A.length; i++) {
        if (c = (l = A[i])._gsap || mt(A)[i]._gsap, e._ptLookup[i] = d = {}, ct[c.id] && Mt(), p = L === A ? i : L.indexOf(l), f && !1 !== (h = new f()).init(l, g || r, e, p, L) && (e._pt = s = new sn(e._pt, l, h.name, 0, 1, h.render, h, 0, h.priority), h._props.forEach(function (t) {
          d[t] = s;
        }), h.priority && (u = 1)), !f || g) for (o in r) {
          ft[o] && (h = Ie(o, r, e, p, l, L)) ? h.priority && (u = 1) : d[o] = s = Xe.call(e, l, o, "get", r[o], p, L, 0, m.stringFilter);
        }
        e._op && e._op[i] && e.kill(l, e._op[i]), z && e._pt && (Fe = e, a.killTweensOf(l, d, "started"), Fe = 0), e._pt && x && (ct[c.id] = 1);
      }

      u && on(e), e._onInit && e._onInit(e);
    }

    e._from = !N && !!m.runBackwards, e._onUpdate = b, e._initted = !!e.parent;
  },
      Ze = function Ze(t, e, n, r, i) {
    return X(t) ? t.call(e, n, r, i) : Y(t) && ~t.indexOf("random(") ? le(t) : t;
  },
      We = gt + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase",
      He = (We + ",id,stagger,delay,duration,paused,scrollTrigger").split(","),
      Ve = function (t) {
    function e(e, n, i, o) {
      var s;
      "number" == typeof n && (i.duration = n, n = i, i = null);
      var l,
          u,
          c,
          f,
          h,
          d,
          p,
          g,
          m = (s = t.call(this, o ? n : Dt(n), i) || this).vars,
          _ = m.duration,
          v = m.delay,
          y = m.immediateRender,
          x = m.stagger,
          b = m.overwrite,
          w = m.keyframes,
          M = m.defaults,
          T = m.scrollTrigger,
          S = m.yoyoEase,
          C = s.parent,
          k = (U(e) ? I(e[0]) : "length" in n) ? [e] : ee(e);

      if (s._targets = k.length ? mt(k) : at("GSAP target " + e + " not found. https://greensock.com", !A.nullTargetWarn) || [], s._ptLookup = [], s._overwrite = b, w || x || V(_) || V(v)) {
        if (n = s.vars, (l = s.timeline = new Re({
          data: "nested",
          defaults: M || {}
        })).kill(), l.parent = r(s), w) kt(l.vars.defaults, {
          ease: "none"
        }), w.forEach(function (t) {
          return l.to(k, t, ">");
        });else {
          if (f = k.length, p = x ? re(x) : st, Z(x)) for (h in x) {
            ~We.indexOf(h) && (g || (g = {}), g[h] = x[h]);
          }

          for (u = 0; u < f; u++) {
            for (h in c = {}, n) {
              He.indexOf(h) < 0 && (c[h] = n[h]);
            }

            c.stagger = 0, S && (c.yoyoEase = S), g && Pt(c, g), d = k[u], c.duration = +Ze(_, r(s), u, d, k), c.delay = (+Ze(v, r(s), u, d, k) || 0) - s._delay, !x && 1 === f && c.delay && (s._delay = v = c.delay, s._start += v, c.delay = 0), l.to(d, c, p(u, d, k));
          }

          l.duration() ? _ = v = 0 : s.timeline = 0;
        }
        _ || s.duration(_ = l.duration());
      } else s.timeline = 0;

      return !0 === b && (Fe = r(s), a.killTweensOf(k), Fe = 0), C && It(C, r(s)), (y || !_ && !w && s._start === xt(C._time) && W(y) && function t(e) {
        return !e || e._ts && t(e.parent);
      }(r(s)) && "nested" !== C.data) && (s._tTime = -1e-8, s.render(Math.max(0, -v))), T && Zt(r(s), T), s;
    }

    i(e, t);
    var n = e.prototype;
    return n.render = function (t, e, n) {
      var r,
          i,
          a,
          o,
          s,
          l,
          u,
          c,
          f,
          h = this._time,
          d = this._tDur,
          p = this._dur,
          g = t > d - 1e-8 && t >= 0 ? d : t < 1e-8 ? 0 : t;

      if (p) {
        if (g !== this._tTime || !t || n || this._startAt && this._zTime < 0 != t < 0) {
          if (r = g, c = this.timeline, this._repeat) {
            if (o = p + this._rDelay, ((r = xt(g % o)) > p || d === g) && (r = p), (a = ~~(g / o)) && a === g / o && (r = p, a--), (l = this._yoyo && 1 & a) && (f = this._yEase, r = p - r), s = Ft(this._tTime, o), r === h && !n && this._initted) return this;
            a !== s && (c && this._yEase && Pe(c, l), !this.vars.repeatRefresh || l || this._lock || (this._lock = n = 1, this.render(xt(o * a), !0).invalidate()._lock = 0));
          }

          if (!this._initted) {
            if (Wt(this, r, n, e)) return this._tTime = 0, this;
            if (p !== this._dur) return this.render(t, e, n);
          }

          for (this._tTime = g, this._time = r, !this._act && this._ts && (this._act = 1, this._lazy = 0), this.ratio = u = (f || this._ease)(r / p), this._from && (this.ratio = u = 1 - u), r && !h && !e && fe(this, "onStart"), i = this._pt; i;) {
            i.r(u, i.d), i = i._next;
          }

          c && c.render(t < 0 ? t : !r && l ? -1e-8 : c._dur * u, e, n) || this._startAt && (this._zTime = t), this._onUpdate && !e && (t < 0 && this._startAt && this._startAt.render(t, !0, n), fe(this, "onUpdate")), this._repeat && a !== s && this.vars.onRepeat && !e && this.parent && fe(this, "onRepeat"), g !== this._tDur && g || this._tTime !== g || (t < 0 && this._startAt && !this._onUpdate && this._startAt.render(t, !0, !0), (t || !p) && (g === this._tDur && this._ts > 0 || !g && this._ts < 0) && zt(this, 1), e || t < 0 && !h || !g && !h || (fe(this, g === d ? "onComplete" : "onReverseComplete", !0), this._prom && !(g < d && this.timeScale() > 0) && this._prom()));
        }
      } else !function (t, e, n, r) {
        var i,
            a,
            o = t.ratio,
            s = e < 0 || !e && o && !t._start && t._zTime > 1e-8 && !t._dp._lock || t._ts < 0 || t._dp._ts < 0 ? 0 : 1,
            l = t._rDelay,
            u = 0;
        if (l && t._repeat && (u = Qt(0, t._tDur, e), Ft(u, l) !== (a = Ft(t._tTime, l)) && (o = 1 - s, t.vars.repeatRefresh && t._initted && t.invalidate())), t._initted || !Wt(t, e, r, n)) if (s !== o || r || 1e-8 === t._zTime || !e && t._zTime) {
          for (a = t._zTime, t._zTime = e || (n ? 1e-8 : 0), n || (n = e && !a), t.ratio = s, t._from && (s = 1 - s), t._time = 0, t._tTime = u, n || fe(t, "onStart"), i = t._pt; i;) {
            i.r(s, i.d), i = i._next;
          }

          t._startAt && e < 0 && t._startAt.render(e, !0, !0), t._onUpdate && !n && fe(t, "onUpdate"), u && t._repeat && !n && t.parent && fe(t, "onRepeat"), (e >= t._tDur || e < 0) && t.ratio === s && (s && zt(t, 1), n || (fe(t, s ? "onComplete" : "onReverseComplete", !0), t._prom && t._prom()));
        } else t._zTime || (t._zTime = e);
      }(this, t, e, n);

      return this;
    }, n.targets = function () {
      return this._targets;
    }, n.invalidate = function () {
      return this._pt = this._op = this._startAt = this._onUpdate = this._act = this._lazy = 0, this._ptLookup = [], this.timeline && this.timeline.invalidate(), t.prototype.invalidate.call(this);
    }, n.kill = function (t, e) {
      if (void 0 === e && (e = "all"), !(t || e && "all" !== e) && (this._lazy = 0, this.parent)) return he(this);

      if (this.timeline) {
        var n = this.timeline.totalDuration();
        return this.timeline.killTweensOf(t, e, Fe && !0 !== Fe.vars.overwrite)._first || he(this), this.parent && n !== this.timeline.totalDuration() && Ht(this, this._dur * this.timeline._tDur / n), this;
      }

      var r,
          i,
          a,
          o,
          s,
          l,
          u,
          c = this._targets,
          f = t ? ee(t) : c,
          h = this._ptLookup,
          d = this._pt;
      if ((!e || "all" === e) && function (t, e) {
        for (var n = t.length, r = n === e.length; r && n-- && t[n] === e[n];) {
          ;
        }

        return n < 0;
      }(c, f)) return he(this);

      for (r = this._op = this._op || [], "all" !== e && (Y(e) && (s = {}, yt(e, function (t) {
        return s[t] = 1;
      }), e = s), e = function (t, e) {
        var n,
            r,
            i,
            a,
            o = t[0] ? _t(t[0]).harness : 0,
            s = o && o.aliases;
        if (!s) return e;

        for (r in n = Pt({}, e), s) {
          if ((r in n)) for (i = (a = s[r].split(",")).length; i--;) {
            n[a[i]] = n[r];
          }
        }

        return n;
      }(c, e)), u = c.length; u--;) {
        if (~f.indexOf(c[u])) for (s in i = h[u], "all" === e ? (r[u] = e, o = i, a = {}) : (a = r[u] = r[u] || {}, o = e), o) {
          (l = i && i[s]) && ("kill" in l.d && !0 !== l.d.kill(s) || Lt(this, l, "_pt"), delete i[s]), "all" !== a && (a[s] = 1);
        }
      }

      return this._initted && !this._pt && d && he(this), this;
    }, e.to = function (t, n) {
      return new e(t, n, arguments[2]);
    }, e.from = function (t, n) {
      return new e(t, wt(arguments, 1));
    }, e.delayedCall = function (t, n, r, i) {
      return new e(n, 0, {
        immediateRender: !1,
        lazy: !1,
        overwrite: !1,
        delay: t,
        onComplete: n,
        onReverseComplete: n,
        onCompleteParams: r,
        onReverseCompleteParams: r,
        callbackScope: i
      });
    }, e.fromTo = function (t, n, r) {
      return new e(t, wt(arguments, 2));
    }, e.set = function (t, n) {
      return n.duration = 0, n.repeatDelay || (n.repeat = 0), new e(t, n);
    }, e.killTweensOf = function (t, e, n) {
      return a.killTweensOf(t, e, n);
    }, e;
  }(Be);

  kt(Ve.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
  }), yt("staggerTo,staggerFrom,staggerFromTo", function (t) {
    Ve[t] = function () {
      var e = new Re(),
          n = $t.call(arguments, 0);
      return n.splice("staggerFromTo" === t ? 5 : 4, 0, 0), e[t].apply(e, n);
    };
  });

  var Ue = function Ue(t, e, n) {
    return t[e] = n;
  },
      Ge = function Ge(t, e, n) {
    return t[e](n);
  },
      qe = function qe(t, e, n, r) {
    return t[e](r.fp, n);
  },
      Qe = function Qe(t, e, n) {
    return t.setAttribute(e, n);
  },
      Ke = function Ke(t, e) {
    return X(t[e]) ? Ge : j(t[e]) && t.setAttribute ? Qe : Ue;
  },
      $e = function $e(t, e) {
    return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t)) / 1e4, e);
  },
      Je = function Je(t, e) {
    return e.set(e.t, e.p, !!(e.s + e.c * t), e);
  },
      tn = function tn(t, e) {
    var n = e._pt,
        r = "";
    if (!t && e.b) r = e.b;else if (1 === t && e.e) r = e.e;else {
      for (; n;) {
        r = n.p + (n.m ? n.m(n.s + n.c * t) : Math.round(1e4 * (n.s + n.c * t)) / 1e4) + r, n = n._next;
      }

      r += e.c;
    }
    e.set(e.t, e.p, r, e);
  },
      en = function en(t, e) {
    for (var n = e._pt; n;) {
      n.r(t, n.d), n = n._next;
    }
  },
      nn = function nn(t, e, n, r) {
    for (var i, a = this._pt; a;) {
      i = a._next, a.p === r && a.modifier(t, e, n), a = i;
    }
  },
      rn = function rn(t) {
    for (var e, n, r = this._pt; r;) {
      n = r._next, r.p === t && !r.op || r.op === t ? Lt(this, r, "_pt") : r.dep || (e = 1), r = n;
    }

    return !e;
  },
      an = function an(t, e, n, r) {
    r.mSet(t, e, r.m.call(r.tween, n, r.mt), r);
  },
      on = function on(t) {
    for (var e, n, r, i, a = t._pt; a;) {
      for (e = a._next, n = r; n && n.pr > a.pr;) {
        n = n._next;
      }

      (a._prev = n ? n._prev : i) ? a._prev._next = a : r = a, (a._next = n) ? n._prev = a : i = a, a = e;
    }

    t._pt = r;
  },
      sn = function () {
    function t(t, e, n, r, i, a, o, s, l) {
      this.t = e, this.s = r, this.c = i, this.p = n, this.r = a || $e, this.d = o || this, this.set = s || Ue, this.pr = l || 0, this._next = t, t && (t._prev = this);
    }

    return t.prototype.modifier = function (t, e, n) {
      this.mSet = this.mSet || this.set, this.set = an, this.m = t, this.mt = n, this.tween = e;
    }, t;
  }();

  yt(gt + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function (t) {
    return lt[t] = 1;
  }), et.TweenMax = et.TweenLite = Ve, et.TimelineLite = et.TimelineMax = Re, a = new Re({
    sortChildren: !1,
    defaults: E,
    autoRemoveChildren: !0,
    id: "root",
    smoothChildTiming: !0
  }), A.stringFilter = be;
  var ln = {
    registerPlugin: function registerPlugin() {
      for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) {
        e[n] = arguments[n];
      }

      e.forEach(function (t) {
        return de(t);
      });
    },
    timeline: function timeline(t) {
      return new Re(t);
    },
    getTweensOf: function getTweensOf(t, e) {
      return a.getTweensOf(t, e);
    },
    getProperty: function getProperty(t, e, n, r) {
      Y(t) && (t = ee(t)[0]);

      var i = _t(t || {}).get,
          a = n ? Ct : St;

      return "native" === n && (n = ""), t ? e ? a((ft[e] && ft[e].get || i)(t, e, n, r)) : function (e, n, r) {
        return a((ft[e] && ft[e].get || i)(t, e, n, r));
      } : t;
    },
    quickSetter: function quickSetter(t, e, n) {
      if ((t = ee(t)).length > 1) {
        var r = t.map(function (t) {
          return fn.quickSetter(t, e, n);
        }),
            i = r.length;
        return function (t) {
          for (var e = i; e--;) {
            r[e](t);
          }
        };
      }

      t = t[0] || {};

      var a = ft[e],
          o = _t(t),
          s = o.harness && (o.harness.aliases || {})[e] || e,
          l = a ? function (e) {
        var r = new a();
        f._pt = 0, r.init(t, n ? e + n : e, f, 0, [t]), r.render(1, r), f._pt && en(1, f);
      } : o.set(t, s);

      return a ? l : function (e) {
        return l(t, s, n ? e + n : e, o, 1);
      };
    },
    isTweening: function isTweening(t) {
      return a.getTweensOf(t, !0).length > 0;
    },
    defaults: function defaults(t) {
      return t && t.ease && (t.ease = Ae(t.ease, E.ease)), At(E, t || {});
    },
    config: function config(t) {
      return At(A, t || {});
    },
    registerEffect: function registerEffect(t) {
      var e = t.name,
          n = t.effect,
          r = t.plugins,
          i = t.defaults,
          a = t.extendTimeline;
      (r || "").split(",").forEach(function (t) {
        return t && !ft[t] && !et[t] && at(e + " effect requires " + t + " plugin.");
      }), ht[e] = function (t, e, r) {
        return n(ee(t), kt(e || {}, i), r);
      }, a && (Re.prototype[e] = function (t, n, r) {
        return this.add(ht[e](t, Z(n) ? n : (r = n) && {}, this), r);
      });
    },
    registerEase: function registerEase(t, e) {
      Te[t] = Ae(e);
    },
    parseEase: function parseEase(t, e) {
      return arguments.length ? Ae(t, e) : Te;
    },
    getById: function getById(t) {
      return a.getById(t);
    },
    exportRoot: function exportRoot(t, e) {
      void 0 === t && (t = {});
      var n,
          r,
          i = new Re(t);

      for (i.smoothChildTiming = W(t.smoothChildTiming), a.remove(i), i._dp = 0, i._time = i._tTime = a._time, n = a._first; n;) {
        r = n._next, !e && !n._dur && n instanceof Ve && n.vars.onComplete === n._targets[0] || jt(i, n, n._start - n._delay), n = r;
      }

      return jt(a, i, 0), i;
    },
    utils: {
      wrap: function t(e, n, r) {
        var i = n - e;
        return U(e) ? se(e, t(0, e.length), n) : qt(r, function (t) {
          return (i + (t - e) % i) % i + e;
        });
      },
      wrapYoyo: function t(e, n, r) {
        var i = n - e,
            a = 2 * i;
        return U(e) ? se(e, t(0, e.length - 1), n) : qt(r, function (t) {
          return e + ((t = (a + (t - e) % a) % a || 0) > i ? a - t : t);
        });
      },
      distribute: re,
      random: oe,
      snap: ae,
      normalize: function normalize(t, e, n) {
        return ue(t, e, 0, 1, n);
      },
      getUnit: Kt,
      clamp: function clamp(t, e, n) {
        return qt(n, function (n) {
          return Qt(t, e, n);
        });
      },
      splitColor: me,
      toArray: ee,
      mapRange: ue,
      pipe: function pipe() {
        for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++) {
          e[n] = arguments[n];
        }

        return function (t) {
          return e.reduce(function (t, e) {
            return e(t);
          }, t);
        };
      },
      unitize: function unitize(t, e) {
        return function (n) {
          return t(parseFloat(n)) + (e || Kt(n));
        };
      },
      interpolate: function t(e, n, r, i) {
        var a = isNaN(e + n) ? 0 : function (t) {
          return (1 - t) * e + t * n;
        };

        if (!a) {
          var o,
              s,
              l,
              u,
              c,
              f = Y(e),
              h = {};
          if (!0 === r && (i = 1) && (r = null), f) e = {
            p: e
          }, n = {
            p: n
          };else if (U(e) && !U(n)) {
            for (l = [], u = e.length, c = u - 2, s = 1; s < u; s++) {
              l.push(t(e[s - 1], e[s]));
            }

            u--, a = function a(t) {
              t *= u;
              var e = Math.min(c, ~~t);
              return l[e](t - e);
            }, r = n;
          } else i || (e = Pt(U(e) ? [] : {}, e));

          if (!l) {
            for (o in n) {
              Xe.call(h, e, o, "get", n[o]);
            }

            a = function a(t) {
              return en(t, h) || (f ? e.p : e);
            };
          }
        }

        return qt(r, a);
      },
      shuffle: ne
    },
    install: rt,
    effects: ht,
    ticker: we,
    updateRoot: Re.updateRoot,
    plugins: ft,
    globalTimeline: a,
    core: {
      PropTween: sn,
      globals: ot,
      Tween: Ve,
      Timeline: Re,
      Animation: Be,
      getCache: _t,
      _removeLinkedListItem: Lt
    }
  };
  yt("to,from,fromTo,delayedCall,set,killTweensOf", function (t) {
    return ln[t] = Ve[t];
  }), we.add(Re.updateRoot), f = ln.to({}, {
    duration: 0
  });

  var un = function un(t, e) {
    for (var n = t._pt; n && n.p !== e && n.op !== e && n.fp !== e;) {
      n = n._next;
    }

    return n;
  },
      cn = function cn(t, e) {
    return {
      name: t,
      rawVars: 1,
      init: function init(t, n, r) {
        r._onInit = function (t) {
          var r, i;

          if (Y(n) && (r = {}, yt(n, function (t) {
            return r[t] = 1;
          }), n = r), e) {
            for (i in r = {}, n) {
              r[i] = e(n[i]);
            }

            n = r;
          }

          !function (t, e) {
            var n,
                r,
                i,
                a = t._targets;

            for (n in e) {
              for (r = a.length; r--;) {
                (i = t._ptLookup[r][n]) && (i = i.d) && (i._pt && (i = un(i, n)), i && i.modifier && i.modifier(e[n], t, a[r], n));
              }
            }
          }(t, n);
        };
      }
    };
  },
      fn = ln.registerPlugin({
    name: "attr",
    init: function init(t, e, n, r, i) {
      var a, o;

      for (a in e) {
        (o = this.add(t, "setAttribute", (t.getAttribute(a) || 0) + "", e[a], r, i, 0, 0, a)) && (o.op = a), this._props.push(a);
      }
    }
  }, {
    name: "endArray",
    init: function init(t, e) {
      for (var n = e.length; n--;) {
        this.add(t, n, t[n] || 0, e[n]);
      }
    }
  }, cn("roundProps", ie), cn("modifiers"), cn("snap", ae)) || ln;

  Ve.version = Re.version = fn.version = "3.3.4", u = 1, H() && Me();

  var hn,
      dn,
      pn,
      gn,
      mn,
      _n,
      vn,
      yn,
      xn = Te.Power0,
      bn = Te.Power1,
      wn = Te.Power2,
      Mn = Te.Power3,
      Tn = Te.Power4,
      Sn = Te.Linear,
      Cn = Te.Quad,
      kn = Te.Cubic,
      On = Te.Quart,
      Pn = Te.Quint,
      An = Te.Strong,
      En = Te.Elastic,
      Dn = Te.Back,
      Ln = Te.SteppedEase,
      zn = Te.Bounce,
      Nn = Te.Sine,
      Bn = Te.Expo,
      Rn = Te.Circ,
      Fn = {},
      Yn = 180 / Math.PI,
      Xn = Math.PI / 180,
      In = Math.atan2,
      jn = /([A-Z])/g,
      Zn = /(?:left|right|width|margin|padding|x)/i,
      Wn = /[\s,\(]\S/,
      Hn = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
  },
      Vn = function Vn(t, e) {
    return e.set(e.t, e.p, Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e);
  },
      Un = function Un(t, e) {
    return e.set(e.t, e.p, 1 === t ? e.e : Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u, e);
  },
      Gn = function Gn(t, e) {
    return e.set(e.t, e.p, t ? Math.round(1e4 * (e.s + e.c * t)) / 1e4 + e.u : e.b, e);
  },
      qn = function qn(t, e) {
    var n = e.s + e.c * t;
    e.set(e.t, e.p, ~~(n + (n < 0 ? -.5 : .5)) + e.u, e);
  },
      Qn = function Qn(t, e) {
    return e.set(e.t, e.p, t ? e.e : e.b, e);
  },
      Kn = function Kn(t, e) {
    return e.set(e.t, e.p, 1 !== t ? e.b : e.e, e);
  },
      $n = function $n(t, e, n) {
    return t.style[e] = n;
  },
      Jn = function Jn(t, e, n) {
    return t.style.setProperty(e, n);
  },
      tr = function tr(t, e, n) {
    return t._gsap[e] = n;
  },
      er = function er(t, e, n) {
    return t._gsap.scaleX = t._gsap.scaleY = n;
  },
      nr = function nr(t, e, n, r, i) {
    var a = t._gsap;
    a.scaleX = a.scaleY = n, a.renderTransform(i, a);
  },
      rr = function rr(t, e, n, r, i) {
    var a = t._gsap;
    a[e] = n, a.renderTransform(i, a);
  },
      ir = "transform",
      ar = ir + "Origin",
      or = function or(t, e) {
    var n = dn.createElementNS ? dn.createElementNS((e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t) : dn.createElement(t);
    return n.style ? n : dn.createElement(t);
  },
      sr = function t(e, n, r) {
    var i = getComputedStyle(e);
    return i[n] || i.getPropertyValue(n.replace(jn, "-$1").toLowerCase()) || i.getPropertyValue(n) || !r && t(e, ur(n) || n, 1) || "";
  },
      lr = "O,Moz,ms,Ms,Webkit".split(","),
      ur = function ur(t, e, n) {
    var r = (e || mn).style,
        i = 5;
    if (t in r && !n) return t;

    for (t = t.charAt(0).toUpperCase() + t.substr(1); i-- && !(lr[i] + t in r);) {
      ;
    }

    return i < 0 ? null : (3 === i ? "ms" : i >= 0 ? lr[i] : "") + t;
  },
      cr = function cr() {
    "undefined" != typeof window && window.document && (hn = window, dn = hn.document, pn = dn.documentElement, mn = or("div") || {
      style: {}
    }, _n = or("div"), ir = ur(ir), ar = ur(ar), mn.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0", yn = !!ur("perspective"), gn = 1);
  },
      fr = function t(e) {
    var n,
        r = or("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
        i = this.parentNode,
        a = this.nextSibling,
        o = this.style.cssText;
    if (pn.appendChild(r), r.appendChild(this), this.style.display = "block", e) try {
      n = this.getBBox(), this._gsapBBox = this.getBBox, this.getBBox = t;
    } catch (t) {} else this._gsapBBox && (n = this._gsapBBox());
    return i && (a ? i.insertBefore(this, a) : i.appendChild(this)), pn.removeChild(r), this.style.cssText = o, n;
  },
      hr = function hr(t, e) {
    for (var n = e.length; n--;) {
      if (t.hasAttribute(e[n])) return t.getAttribute(e[n]);
    }
  },
      dr = function dr(t) {
    var e;

    try {
      e = t.getBBox();
    } catch (n) {
      e = fr.call(t, !0);
    }

    return e && (e.width || e.height) || t.getBBox === fr || (e = fr.call(t, !0)), !e || e.width || e.x || e.y ? e : {
      x: +hr(t, ["x", "cx", "x1"]) || 0,
      y: +hr(t, ["y", "cy", "y1"]) || 0,
      width: 0,
      height: 0
    };
  },
      pr = function pr(t) {
    return !(!t.getCTM || t.parentNode && !t.ownerSVGElement || !dr(t));
  },
      gr = function gr(t, e) {
    if (e) {
      var n = t.style;
      e in Fn && (e = ir), n.removeProperty ? ("ms" !== e.substr(0, 2) && "webkit" !== e.substr(0, 6) || (e = "-" + e), n.removeProperty(e.replace(jn, "-$1").toLowerCase())) : n.removeAttribute(e);
    }
  },
      mr = function mr(t, e, n, r, i, a) {
    var o = new sn(t._pt, e, n, 0, 1, a ? Kn : Qn);
    return t._pt = o, o.b = r, o.e = i, t._props.push(n), o;
  },
      _r = {
    deg: 1,
    rad: 1,
    turn: 1
  },
      vr = function t(e, n, r, i) {
    var a,
        o,
        s,
        l,
        u = parseFloat(r) || 0,
        c = (r + "").trim().substr((u + "").length) || "px",
        f = mn.style,
        h = Zn.test(n),
        d = "svg" === e.tagName.toLowerCase(),
        p = (d ? "client" : "offset") + (h ? "Width" : "Height"),
        g = "px" === i,
        m = "%" === i;
    return i === c || !u || _r[i] || _r[c] ? u : ("px" !== c && !g && (u = t(e, n, r, "px")), l = e.getCTM && pr(e), m && (Fn[n] || ~n.indexOf("adius")) ? xt(u / (l ? e.getBBox()[h ? "width" : "height"] : e[p]) * 100) : (f[h ? "width" : "height"] = 100 + (g ? c : i), o = ~n.indexOf("adius") || "em" === i && e.appendChild && !d ? e : e.parentNode, l && (o = (e.ownerSVGElement || {}).parentNode), o && o !== dn && o.appendChild || (o = dn.body), (s = o._gsap) && m && s.width && h && s.time === we.time ? xt(u / s.width * 100) : ((m || "%" === c) && (f.position = sr(e, "position")), o === e && (f.position = "static"), o.appendChild(mn), a = mn[p], o.removeChild(mn), f.position = "absolute", h && m && ((s = _t(o)).time = we.time, s.width = o[p]), xt(g ? a * u / 100 : a && u ? 100 / a * u : 0))));
  },
      yr = function yr(t, e, n, r) {
    var i;
    return gn || cr(), e in Hn && "transform" !== e && ~(e = Hn[e]).indexOf(",") && (e = e.split(",")[0]), Fn[e] && "transform" !== e ? (i = Ar(t, r), i = "transformOrigin" !== e ? i[e] : Er(sr(t, ar)) + " " + i.zOrigin + "px") : (!(i = t.style[e]) || "auto" === i || r || ~(i + "").indexOf("calc(")) && (i = Mr[e] && Mr[e](t, e, n) || sr(t, e) || vt(t, e) || ("opacity" === e ? 1 : 0)), n && !~(i + "").indexOf(" ") ? vr(t, e, i, n) + n : i;
  },
      xr = function xr(t, e, n, r) {
    if (!n || "none" === n) {
      var i = ur(e, t, 1),
          a = i && sr(t, i, 1);
      a && a !== n && (e = i, n = a);
    }

    var o,
        s,
        l,
        u,
        c,
        f,
        h,
        d,
        p,
        g,
        m,
        _,
        v = new sn(this._pt, t.style, e, 0, 1, tn),
        y = 0,
        x = 0;

    if (v.b = n, v.e = r, n += "", "auto" === (r += "") && (t.style[e] = r, r = sr(t, e) || r, t.style[e] = n), be(o = [n, r]), r = o[1], l = (n = o[0]).match(Q) || [], (r.match(Q) || []).length) {
      for (; s = Q.exec(r);) {
        h = s[0], p = r.substring(y, s.index), c ? c = (c + 1) % 5 : "rgba(" !== p.substr(-5) && "hsla(" !== p.substr(-5) || (c = 1), h !== (f = l[x++] || "") && (u = parseFloat(f) || 0, m = f.substr((u + "").length), (_ = "=" === h.charAt(1) ? +(h.charAt(0) + "1") : 0) && (h = h.substr(2)), d = parseFloat(h), g = h.substr((d + "").length), y = Q.lastIndex - g.length, g || (g = g || A.units[e] || m, y === r.length && (r += g, v.e += g)), m !== g && (u = vr(t, e, f, g) || 0), v._pt = {
          _next: v._pt,
          p: p || 1 === x ? p : ",",
          s: u,
          c: _ ? _ * d : d - u,
          m: c && c < 4 ? Math.round : 0
        });
      }

      v.c = y < r.length ? r.substring(y, r.length) : "";
    } else v.r = "display" === e && "none" === r ? Kn : Qn;

    return J.test(r) && (v.e = 0), this._pt = v, v;
  },
      br = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
  },
      wr = function wr(t, e) {
    if (e.tween && e.tween._time === e.tween._dur) {
      var n,
          r,
          i,
          a = e.t,
          o = a.style,
          s = e.u,
          l = a._gsap;
      if ("all" === s || !0 === s) o.cssText = "", r = 1;else for (i = (s = s.split(",")).length; --i > -1;) {
        n = s[i], Fn[n] && (r = 1, n = "transformOrigin" === n ? ar : ir), gr(a, n);
      }
      r && (gr(a, ir), l && (l.svg && a.removeAttribute("transform"), Ar(a, 1), l.uncache = 1));
    }
  },
      Mr = {
    clearProps: function clearProps(t, e, n, r, i) {
      if ("isFromStart" !== i.data) {
        var a = t._pt = new sn(t._pt, e, n, 0, 0, wr);
        return a.u = r, a.pr = -10, a.tween = i, t._props.push(n), 1;
      }
    }
  },
      Tr = [1, 0, 0, 1, 0, 0],
      Sr = {},
      Cr = function Cr(t) {
    return "matrix(1, 0, 0, 1, 0, 0)" === t || "none" === t || !t;
  },
      kr = function kr(t) {
    var e = sr(t, ir);
    return Cr(e) ? Tr : e.substr(7).match(q).map(xt);
  },
      Or = function Or(t, e) {
    var n,
        r,
        i,
        a,
        o = t._gsap || _t(t),
        s = t.style,
        l = kr(t);

    return o.svg && t.getAttribute("transform") ? "1,0,0,1,0,0" === (l = [(i = t.transform.baseVal.consolidate().matrix).a, i.b, i.c, i.d, i.e, i.f]).join(",") ? Tr : l : (l !== Tr || t.offsetParent || t === pn || o.svg || (i = s.display, s.display = "block", (n = t.parentNode) && t.offsetParent || (a = 1, r = t.nextSibling, pn.appendChild(t)), l = kr(t), i ? s.display = i : gr(t, "display"), a && (r ? n.insertBefore(t, r) : n ? n.appendChild(t) : pn.removeChild(t))), e && l.length > 6 ? [l[0], l[1], l[4], l[5], l[12], l[13]] : l);
  },
      Pr = function Pr(t, e, n, r, i, a) {
    var o,
        s,
        l,
        u = t._gsap,
        c = i || Or(t, !0),
        f = u.xOrigin || 0,
        h = u.yOrigin || 0,
        d = u.xOffset || 0,
        p = u.yOffset || 0,
        g = c[0],
        m = c[1],
        _ = c[2],
        v = c[3],
        y = c[4],
        x = c[5],
        b = e.split(" "),
        w = parseFloat(b[0]) || 0,
        M = parseFloat(b[1]) || 0;
    n ? c !== Tr && (s = g * v - m * _) && (l = w * (-m / s) + M * (g / s) - (g * x - m * y) / s, w = w * (v / s) + M * (-_ / s) + (_ * x - v * y) / s, M = l) : (w = (o = dr(t)).x + (~b[0].indexOf("%") ? w / 100 * o.width : w), M = o.y + (~(b[1] || b[0]).indexOf("%") ? M / 100 * o.height : M)), r || !1 !== r && u.smooth ? (y = w - f, x = M - h, u.xOffset = d + (y * g + x * _) - y, u.yOffset = p + (y * m + x * v) - x) : u.xOffset = u.yOffset = 0, u.xOrigin = w, u.yOrigin = M, u.smooth = !!r, u.origin = e, u.originIsAbsolute = !!n, t.style[ar] = "0px 0px", a && (mr(a, u, "xOrigin", f, w), mr(a, u, "yOrigin", h, M), mr(a, u, "xOffset", d, u.xOffset), mr(a, u, "yOffset", p, u.yOffset)), t.setAttribute("data-svg-origin", w + " " + M);
  },
      Ar = function Ar(t, e) {
    var n = t._gsap || new Ne(t);
    if ("x" in n && !e && !n.uncache) return n;

    var r,
        i,
        a,
        o,
        s,
        l,
        u,
        c,
        f,
        h,
        d,
        p,
        g,
        m,
        _,
        v,
        y,
        x,
        b,
        w,
        M,
        T,
        S,
        C,
        k,
        O,
        P,
        E,
        D,
        L,
        z,
        N,
        B = t.style,
        R = n.scaleX < 0,
        F = sr(t, ar) || "0";

    return r = i = a = l = u = c = f = h = d = 0, o = s = 1, n.svg = !(!t.getCTM || !pr(t)), m = Or(t, n.svg), n.svg && (C = !n.uncache && t.getAttribute("data-svg-origin"), Pr(t, C || F, !!C || n.originIsAbsolute, !1 !== n.smooth, m)), p = n.xOrigin || 0, g = n.yOrigin || 0, m !== Tr && (x = m[0], b = m[1], w = m[2], M = m[3], r = T = m[4], i = S = m[5], 6 === m.length ? (o = Math.sqrt(x * x + b * b), s = Math.sqrt(M * M + w * w), l = x || b ? In(b, x) * Yn : 0, (f = w || M ? In(w, M) * Yn + l : 0) && (s *= Math.cos(f * Xn)), n.svg && (r -= p - (p * x + g * w), i -= g - (p * b + g * M))) : (N = m[6], L = m[7], P = m[8], E = m[9], D = m[10], z = m[11], r = m[12], i = m[13], a = m[14], u = (_ = In(N, D)) * Yn, _ && (C = T * (v = Math.cos(-_)) + P * (y = Math.sin(-_)), k = S * v + E * y, O = N * v + D * y, P = T * -y + P * v, E = S * -y + E * v, D = N * -y + D * v, z = L * -y + z * v, T = C, S = k, N = O), c = (_ = In(-w, D)) * Yn, _ && (v = Math.cos(-_), z = M * (y = Math.sin(-_)) + z * v, x = C = x * v - P * y, b = k = b * v - E * y, w = O = w * v - D * y), l = (_ = In(b, x)) * Yn, _ && (C = x * (v = Math.cos(_)) + b * (y = Math.sin(_)), k = T * v + S * y, b = b * v - x * y, S = S * v - T * y, x = C, T = k), u && Math.abs(u) + Math.abs(l) > 359.9 && (u = l = 0, c = 180 - c), o = xt(Math.sqrt(x * x + b * b + w * w)), s = xt(Math.sqrt(S * S + N * N)), _ = In(T, S), f = Math.abs(_) > 2e-4 ? _ * Yn : 0, d = z ? 1 / (z < 0 ? -z : z) : 0), n.svg && (C = t.getAttribute("transform"), n.forceCSS = t.setAttribute("transform", "") || !Cr(sr(t, ir)), C && t.setAttribute("transform", C))), Math.abs(f) > 90 && Math.abs(f) < 270 && (R ? (o *= -1, f += l <= 0 ? 180 : -180, l += l <= 0 ? 180 : -180) : (s *= -1, f += f <= 0 ? 180 : -180)), n.x = ((n.xPercent = r && Math.round(t.offsetWidth / 2) === Math.round(-r) ? -50 : 0) ? 0 : r) + "px", n.y = ((n.yPercent = i && Math.round(t.offsetHeight / 2) === Math.round(-i) ? -50 : 0) ? 0 : i) + "px", n.z = a + "px", n.scaleX = xt(o), n.scaleY = xt(s), n.rotation = xt(l) + "deg", n.rotationX = xt(u) + "deg", n.rotationY = xt(c) + "deg", n.skewX = f + "deg", n.skewY = h + "deg", n.transformPerspective = d + "px", (n.zOrigin = parseFloat(F.split(" ")[2]) || 0) && (B[ar] = Er(F)), n.xOffset = n.yOffset = 0, n.force3D = A.force3D, n.renderTransform = n.svg ? Nr : yn ? zr : Lr, n.uncache = 0, n;
  },
      Er = function Er(t) {
    return (t = t.split(" "))[0] + " " + t[1];
  },
      Dr = function Dr(t, e, n) {
    var r = Kt(e);
    return xt(parseFloat(e) + parseFloat(vr(t, "x", n + "px", r))) + r;
  },
      Lr = function Lr(t, e) {
    e.z = "0px", e.rotationY = e.rotationX = "0deg", e.force3D = 0, zr(t, e);
  },
      zr = function zr(t, e) {
    var n = e || this,
        r = n.xPercent,
        i = n.yPercent,
        a = n.x,
        o = n.y,
        s = n.z,
        l = n.rotation,
        u = n.rotationY,
        c = n.rotationX,
        f = n.skewX,
        h = n.skewY,
        d = n.scaleX,
        p = n.scaleY,
        g = n.transformPerspective,
        m = n.force3D,
        _ = n.target,
        v = n.zOrigin,
        y = "",
        x = "auto" === m && t && 1 !== t || !0 === m;

    if (v && ("0deg" !== c || "0deg" !== u)) {
      var b,
          w = parseFloat(u) * Xn,
          M = Math.sin(w),
          T = Math.cos(w);
      w = parseFloat(c) * Xn, b = Math.cos(w), a = Dr(_, a, M * b * -v), o = Dr(_, o, -Math.sin(w) * -v), s = Dr(_, s, T * b * -v + v);
    }

    "0px" !== g && (y += "perspective(" + g + ") "), (r || i) && (y += "translate(" + r + "%, " + i + "%) "), (x || "0px" !== a || "0px" !== o || "0px" !== s) && (y += "0px" !== s || x ? "translate3d(" + a + ", " + o + ", " + s + ") " : "translate(" + a + ", " + o + ") "), "0deg" !== l && (y += "rotate(" + l + ") "), "0deg" !== u && (y += "rotateY(" + u + ") "), "0deg" !== c && (y += "rotateX(" + c + ") "), "0deg" === f && "0deg" === h || (y += "skew(" + f + ", " + h + ") "), 1 === d && 1 === p || (y += "scale(" + d + ", " + p + ") "), _.style[ir] = y || "translate(0, 0)";
  },
      Nr = function Nr(t, e) {
    var n,
        r,
        i,
        a,
        o,
        s = e || this,
        l = s.xPercent,
        u = s.yPercent,
        c = s.x,
        f = s.y,
        h = s.rotation,
        d = s.skewX,
        p = s.skewY,
        g = s.scaleX,
        m = s.scaleY,
        _ = s.target,
        v = s.xOrigin,
        y = s.yOrigin,
        x = s.xOffset,
        b = s.yOffset,
        w = s.forceCSS,
        M = parseFloat(c),
        T = parseFloat(f);
    h = parseFloat(h), d = parseFloat(d), (p = parseFloat(p)) && (d += p = parseFloat(p), h += p), h || d ? (h *= Xn, d *= Xn, n = Math.cos(h) * g, r = Math.sin(h) * g, i = Math.sin(h - d) * -m, a = Math.cos(h - d) * m, d && (p *= Xn, o = Math.tan(d - p), i *= o = Math.sqrt(1 + o * o), a *= o, p && (o = Math.tan(p), n *= o = Math.sqrt(1 + o * o), r *= o)), n = xt(n), r = xt(r), i = xt(i), a = xt(a)) : (n = g, a = m, r = i = 0), (M && !~(c + "").indexOf("px") || T && !~(f + "").indexOf("px")) && (M = vr(_, "x", c, "px"), T = vr(_, "y", f, "px")), (v || y || x || b) && (M = xt(M + v - (v * n + y * i) + x), T = xt(T + y - (v * r + y * a) + b)), (l || u) && (o = _.getBBox(), M = xt(M + l / 100 * o.width), T = xt(T + u / 100 * o.height)), o = "matrix(" + n + "," + r + "," + i + "," + a + "," + M + "," + T + ")", _.setAttribute("transform", o), w && (_.style[ir] = o);
  },
      Br = function Br(t, e, n, r, i, a) {
    var o,
        s,
        l = Y(i),
        u = parseFloat(i) * (l && ~i.indexOf("rad") ? Yn : 1),
        c = a ? u * a : u - r,
        f = r + c + "deg";
    return l && ("short" === (o = i.split("_")[1]) && (c %= 360) !== c % 180 && (c += c < 0 ? 360 : -360), "cw" === o && c < 0 ? c = (c + 36e9) % 360 - 360 * ~~(c / 360) : "ccw" === o && c > 0 && (c = (c - 36e9) % 360 - 360 * ~~(c / 360))), t._pt = s = new sn(t._pt, e, n, r, c, Un), s.e = f, s.u = "deg", t._props.push(n), s;
  },
      Rr = function Rr(t, e, n) {
    var r,
        i,
        a,
        o,
        s,
        l,
        u,
        c = _n.style,
        f = n._gsap;

    for (i in c.cssText = getComputedStyle(n).cssText + ";position:absolute;display:block;", c[ir] = e, dn.body.appendChild(_n), r = Ar(_n, 1), Fn) {
      (a = f[i]) !== (o = r[i]) && "perspective,force3D,transformOrigin,svgOrigin".indexOf(i) < 0 && (s = Kt(a) !== (u = Kt(o)) ? vr(n, i, a, u) : parseFloat(a), l = parseFloat(o), t._pt = new sn(t._pt, f, i, s, l - s, Vn), t._pt.u = u || 0, t._props.push(i));
    }

    dn.body.removeChild(_n);
  };
  /*!
   * CSSPlugin 3.3.4
   * https://greensock.com
   *
   * Copyright 2008-2020, GreenSock. All rights reserved.
   * Subject to the terms at https://greensock.com/standard-license or for
   * Club GreenSock members, the agreement issued with that membership.
   * @author: Jack Doyle, jack@greensock.com
  */


  yt("padding,margin,Width,Radius", function (t, e) {
    var n = "Top",
        r = "Right",
        i = "Bottom",
        a = "Left",
        o = (e < 3 ? [n, r, i, a] : [n + a, n + r, i + r, i + a]).map(function (n) {
      return e < 2 ? t + n : "border" + n + t;
    });

    Mr[e > 1 ? "border" + t : t] = function (t, e, n, r, i) {
      var a, s;
      if (arguments.length < 4) return a = o.map(function (e) {
        return yr(t, e, n);
      }), 5 === (s = a.join(" ")).split(a[0]).length ? a[0] : s;
      a = (r + "").split(" "), s = {}, o.forEach(function (t, e) {
        return s[t] = a[e] = a[e] || a[(e - 1) / 2 | 0];
      }), t.init(e, s, i);
    };
  });
  var Fr,
      Yr,
      Xr = {
    name: "css",
    register: cr,
    targetTest: function targetTest(t) {
      return t.style && t.nodeType;
    },
    init: function init(t, e, n, r, i) {
      var a,
          o,
          s,
          l,
          u,
          c,
          f,
          h,
          d,
          p,
          g,
          m,
          _,
          v,
          y,
          x,
          b,
          w,
          M,
          T = this._props,
          S = t.style;

      for (f in gn || cr(), e) {
        if ("autoRound" !== f && (o = e[f], !ft[f] || !Ie(f, e, n, r, t, i))) if (u = typeof o, c = Mr[f], "function" === u && (u = typeof (o = o.call(n, r, t, i))), "string" === u && ~o.indexOf("random(") && (o = le(o)), c) c(this, t, f, o, n) && (y = 1);else if ("--" === f.substr(0, 2)) this.add(S, "setProperty", getComputedStyle(t).getPropertyValue(f) + "", o + "", r, i, 0, 0, f);else {
          if (a = yr(t, f), l = parseFloat(a), (p = "string" === u && "=" === o.charAt(1) ? +(o.charAt(0) + "1") : 0) && (o = o.substr(2)), s = parseFloat(o), f in Hn && ("autoAlpha" === f && (1 === l && "hidden" === yr(t, "visibility") && s && (l = 0), mr(this, S, "visibility", l ? "inherit" : "hidden", s ? "inherit" : "hidden", !s)), "scale" !== f && "transform" !== f && ~(f = Hn[f]).indexOf(",") && (f = f.split(",")[0])), g = f in Fn) {
            if (m || ((_ = t._gsap).renderTransform || Ar(t), v = !1 !== e.smoothOrigin && _.smooth, (m = this._pt = new sn(this._pt, S, ir, 0, 1, _.renderTransform, _, 0, -1)).dep = 1), "scale" === f) this._pt = new sn(this._pt, _, "scaleY", _.scaleY, p ? p * s : s - _.scaleY), T.push("scaleY", f), f += "X";else {
              if ("transformOrigin" === f) {
                b = void 0, w = void 0, M = void 0, b = (x = o).split(" "), w = b[0], M = b[1] || "50%", "top" !== w && "bottom" !== w && "left" !== M && "right" !== M || (x = w, w = M, M = x), b[0] = br[w] || w, b[1] = br[M] || M, o = b.join(" "), _.svg ? Pr(t, o, 0, v, 0, this) : ((d = parseFloat(o.split(" ")[2]) || 0) !== _.zOrigin && mr(this, _, "zOrigin", _.zOrigin, d), mr(this, S, f, Er(a), Er(o)));
                continue;
              }

              if ("svgOrigin" === f) {
                Pr(t, o, 1, v, 0, this);
                continue;
              }

              if (f in Sr) {
                Br(this, _, f, l, o, p);
                continue;
              }

              if ("smoothOrigin" === f) {
                mr(this, _, "smooth", _.smooth, o);
                continue;
              }

              if ("force3D" === f) {
                _[f] = o;
                continue;
              }

              if ("transform" === f) {
                Rr(this, o, t);
                continue;
              }
            }
          } else f in S || (f = ur(f) || f);
          if (g || (s || 0 === s) && (l || 0 === l) && !Wn.test(o) && f in S) s || (s = 0), (h = (a + "").substr((l + "").length)) !== (d = (o + "").substr((s + "").length) || (f in A.units ? A.units[f] : h)) && (l = vr(t, f, a, d)), this._pt = new sn(this._pt, g ? _ : S, f, l, p ? p * s : s - l, "px" !== d || !1 === e.autoRound || g ? Vn : qn), this._pt.u = d || 0, h !== d && (this._pt.b = a, this._pt.r = Gn);else if (f in S) xr.call(this, t, f, a, o);else {
            if (!(f in t)) {
              it(f, o);
              continue;
            }

            this.add(t, f, t[f], o, r, i);
          }
          T.push(f);
        }
      }

      y && on(this);
    },
    get: yr,
    aliases: Hn,
    getSetter: function getSetter(t, e, n) {
      var r = Hn[e];
      return r && r.indexOf(",") < 0 && (e = r), e in Fn && e !== ar && (t._gsap.x || yr(t, "x")) ? n && vn === n ? "scale" === e ? er : tr : (vn = n || {}) && ("scale" === e ? nr : rr) : t.style && !j(t.style[e]) ? $n : ~e.indexOf("-") ? Jn : Ke(t, e);
    },
    core: {
      _removeProperty: gr,
      _getMatrix: Or
    }
  };
  fn.utils.checkPrefix = ur, Yr = yt("x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + (Fr = "rotation,rotationX,rotationY,skewX,skewY") + ",transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", function (t) {
    Fn[t] = 1;
  }), yt(Fr, function (t) {
    A.units[t] = "deg", Sr[t] = 1;
  }), Hn[Yr[13]] = "x,y,z,scale,scaleX,scaleY,xPercent,yPercent," + Fr, yt("0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY", function (t) {
    var e = t.split(":");
    Hn[e[1]] = Yr[e[0]];
  }), yt("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function (t) {
    A.units[t] = "px";
  }), fn.registerPlugin(Xr);
  var Ir = fn.registerPlugin(Xr) || fn,
      jr = Ir.core.Tween;
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.IconSetOptions = void 0, function (t) {
    t.chrisGannon = "chrisGannon", t.twemoji = "twemoji";
  }(e.IconSetOptions || (e.IconSetOptions = {}));
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = '"Nunito Sans",-apple-system,".SFNSText-Regular","San Francisco",BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Helvetica,Arial,sans-serif';
  e["default"] = {
    fonts: {
      body: r,
      heading: r
    },
    colors: {
      text: "#282a36",
      background: "#ffffff",
      primary: "#FF69B4",
      secondary: "#1EA7FD",
      muted: "#8394ca",
      highlight: "#50fa7b",
      gray: "#F2F2F2",
      darkGray: "#999999",
      accent: "#ffd5ea",
      mutedAccent: "#d1d8ec",
      darken: "#323442",
      emoji: "#ffcb4c"
    },
    shadows: ["0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)", "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)", "0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23)", "0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)", "0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22)"],
    buttons: {
      primary: {
        cursor: "pointer",
        fontWeight: "bold",
        minWidth: 120,
        ":disabled": {
          color: "primary",
          backgroundColor: "accent",
          cursor: "not-allowed"
        },
        ":focus": {
          outlineColor: "secondary"
        }
      },
      ghost: {
        cursor: "pointer",
        fontWeight: "bold",
        color: "white",
        backgroundColor: "secondary",
        minWidth: 120,
        ":disabled": {
          color: "darkGray",
          backgroundColor: "gray",
          cursor: "not-allowed"
        },
        ":focus": {
          outlineColor: "emoji"
        }
      }
    },
    text: {
      small: {
        textAlign: "center",
        fontWeight: "bold",
        mt: 2,
        color: "primary"
      }
    },
    lineHeights: {
      body: "normal",
      heading: "normal"
    },
    fontWeights: {
      body: 400,
      heading: 800
    },
    styles: {
      a: {
        fontWeight: "bold",
        color: "secondary",
        ":focus": {
          outlineColor: "primary"
        }
      },
      hr: {
        my: 4
      }
    }
  };
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.iconPaths = void 0, e.iconPaths = {
    twemoji: [{
      name: "happy",
      paths: ['<path d="M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm5.33,8.89c1.23,0,2.23,1.39,2.23,3.11s-1,3.11-2.23,3.11S19.11,13.72,19.11,12,20.11,8.89,21.33,8.89Zm-10.66,0c1.22,0,2.22,1.39,2.22,3.11s-1,3.11-2.22,3.11S8.44,13.72,8.44,12,9.44,8.89,10.67,8.89ZM16,27.56c-5.69,0-9.78-4.45-9.78-8,0-1.78,1.18-1.9,1.78-1.78a37.84,37.84,0,0,0,8,.89,37.84,37.84,0,0,0,8-.89c.6-.12,1.78,0,1.78,1.78C25.78,23.11,21.69,27.56,16,27.56Z" style="fill: #ffcc4d"/>', '<path d="M24,17.78a37.84,37.84,0,0,1-8,.89,37.84,37.84,0,0,1-8-.89c-.6-.12-1.78,0-1.78,1.78,0,3.55,4.09,8,9.78,8s9.78-4.45,9.78-8C25.78,17.78,24.6,17.66,24,17.78Zm-8,5.33c-6.22,0-8-3.55-8-3.55a28.2,28.2,0,0,0,8,.88,28.2,28.2,0,0,0,8-.88S22.22,23.11,16,23.11Z" style="fill: #664500"/>', '<path d="M8,19.56a28.2,28.2,0,0,0,8,.88,28.2,28.2,0,0,0,8-.88s-1.78,3.55-8,3.55S8,19.56,8,19.56Z" style="fill: #fff"/>', '<path d="M10.67,8.89c-2.88-.07-2.88,6.29,0,6.22S13.55,8.82,10.67,8.89Z" style="fill: #664500"/>', '<path d="M21.33,8.89c-2.88-.07-2.88,6.29,0,6.22S24.21,8.82,21.33,8.89Z" style="fill: #664500"/>']
    }, {
      name: "cool",
      paths: ['<path d="M32,16A16,16,0,1,1,16,0,16,16,0,0,1,32,16" style="fill: #ffcc4d"/>', '<path d="M1.1,9.79c.22.22,1.28.85,1.49,1.49s.64,4.26,1.92,5.32,6.29.69,7.24.21c2.13-1.06,2.4-4,2.77-5.53.22-.85,1.49-.85,1.49-.85s1.28,0,1.49.85c.38,1.5.64,4.47,2.77,5.53,1,.48,5.93.89,7.25-.21s1.7-4.68,1.91-5.32,1.28-1.27,1.5-1.49a1.36,1.36,0,0,0,0-1.27c-.43-.43-5.46-.81-10.87-.21a19.62,19.62,0,0,1-4,.42,19.49,19.49,0,0,1-4-.42c-5.41-.6-10.44-.22-10.87.21A1.36,1.36,0,0,0,1.1,9.79Z" style="fill: #292f33;fill-rule: evenodd"/>', '<path d="M24.3,21a.45.45,0,0,0-.57,0A14.46,14.46,0,0,1,16,23.56,14.5,14.5,0,0,1,8.27,21a.45.45,0,0,0-.57,0,.44.44,0,0,0-.08.56A10.2,10.2,0,0,0,16,26.22a10.2,10.2,0,0,0,8.38-4.66A.44.44,0,0,0,24.3,21Z" style="fill: #664500"/>']
    }, {
      name: "evil",
      paths: ['<path d="M16,0c20.92.09,20.92,31.91,0,32C-4.92,31.91-4.92.09,16,0Z" transform="translate(0 0)" style="fill: #aa8dd8"/>', '<path d="M8.89,3.56c-2.29,0-5-2.2-5.86-3A1.75,1.75,0,0,0,1.1.14,1.76,1.76,0,0,0,0,1.78c0,3.07,1.49,8.89,7.11,8.89a1.77,1.77,0,0,0,1.59-1l1.78-3.55A1.78,1.78,0,0,0,8.89,3.56ZM30.9.14A1.75,1.75,0,0,0,29,.52c-.79.79-3.56,3-5.86,3a1.76,1.76,0,0,0-1.51.84,1.8,1.8,0,0,0-.08,1.73L23.3,9.68a1.77,1.77,0,0,0,1.59,1c5.62,0,7.11-5.82,7.11-8.89A1.76,1.76,0,0,0,30.9.14Z" transform="translate(0 0)" style="fill: #aa8dd8"/>', '<path d="M24.3,22.78a.45.45,0,0,0-.57,0A14.49,14.49,0,0,1,16,25.33a14.53,14.53,0,0,1-7.73-2.57.45.45,0,0,0-.57,0,.44.44,0,0,0-.08.56A10.2,10.2,0,0,0,16,28a10.2,10.2,0,0,0,8.38-4.66A.44.44,0,0,0,24.3,22.78ZM14,16.26c-2.89-2.89-7.54-2.93-7.74-2.93a.89.89,0,0,0,0,1.78,12.29,12.29,0,0,1,3.54.66,3.61,3.61,0,0,0-.87,2.45c0,1.72,1,3.11,2.22,3.11s2.22-1.39,2.22-3.11a3.4,3.4,0,0,0,0-.45h0A.89.89,0,0,0,14,16.26Zm11.82-2.93c-.2,0-4.85,0-7.74,2.93a.89.89,0,0,0,.63,1.52h0a3.4,3.4,0,0,0,0,.45c0,1.72,1,3.11,2.22,3.11s2.22-1.39,2.22-3.11a3.61,3.61,0,0,0-.87-2.45,12.29,12.29,0,0,1,3.54-.66.89.89,0,1,0,0-1.78Z" transform="translate(0 0)" style="fill: #553986"/>']
    }, {
      name: "confused",
      paths: ['<path d="M16,0c20.92.09,20.92,31.91,0,32C-4.92,31.91-4.92.09,16,0Z" transform="translate(-0.31)" style="fill: #ffcc4d"/>', '<path d="M5.33,9.78A.89.89,0,0,1,5.33,8a7.52,7.52,0,0,0,5.52-3.2.89.89,0,0,1,1.24-.18.9.9,0,0,1,.18,1.25A9.28,9.28,0,0,1,5.33,9.78ZM27.54,11.9a.89.89,0,1,1-1.72.42,7.51,7.51,0,0,0-4.4-4.62.89.89,0,1,1,.71-1.63A9.21,9.21,0,0,1,27.54,11.9Z" transform="translate(-0.31)" style="fill: #65471b"/>', '<path d="M20.61,26.25a3.44,3.44,0,0,1-2.48-1.19C15.63,22.4,15,23,13.85,23.94A4.24,4.24,0,0,1,11,25.3c-2.09,0-3.53-2.05-3.59-2.14a.89.89,0,0,1,1.46-1A3.21,3.21,0,0,0,11,23.52a2.76,2.76,0,0,0,1.69-.92c1.61-1.4,3.34-2.36,6.74,1.23.73.78,1.29.69,1.69.53C22.6,23.77,24,21.07,24,19.78a.89.89,0,0,1,.89-.89h0a.88.88,0,0,1,.89.88c0,1.87-1.65,5.32-4,6.24A3.26,3.26,0,0,1,20.61,26.25Z" transform="translate(-0.31)" style="fill: #664500"/>', '<path d="M13.17,13.67c-.52,1.88-1.46,2.74-2.8,2.37s-2.09-1.7-1.57-3.58,1.94-3,3.28-2.62S13.69,11.79,13.17,13.67ZM23.32,13c.42,1.9-.6,4.3-2,4.6S18.44,16.07,18,14.17s.37-3.53,1.73-3.83A3.24,3.24,0,0,1,23.32,13Z" transform="translate(-0.31)" style="fill: #65471b"/>']
    }, {
      name: "sad",
      paths: ['<path d="M16,0c20.92.09,20.92,31.91,0,32C-4.92,31.91-4.92.09,16,0Z" transform="translate(-0.31)" style="fill: #ffcc4d"/>', '<path d="M22.65,24.34c0-.16-1-3.9-6.65-3.9s-6.61,3.74-6.65,3.9a.43.43,0,0,0,.21.49.44.44,0,0,0,.53-.07s1.74-1.65,5.91-1.65,5.89,1.63,5.91,1.65a.46.46,0,0,0,.31.13.45.45,0,0,0,.43-.55Z" transform="translate(-0.31)" style="fill: #664500"/>', '<path d="M10.67,8.89c2.88-.07,2.88,6.29,0,6.22S7.79,8.82,10.67,8.89Z" transform="translate(-0.31)" style="fill: #664500"/>', '<path d="M21.33,8.89c2.88-.07,2.88,6.29,0,6.22S18.45,8.82,21.33,8.89Z" transform="translate(-0.31)" style="fill: #664500"/>']
    }, {
      name: "shocked",
      paths: ['<path d="M32,16C31.91,36.92.09,36.92,0,16,.1-4.92,31.91-4.92,32,16" transform="translate(0 -0.31)" style="fill: #ffcc4d"/>', '<path d="M16,18.67c5.76-.11,5.76,10.77,0,10.66C10.24,29.44,10.24,18.56,16,18.67Z" transform="translate(0 -0.31)" style="fill: #664500"/>', '<path d="M5.33,9.78a.89.89,0,0,1-.71-1.42,9.27,9.27,0,0,1,6.94-3.92.89.89,0,0,1,0,1.78A7.52,7.52,0,0,0,6,9.42.86.86,0,0,1,5.33,9.78Zm21.34,0A.86.86,0,0,1,26,9.42a7.49,7.49,0,0,0-5.52-3.2.89.89,0,0,1,0-1.78,9.27,9.27,0,0,1,6.94,3.92.89.89,0,0,1-.71,1.42Z" transform="translate(0 -0.31)" style="fill: #664500"/>', '<path d="M16,20.44c-1.47,0-2.67,1.6-2.67,3.56h5.34C18.67,22,17.47,20.44,16,20.44Z" transform="translate(0 -0.31)" style="fill: #f5f8fa"/>', '<path d="M10.67,9.78c2.88-.07,2.88,6.29,0,6.22S7.79,9.71,10.67,9.78Z" transform="translate(0 -0.31)" style="fill: #664500"/>', '<path d="M21.33,9.78c2.88-.07,2.88,6.29,0,6.22S18.45,9.71,21.33,9.78Z" transform="translate(0 -0.31)" style="fill: #664500"/>']
    }, {
      name: "angry",
      paths: ['<path d="M32,16C31.91,36.92.09,36.92,0,16,.1-4.92,31.91-4.92,32,16" transform="translate(0 -0.31)" style="fill: #ffcc4d"/>', '<path d="M22.65,26.56c0-.16-1-3.89-6.65-3.89S9.39,26.4,9.35,26.56a.43.43,0,0,0,.21.49.44.44,0,0,0,.53-.07s1.74-1.65,5.91-1.65S21.89,27,21.91,27a.42.42,0,0,0,.31.13.45.45,0,0,0,.43-.55ZM14,15.37c-2.89-2.89-7.54-2.93-7.74-2.93a.89.89,0,0,0,0,1.78,12.29,12.29,0,0,1,3.54.66,3.61,3.61,0,0,0-.87,2.45c0,1.72,1,3.11,2.22,3.11s2.22-1.39,2.22-3.11a3.4,3.4,0,0,0,0-.45h0A.89.89,0,0,0,14,15.37Zm11.82-2.93c-.2,0-4.85,0-7.74,2.93a.89.89,0,0,0,.63,1.52h0a3.4,3.4,0,0,0,0,.45c0,1.72,1,3.11,2.22,3.11s2.22-1.39,2.22-3.11a3.61,3.61,0,0,0-.87-2.45,12.29,12.29,0,0,1,3.54-.66.89.89,0,0,0,0-1.78Z" transform="translate(0 -0.31)" style="fill: #664500"/>']
    }, {
      name: "wondering",
      paths: ['<path d="M16.12,0c19.77.09,19.77,30.15,0,30.24C-3.65,30.15-3.65.09,16.12,0Z" transform="translate(-1.29)" style="fill: #ffcb4c"/>', '<path d="M13,18.69a.8.8,0,0,1-.28-.41.71.71,0,0,1,.52-.91,8.47,8.47,0,0,1,6.86,1.3.74.74,0,1,1-.92,1.16,6.85,6.85,0,0,0-5.5-1A.82.82,0,0,1,13,18.69Z" transform="translate(-1.29)" style="fill: #65471b"/>', '<path d="M11.78,7.56c2.45,0,2.45,4.77,0,4.72S9.33,7.51,11.78,7.56Z" transform="translate(-1.29)" style="fill: #65471b"/>', '<path d="M21.79,8.5c2.45-.05,2.45,4.78,0,4.73S19.34,8.45,21.79,8.5Z" transform="translate(-1.29)" style="fill: #65471b"/>', '<path d="M15.48,31.24s1.12-.36,1.27-1.2a.84.84,0,0,0-.56-1,1.36,1.36,0,0,0,1-1.22,1.08,1.08,0,0,0-.76-1.21,1.58,1.58,0,0,0,.9-1.37,1.49,1.49,0,0,0-.88-1.27s4.48-1.09,4.94-1.19a1.21,1.21,0,0,0,.95-1.51,1.18,1.18,0,0,0-1.51-.89L13,22.18l-1.28.29c-.48.12-.69-.09-.36-.45a3,3,0,0,0,.85-1.88,6.05,6.05,0,0,0-.39-2.5A2.83,2.83,0,0,0,10.23,16c-1-.34-1.73.29-1.37,1.39a3.46,3.46,0,0,1-.74,3.82c-2.18,1.92-3.19,3.28-2.52,6.2a5.93,5.93,0,0,0,7.07,4.49Z" transform="translate(-1.29)" style="fill: #f19020"/>', '<path d="M8.38,5.63A.84.84,0,0,1,8,5.28a.71.71,0,0,1,.35-1,8.44,8.44,0,0,1,7,0,.74.74,0,1,1-.7,1.31,6.78,6.78,0,0,0-5.58,0A.78.78,0,0,1,8.38,5.63ZM19.17,9a.85.85,0,0,1-.32-.38.71.71,0,0,1,.41-1,8.42,8.42,0,0,1,7,.5.74.74,0,1,1-.78,1.26,6.85,6.85,0,0,0-5.57-.34A.86.86,0,0,1,19.17,9Z" transform="translate(-1.29)" style="fill: #65471b"/>']
    }, {
      name: "baffled",
      paths: ['<path d="M32,16C31.91,36.92.09,36.92,0,16,.1-4.92,31.91-4.92,32,16" transform="translate(0 -0.31)" style="fill: #ffcc4d"/>', '<path d="M25.78,16c5.76-.08,5.76,9,0,8.89C20,25,20,15.92,25.78,16Z" transform="translate(0 -0.31)" style="fill: #ff7892"/>', '<path d="M6.22,16c5.77-.08,5.77,9,0,8.89C.46,25,.46,15.92,6.22,16Z" transform="translate(0 -0.31)" style="fill: #ff7892"/>', '<path d="M21.78,9.78c6.34-.09,6.34,9.87,0,9.78C15.43,19.65,15.43,9.68,21.78,9.78Z" transform="translate(0 -0.31)" style="fill: #f5f8fa"/>', '<path d="M10.22,9.78c6.35-.09,6.35,9.87,0,9.78C3.88,19.65,3.88,9.68,10.22,9.78Z" transform="translate(0 -0.31)" style="fill: #f5f8fa"/>', '<path d="M10.22,12.44c2.89,0,2.89,4.49,0,4.45S7.34,12.4,10.22,12.44Z" transform="translate(0 -0.31)" style="fill: #292f33"/>', '<path d="M21.78,12.44c2.88,0,2.88,4.49,0,4.45S18.89,12.4,21.78,12.44Z" transform="translate(0 -0.31)" style="fill: #292f33"/>', '<path d="M19.56,26.67H12.44a.89.89,0,0,1,0-1.78h7.12a.89.89,0,0,1,0,1.78ZM26.67,9.78A.86.86,0,0,1,26,9.42a7.49,7.49,0,0,0-5.52-3.2.89.89,0,0,1,0-1.78,9.27,9.27,0,0,1,6.94,3.92.89.89,0,0,1-.71,1.42Zm-21.34,0a.89.89,0,0,1-.71-1.42,9.27,9.27,0,0,1,6.94-3.92.89.89,0,0,1,0,1.78A7.52,7.52,0,0,0,6,9.42.86.86,0,0,1,5.33,9.78Z" transform="translate(0 -0.31)" style="fill: #664500"/>']
    }, {
      name: "smile",
      paths: ['<path d="M16,0c20.92.09,20.92,31.91,0,32C-4.92,31.91-4.92.09,16,0Z" transform="translate(-0.31)" style="fill: #ffcc4d"/>', '<path d="M16,18.67a37.84,37.84,0,0,1-8-.89c-.6-.12-1.78,0-1.78,1.78,0,3.55,4.09,8,9.78,8s9.78-4.45,9.78-8c0-1.78-1.18-1.9-1.78-1.78A37.84,37.84,0,0,1,16,18.67Z" transform="translate(-0.31)" style="fill: #664500"/>', '<path d="M8,19.56a28.2,28.2,0,0,0,8,.88,28.2,28.2,0,0,0,8-.88s-1.78,3.55-8,3.55S8,19.56,8,19.56Z" transform="translate(-0.31)" style="fill: #fff"/>', '<path d="M10.67,8.89c2.88-.07,2.88,6.29,0,6.22S7.79,8.82,10.67,8.89Z" transform="translate(-0.31)" style="fill: #664500"/>', '<path d="M21.33,8.89c2.88-.07,2.88,6.29,0,6.22S18.45,8.82,21.33,8.89Z" transform="translate(-0.31)" style="fill: #664500"/>']
    }, {
      name: "sleepy",
      paths: ['<path d="M31.22,15.11A15.11,15.11,0,1,1,16.11,0,15.1,15.1,0,0,1,31.22,15.11" transform="translate(-1)" style="fill: #ffcc4d"/>', '<path d="M16.11,10.67c8.07-.13,8.07,13.46,0,13.33C8,24.13,8,10.54,16.11,10.67Z" transform="translate(-1)" style="fill: #664500"/>', '<path d="M20.08,24.33a1,1,0,1,0-1.29-1.39L15.1,26.38c-.06-.18-.41-.66-.49-.84l5.12-4.77a1,1,0,1,0-1.3-1.39l-4.81,4.48c-.11-.14-.41-.48-.53-.62L18.67,18a1,1,0,1,0-1.29-1.39l-5.58,5.2-.68-.66,5.21-4.86A1,1,0,1,0,15,14.94L9.52,20.08l-.44.41-.2.18s-.47.66-1,.16l1.64-3.69a1.08,1.08,0,0,0-.44-1.48,1.06,1.06,0,0,0-1.47.44L6.16,18.55a23.72,23.72,0,0,1-1.92,2.82,6.51,6.51,0,0,0,9.49,8.88l.4-.37Z" transform="translate(-1)" style="fill: #f4900c"/>', '<path d="M9.9,5.4A6.76,6.76,0,0,0,6.74,7.23.89.89,0,0,0,8.08,8.4a5.52,5.52,0,0,1,5.16-1.33.89.89,0,1,0,.36-1.74A8.08,8.08,0,0,0,9.9,5.4Zm12.42,0a8.06,8.06,0,0,0-3.7-.08A.89.89,0,0,0,19,7.07,5.54,5.54,0,0,1,24.15,8.4a.89.89,0,0,0,1.33-1.17A6.7,6.7,0,0,0,22.32,5.41Z" transform="translate(-1)" style="fill: #664500"/>']
    }, {
      name: "tongue",
      paths: ['<path d="M16,0c20.92.09,20.92,31.91,0,32C-4.92,31.91-4.92.09,16,0Z" transform="translate(-0.31)" style="fill: #ffcc4d"/>', '<path d="M6.22,15.11a1,1,0,0,1-.4-.09.9.9,0,0,1-.39-1.2,4.72,4.72,0,0,1,4.35-2.26,4.74,4.74,0,0,1,4.35,2.26.89.89,0,0,1-1.59.81,3,3,0,0,0-2.76-1.3A3,3,0,0,0,7,14.62.9.9,0,0,1,6.22,15.11Zm19.56,0a.89.89,0,0,0,.79-1.29,4.72,4.72,0,0,0-4.35-2.26,4.74,4.74,0,0,0-4.35,2.26.89.89,0,0,0,1.59.81,3,3,0,0,1,2.76-1.3A3,3,0,0,1,25,14.62.9.9,0,0,0,25.78,15.11Zm.44,5.8a10.49,10.49,0,0,0,.42-1.14.89.89,0,0,0-1.73-.43A8.92,8.92,0,0,1,16,25.78a9,9,0,0,1-8.92-6.44.89.89,0,0,0-1.72.43A10.85,10.85,0,0,0,16,27.56,12,12,0,0,0,19.84,27,10.82,10.82,0,0,0,26.22,20.91Z" transform="translate(-0.31)" style="fill: #664500"/>', '<path d="M28.81,23.72,26.18,21s-.61-.38-1.13.51a11.78,11.78,0,0,1-3.5,3.71,10.64,10.64,0,0,1-2.4,1.17c-.65.15-.34.86-.34.86a8.73,8.73,0,0,0,.93-.27l.27.26,2.42,2.42a4.5,4.5,0,0,0,6.22,0A4.18,4.18,0,0,0,28.81,23.72Z" transform="translate(-0.31)" style="fill: #e75b70"/>', '<path d="M26.59,27.62a.48.48,0,0,0,0-.68l-3.22-3.23-.71.67,3.24,3.24A.49.49,0,0,0,26.59,27.62Z" transform="translate(-0.31)" style="fill: #de3146"/>']
    }, {
      name: "grin",
      paths: ['<path d="M32,16C31.91,36.92.09,36.92,0,16,.09-4.92,31.91-4.92,32,16" transform="translate(0 -0.31)" style="fill: #ffcc4d"/>', '<path d="M6.22,11.56c5.77-.09,5.77,9,0,8.88C.46,20.53.46,11.47,6.22,11.56Z" transform="translate(0 -0.31)" style="fill: #ff7892"/>', '<path d="M25.78,11.56c5.76-.09,5.76,9,0,8.88C20,20.53,20,11.47,25.78,11.56Z" transform="translate(0 -0.31)" style="fill: #ff7892"/>', '<path d="M24.3,19.23a.44.44,0,0,0-.57,0A14.37,14.37,0,0,1,16,21.78,14.41,14.41,0,0,1,8.27,19.2a.44.44,0,0,0-.57,0,.43.43,0,0,0-.08.55A10.17,10.17,0,0,0,16,24.44a10.17,10.17,0,0,0,8.38-4.66A.43.43,0,0,0,24.3,19.23ZM7.11,13.33a1,1,0,0,1-.4-.09.88.88,0,0,1-.39-1.19,4.7,4.7,0,0,1,4.35-2.27A4.71,4.71,0,0,1,15,12.05a.89.89,0,0,1-1.59.8,3,3,0,0,0-2.76-1.29,3,3,0,0,0-2.76,1.28A.9.9,0,0,1,7.11,13.33Zm17.78,0a.9.9,0,0,1-.8-.49,3,3,0,0,0-2.76-1.28,3,3,0,0,0-2.76,1.29.9.9,0,0,1-1.2.38A.89.89,0,0,1,17,12.05a4.71,4.71,0,0,1,4.35-2.27,4.7,4.7,0,0,1,4.35,2.27.88.88,0,0,1-.39,1.19A1,1,0,0,1,24.89,13.33Z" transform="translate(0 -0.31)" style="fill: #664500"/>']
    }, {
      name: "neutral",
      paths: ['<path d="M32,16C31.91,36.92.09,36.92,0,16,.1-4.92,31.91-4.92,32,16" transform="translate(0 -0.31)" style="fill: #ffcc4d"/>', '<path d="M22.22,23.11H9.78a.89.89,0,0,1,0-1.78H22.22a.89.89,0,0,1,0,1.78ZM13.33,16H7.11a.89.89,0,0,1,0-1.78h6.22a.89.89,0,0,1,0,1.78Zm11.56,0H18.67a.89.89,0,0,1,0-1.78h6.22a.89.89,0,1,1,0,1.78Z" transform="translate(0 -0.31)" style="fill: #664500"/>']
    }],
    chrisGannon: [{
      name: "happy",
      paths: ['<path d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0z M22,8c1.1,0,2,1.3,2,3s-0.9,3-2,3s-2-1.3-2-3S20.9,8,22,8z M10,8c1.1,0,2,1.3,2,3s-0.9,3-2,3s-2-1.3-2-3S8.9,8,10,8z M16,28c-5.2,0-9.5-4.4-10-9.9c2.9,1.7,6.4,2.7,10,2.7s7.1-1,10-2.7C25.5,23.6,21.2,28,16,28L16,28z" />']
    }, {
      name: "cool",
      paths: ['<path d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0z M16,26c-1.5,0-2.9-0.3-4.2-0.9l1-1.7c1,0.4,2.1,0.7,3.2,0.7c2.9,0,5.5-1.6,6.9-3.9l1.7,1C22.8,24.1,19.6,26,16,26L16,26z M26,12c0,1.1-0.9,2-2,2h-4c-1.1,0-2-0.9-2-2h-4c0,1.1-0.9,2-2,2H8c-1.1,0-2-0.9-2-2V9c0-0.6,0.4-1,1-1h6c0.6,0,1,0.4,1,1v1h4V9c0-0.6,0.5-1,1-1h6c0.5,0,1,0.4,1,1V12z"/>']
    }, {
      name: "evil",
      paths: ['<path d="M32,2c0-1.4-0.3-2.8-0.8-4c-1,2.4-3,4.3-5.5,5.3C23,1.2,19.7,0,16,0S9,1.2,6.3,3.3C3.8,2.3,1.9,0.4,0.8-2C0.3-0.8,0,0.6,0,2c0,2.3,0.8,4.4,2.1,6.1C0.8,10.4,0,13.1,0,16c0,8.8,7.2,16,16,16s16-7.2,16-16c0-2.9-0.8-5.6-2.1-7.9C31.2,6.4,32,4.3,32,2z M18,11.9c0.1-1.5,1.4-2.5,2.5-3C21.6,8.3,22.7,8,22.8,8c0.5-0.1,1.1,0.2,1.2,0.7s-0.2,1.1-0.7,1.2c-0.6,0.1-1.2,0.4-1.8,0.7C21.8,11,22,11.5,22,12c0,1.1-0.9,2-2,2s-2-0.9-2-2C18,12,18,11.9,18,11.9L18,11.9z M8,8.8C8.2,8.2,8.7,7.9,9.2,8c0,0,1.1,0.3,2.2,0.8c1.1,0.6,2.5,1.6,2.6,3c0,0,0,0.1,0,0.1c0,1.1-0.9,2-2,2s-2-0.9-2-2c0-0.5,0.2-1,0.5-1.4C10,10.4,9.3,10.1,8.8,10C8.2,9.8,7.9,9.3,8,8.8L8,8.8z M16,26c-3.6,0-6.8-1.9-8.6-4.9l2.6-1.5c1.2,2,3.5,3.4,6,3.4s4.8-1.4,6-3.4l2.6,1.5C22.8,24.1,19.6,26,16,26z"/>']
    }, {
      name: "confused",
      paths: ['<path d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0z M22,8c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S20.9,8,22,8z M10,8c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S8.9,8,10,8z M21.5,25.3c-2.6,0.9-5.5-0.4-6.4-3c-0.6-1.6-2.3-2.4-3.8-1.8c-1.4,0.5-2.2,2-1.9,3.5h-2c-0.3-2.3,1-4.5,3.2-5.3c2.6-0.9,5.5,0.4,6.4,3c0.6,1.6,2.3,2.4,3.8,1.8c1.4-0.5,2.2-2,1.9-3.5h2C25,22.3,23.7,24.5,21.5,25.3z"/>']
    }, {
      name: "sad",
      paths: ['<path d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0z M22,8c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S20.9,8,22,8z M10,8c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S8.9,8,10,8z M22,24.4c-1.2-2-3.5-3.4-6-3.4s-4.8,1.4-6,3.4l-2.6-1.5C9.2,19.9,12.4,18,16,18s6.8,1.9,8.6,4.9L22,24.4z"/>']
    }, {
      name: "shocked",
      paths: ['<path d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0z M10,14c-1.1,0-2-1.3-2-3s0.9-3,2-3s2,1.3,2,3S11.1,14,10,14z M16,26c-2.2,0-4-1.8-4-4s1.8-4,4-4s4,1.8,4,4S18.2,26,16,26z M22,14c-1.1,0-2-1.3-2-3s0.9-3,2-3s2,1.3,2,3S23.1,14,22,14z"/>']
    }, {
      name: "angry",
      paths: ['<path d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0z M18,11.9c0.1-1.5,1.4-2.5,2.5-3C21.6,8.3,22.7,8,22.8,8c0.5-0.1,1.1,0.2,1.2,0.7s-0.2,1.1-0.7,1.2c-0.6,0.1-1.2,0.4-1.8,0.7C21.8,11,22,11.5,22,12c0,1.1-0.9,2-2,2s-2-0.9-2-2C18,12,18,11.9,18,11.9L18,11.9z M8,8.8C8.2,8.2,8.7,7.9,9.2,8c0,0,1.1,0.3,2.2,0.8c1.1,0.6,2.5,1.6,2.6,3c0,0,0,0.1,0,0.1c0,1.1-0.9,2-2,2s-2-0.9-2-2c0-0.5,0.2-1,0.5-1.4C10,10.4,9.3,10.1,8.8,10C8.2,9.8,7.9,9.3,8,8.8L8,8.8z M22,24.4c-1.2-2-3.5-3.4-6-3.4s-4.8,1.4-6,3.4l-2.6-1.5C9.2,19.9,12.4,18,16,18s6.8,1.9,8.6,4.9L22,24.4z"/>']
    }, {
      name: "wondering",
      paths: ['<path d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0z M22,8c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S20.9,8,22,8z M8,10c0-1.1,0.9-2,2-2s2,0.9,2,2s-0.9,2-2,2S8,11.1,8,10z M10.4,25.2l-0.7-2.4l13.7-4l0.7,2.4L10.4,25.2z"/>']
    }, {
      name: "baffled",
      paths: ['<path d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0z M8,13c0-1.7,1.3-3,3-3s3,1.3,3,3s-1.3,3-3,3S8,14.7,8,13z M20,24h-8v-2h8V24z M21,16c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S22.7,16,21,16z M12,13c0,0.6-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S12,12.4,12,13z M22,13c0,0.6-0.4,1-1,1s-1-0.4-1-1s0.4-1,1-1S22,12.4,22,13z"/>']
    }, {
      name: "smile",
      paths: ['<path d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0z M22,8c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S20.9,8,22,8z M10,8c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S8.9,8,10,8z M16,26c-3.6,0-6.8-1.9-8.6-4.9l2.6-1.5c1.2,2,3.5,3.4,6,3.4s4.8-1.4,6-3.4l2.6,1.5C22.8,24.1,19.6,26,16,26z",/>']
    }, {
      name: "sleepy",
      paths: ['<path d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0z M9.7,10.3c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4c1.4-1.4,4-1.4,5.4,0c0.4,0.4,0.4,1,0,1.4c-0.2,0.2-0.5,0.3-0.7,0.3s-0.5-0.1-0.7-0.3C11.7,9.7,10.3,9.7,9.7,10.3z M16,26c-2.2,0-4-2.2-4-5s1.8-5,4-5s4,2.2,4,5S18.2,26,16,26z M23.7,10.3c-0.2,0.2-0.5,0.3-0.7,0.3s-0.5-0.1-0.7-0.3c-0.6-0.6-2-0.6-2.6,0c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4c1.4-1.4,4-1.4,5.4,0C24.1,9.3,24.1,9.9,23.7,10.3z"/>']
    }, {
      name: "tongue",
      paths: ['<path d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0z M10,8c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S8.9,8,10,8z M24,20h-2v3c0,1.7-1.3,3-3,3s-3-1.3-3-3v-3H8v-2h16V20z M22,12c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S23.1,12,22,12z"/>']
    }, {
      name: "grin",
      paths: ['<path d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0z M22,7.4c2,0,3.6,1.6,3.6,3.6c0,0.2,0,0.4-0.1,0.6c-0.1,0.3-0.3,0.5-0.6,0.5s-0.6-0.2-0.6-0.5c-0.2-1.1-1.2-1.7-2.3-1.7s-2.1,0.5-2.3,1.7c0,0.3-0.3,0.5-0.6,0.5l0,0c-0.3,0-0.6-0.2-0.6-0.5c0-0.2-0.1-0.4-0.1-0.6C18.4,9,20,7.4,22,7.4L22,7.4z M10,7.4c2,0,3.6,1.6,3.6,3.6c0,0.2,0,0.4-0.1,0.6c-0.1,0.3-0.3,0.5-0.6,0.5s-0.6-0.2-0.6-0.5c-0.2-1.1-1.2-1.7-2.3-1.7s-2.1,0.5-2.3,1.7c-0.1,0.3-0.3,0.5-0.6,0.5l0,0c-0.3,0-0.6-0.2-0.6-0.5c0-0.2-0.1-0.4-0.1-0.6C6.4,9,8,7.4,10,7.4L10,7.4z M6,18h6v7.7C8.6,24.9,6,21.7,6,18z M14,26v-8h4v8H14zM20,25.7V18h6C26,21.7,23.4,24.9,20,25.7z"/>']
    }, {
      name: "neutral",
      paths: ['<path d="M16,0C7.2,0,0,7.2,0,16s7.2,16,16,16s16-7.2,16-16S24.8,0,16,0z M20,24h-8v-2h8V24z M22,8c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S20.9,8,22,8z M10,8c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S8.9,8,10,8z"/>']
    }]
  };
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.createIconPathsMarkup = void 0, e.createIconPathsMarkup = function (t) {
    return {
      __html: t.length && t.map(function (t) {
        return t;
      })
    };
  };
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = n(7);
  Object.defineProperty(e, "SvgBubbleSlider", {
    enumerable: !0,
    get: function get() {
      return r.SvgBubbleSlider;
    }
  });
  var i = n(15);
  Object.defineProperty(e, "SvgIcon", {
    enumerable: !0,
    get: function get() {
      return i.SvgIcon;
    }
  });
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = n(8);
  Object.defineProperty(e, "SvgBubbleSlider", {
    enumerable: !0,
    get: function get() {
      return r.SvgBubbleSlider;
    }
  });
}, function (t, e, n) {
  "use strict";

  var r = this && this.__createBinding || (Object.create ? function (t, e, n, r) {
    void 0 === r && (r = n), Object.defineProperty(t, r, {
      enumerable: !0,
      get: function get() {
        return e[n];
      }
    });
  } : function (t, e, n, r) {
    void 0 === r && (r = n), t[r] = e[n];
  }),
      i = this && this.__setModuleDefault || (Object.create ? function (t, e) {
    Object.defineProperty(t, "default", {
      enumerable: !0,
      value: e
    });
  } : function (t, e) {
    t["default"] = e;
  }),
      a = this && this.__importStar || function (t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for (var n in t) {
      "default" !== n && Object.hasOwnProperty.call(t, n) && r(e, t, n);
    }
    return i(e, t), e;
  },
      o = this && this.__importDefault || function (t) {
    return t && t.__esModule ? t : {
      "default": t
    };
  };

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.SvgBubbleSlider = void 0;
  var s = a(n(0)),
      l = n(2),
      u = o(n(3)),
      c = n(9);
  e.SvgBubbleSlider = s.memo(function (t) {
    var e = t.children,
        n = t.primaryColor,
        r = void 0 === n ? u["default"].colors.primary : n,
        i = t.secondaryColor,
        a = void 0 === i ? u["default"].colors.background : i,
        o = t.icons,
        f = t.showSpeechBubble,
        h = void 0 === f || f,
        d = t.scale,
        p = void 0 === d ? 1 : d,
        g = t.iconSet,
        m = void 0 === g ? l.IconSetOptions.chrisGannon : g,
        _ = s.useState(""),
        v = _[0],
        y = _[1];

    return s["default"].createElement(s.Fragment, null, s["default"].createElement("div", {
      className: "react-svg-bubble-slider",
      style: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        position: "relative",
        width: "100%"
      }
    }, s["default"].createElement(c.Timeline, {
      onAnimationComplete: function onAnimationComplete(t) {
        return y(t);
      },
      primaryColor: r,
      secondaryColor: a,
      icons: o,
      showSpeechBubble: h,
      scale: p,
      iconSet: m
    })), s["default"].createElement("div", {
      className: "svg-bubble-action"
    }, e && e({
      reaction: v
    })));
  }), e.SvgBubbleSlider.displayName = "SvgBubbleSlider";
}, function (t, e, n) {
  "use strict";

  var r = this && this.__createBinding || (Object.create ? function (t, e, n, r) {
    void 0 === r && (r = n), Object.defineProperty(t, r, {
      enumerable: !0,
      get: function get() {
        return e[n];
      }
    });
  } : function (t, e, n, r) {
    void 0 === r && (r = n), t[r] = e[n];
  }),
      i = this && this.__setModuleDefault || (Object.create ? function (t, e) {
    Object.defineProperty(t, "default", {
      enumerable: !0,
      value: e
    });
  } : function (t, e) {
    t["default"] = e;
  }),
      a = this && this.__importStar || function (t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for (var n in t) {
      "default" !== n && Object.hasOwnProperty.call(t, n) && r(e, t, n);
    }
    return i(e, t), e;
  },
      o = this && this.__spreadArrays || function () {
    for (var t = 0, e = 0, n = arguments.length; e < n; e++) {
      t += arguments[e].length;
    }

    var r = Array(t),
        i = 0;

    for (e = 0; e < n; e++) {
      for (var a = arguments[e], o = 0, s = a.length; o < s; o++, i++) {
        r[i] = a[o];
      }
    }

    return r;
  };

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Timeline = void 0;
  var s = a(n(0)),
      l = n(1),
      u = n(17),
      c = n(18),
      f = n(4),
      h = n(10),
      d = n(12),
      p = n(13),
      g = n(14);
  e.Timeline = s.memo(function (t) {
    var e = t.onAnimationComplete,
        n = t.primaryColor,
        r = t.secondaryColor,
        i = t.icons,
        a = t.showSpeechBubble,
        m = t.scale,
        _ = t.iconSet,
        v = s.useRef(null),
        y = s.useRef(null),
        x = s.useRef(null),
        b = [],
        w = [],
        M = s.useState(i ? f.iconPaths[_].map(function (t) {
      return t;
    }).filter(function (t) {
      return i.includes(t.name);
    }).sort(function (t, e) {
      return i.indexOf(t.name) - i.indexOf(e.name);
    }) : f.iconPaths[_])[0],
        T = s.useState(!1),
        S = T[0],
        C = T[1],
        k = s.useState(!0),
        O = k[0],
        P = k[1],
        A = s.useState(0),
        E = A[0],
        D = A[1],
        L = s.useState([]),
        z = L[0],
        N = L[1],
        B = s.useState({
      timeline: l.gsap.timeline({
        paused: !0
      })
    }),
        R = B[0],
        F = B[1],
        Y = s.useState({
      index: 0,
      name: ""
    }),
        X = Y[0],
        I = Y[1],
        j = 60 * -(M.length - 1),
        Z = 60 * M.length - 32,
        W = a ? 290 : 120,
        H = a ? 215 : 45,
        V = Z * m,
        U = W * m;
    if (M.length < 3) throw new Error("You must have at lease three icons");

    var G = 0,
        q = function q() {
      S && (D(Number(l.gsap.getProperty(y.current, "x"))), G = Number(l.gsap.getProperty(y.current, "x")));
    },
        Q = function Q() {
      S && (P(!0), I({
        index: null,
        name: ""
      }), e(""));
    },
        K = function K() {
      var t = Math.abs(G / 60),
          n = M[Math.abs(t)].name;
      S && (P(!1), I({
        index: t,
        name: n
      }), e(n));
    },
        $ = function $(t, e, n) {
      O || l.gsap.to([y.current, x.current], {
        duration: e,
        x: z[t],
        onStart: Q,
        onUpdate: q,
        onComplete: K,
        ease: n
      });
    };

    return s.useEffect(function () {
      l.gsap.registerPlugin(u.Draggable, c.InertiaPlugin), M.map(function (t, e) {
        N(function (t) {
          return o(t, [60 * -e]);
        }), l.gsap.set(b[e], {
          transformOrigin: "50% 50%",
          scale: 0
        }), F({
          timeline: R.timeline.add(l.gsap.timeline().to(w[e], {
            duration: 1,
            attr: {
              r: 48
            },
            ease: "linear"
          }).to(b[e], {
            duration: 1,
            alpha: 1,
            scale: 2,
            ease: "linear"
          }, "-=1").to(w[e], {
            duration: 1,
            attr: {
              r: 10
            },
            ease: "linear"
          }).to(b[e], {
            duration: 1,
            alpha: 0,
            scale: 0,
            ease: "linear"
          }, "-=1"), e / 2)
        });
      }), C(!0), P(!1);
    }, []), s.useEffect(function () {
      var t = u.Draggable.create(y.current, {
        type: "x",
        bounds: {
          minX: j,
          maxX: 0,
          minY: 0,
          maxY: 0
        },
        onStart: Q,
        onDrag: q,
        onDragStart: Q,
        onThrowUpdate: q,
        onThrowComplete: K,
        inertia: !0,
        minDuration: 1,
        snap: z,
        overshootTolerance: 0,
        dragClickables: !0
      })[0].disable();
      S && (t.enable(), $(Math.floor(M.length / 2), 2, "elastic(1, 0.88)"));
    }, [S]), s.useEffect(function () {
      S && (l.gsap.to(R.timeline, {
        duration: .5,
        time: E / j * (R.timeline.duration() - 2) + 1,
        ease: "elastic(2, 0.75)"
      }), l.gsap.set(x.current, {
        x: E
      }));
    }, [E]), s.useEffect(function () {
      return function () {
        C(!1);
      };
    }, []), s["default"].createElement("div", {
      className: "svg-timeline",
      onKeyDown: function onKeyDown(t) {
        return function (t) {
          var e = t.key;
          ("ArrowRight" === e && X.index < M.length - 1 || "ArrowUp" === e && X.index < M.length - 1) && (t.preventDefault(), $(X.index += 1, .8, "power1")), "Home" === e && X.index > 0 && (t.preventDefault(), $(0, .8, "power1")), ("ArrowLeft" === e && X.index > 0 || "ArrowDown" === e && X.index > 0) && (t.preventDefault(), $(X.index -= 1, .8, "power1")), "End" === e && X.index < M.length - 1 && (t.preventDefault(), $(M.length - 1, .8, "power1"));
        }(t);
      },
      style: {
        alignItems: "center",
        display: "flex",
        justifyContent: "center",
        margin: "auto",
        position: "relative",
        overflow: "hidden",
        width: "100%"
      },
      role: "slider",
      "aria-valuemin": 0,
      "aria-valuemax": M.length - 1,
      "aria-valuenow": X.index,
      "aria-valuetext": X.name,
      tabIndex: 0
    }, s["default"].createElement("div", {
      style: {
        display: "flex",
        margin: "auto"
      }
    }, s["default"].createElement("svg", {
      ref: v,
      width: V,
      height: U,
      viewBox: "0,0, " + Z + "," + W,
      style: {
        minWidth: 280
      }
    }, s["default"].createElement(g.Defs, null), a && S && s["default"].createElement(s.Fragment, null, s["default"].createElement(h.PopLines, {
      viewBoxWidth: Z,
      isAnimating: O,
      currentReaction: X.name,
      primaryColor: n
    }), s["default"].createElement(d.SpeechBubble, {
      viewBoxWidth: Z,
      isAnimating: O,
      currentReaction: X.name,
      primaryColor: n,
      secondaryColor: r
    })), s["default"].createElement("g", {
      transform: "matrix(1,0,0,1," + Z / 2 + " " + H + ")"
    }, s["default"].createElement("g", {
      ref: y,
      filter: "url(#goo)",
      style: {
        cursor: O ? "not-allowed" : "move",
        pointerEvents: O ? "none" : "initial"
      }
    }, s["default"].createElement("rect", {
      width: Z,
      transform: "matrix(1,0,0,1,-20,-64)",
      style: {
        fill: "rgba(0, 0, 0, 0)",
        height: "100%"
      }
    }), M.map(function (t, e) {
      var r = t.name;
      return s["default"].createElement("circle", {
        ref: function ref(t) {
          w.push(t);
        },
        key: e,
        className: "reaction-dot",
        cx: 60 * e,
        cy: 16,
        r: 10,
        fill: n,
        id: "dot-" + r + "-" + e,
        onClick: function onClick() {
          e !== X.index && $(e, .8, "power1");
        },
        style: {
          WebkitTapHighlightColor: "transparent",
          cursor: O ? "not-allowed" : X.index === e ? "move" : "pointer"
        }
      });
    })), s["default"].createElement("g", {
      ref: x
    }, M.map(function (t, e) {
      var n = t.name,
          i = t.paths;
      return s["default"].createElement("g", {
        ref: function ref(t) {
          b.push(t);
        },
        key: e,
        className: "reaction-icon",
        fill: r,
        id: "icon-" + n + "-" + e,
        "data-index": e,
        opacity: 0,
        transform: "matrix(1,0,0,1," + (60 * e - 16) + ",0)",
        style: {
          pointerEvents: "none"
        }
      }, s["default"].createElement(p.Path, {
        paths: i
      }));
    }))))));
  }), e.Timeline.displayName = "Timeline";
}, function (t, e, n) {
  "use strict";

  var r = this && this.__assign || function () {
    return (r = Object.assign || function (t) {
      for (var e, n = 1, r = arguments.length; n < r; n++) {
        for (var i in e = arguments[n]) {
          Object.prototype.hasOwnProperty.call(e, i) && (t[i] = e[i]);
        }
      }

      return t;
    }).apply(this, arguments);
  },
      i = this && this.__createBinding || (Object.create ? function (t, e, n, r) {
    void 0 === r && (r = n), Object.defineProperty(t, r, {
      enumerable: !0,
      get: function get() {
        return e[n];
      }
    });
  } : function (t, e, n, r) {
    void 0 === r && (r = n), t[r] = e[n];
  }),
      a = this && this.__setModuleDefault || (Object.create ? function (t, e) {
    Object.defineProperty(t, "default", {
      enumerable: !0,
      value: e
    });
  } : function (t, e) {
    t["default"] = e;
  }),
      o = this && this.__importStar || function (t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for (var n in t) {
      "default" !== n && Object.hasOwnProperty.call(t, n) && i(e, t, n);
    }
    return a(e, t), e;
  };

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.PopLines = void 0;
  var s = o(n(0)),
      l = n(1),
      u = n(11);
  l.gsap.registerPlugin(u.DrawSVGPlugin);
  var c = [{
    x1: "107.923",
    y1: "21.37",
    x2: "116.935",
    y2: "4"
  }, {
    x1: "59.335",
    y1: "24.909",
    x2: "50.5",
    y2: "8.057"
  }, {
    x1: "21.789",
    y1: "56.11",
    x2: "4",
    y2: "53.67"
  }, {
    x1: "26.782",
    y1: "98.86",
    x2: "8.057",
    y2: "108.34"
  }, {
    x1: "65.885",
    y1: "125.86",
    x2: "56.43",
    y2: "145.37"
  }, {
    x1: "112.429",
    y1: "121.342",
    x2: "121.03",
    y2: "142.564"
  }, {
    x1: "147.535",
    y1: "93.82",
    x2: "168.155",
    y2: "101.45"
  }, {
    x1: "149.742",
    y1: "49.01",
    x2: "168.155",
    y2: "42.56"
  }];
  e.PopLines = s.memo(function (t) {
    var e = t.primaryColor,
        n = t.viewBoxWidth,
        i = t.currentReaction,
        a = t.isAnimating,
        o = s.useRef(null),
        u = [];
    return s.useEffect(function () {
      u.map(function (t, e) {
        i.length && a ? l.gsap.to(u[e], .2, {
          scale: 2,
          drawSVG: "100% 100%",
          ease: "linear"
        }) : l.gsap.set(u[e], {
          transformOrigin: "50% 50%",
          drawSVG: "0% 100%",
          scale: 0
        });
      });
    }, [i, a]), s.useEffect(function () {
      l.gsap.set(o.current, {
        visibility: "visible"
      });
    }, []), s["default"].createElement("g", {
      ref: o,
      fill: "none",
      stroke: e,
      strokeWidth: "4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: "10",
      transform: "matrix(1,0,0,1," + (n / 2 - 88) + ",15)",
      style: {
        visibility: "hidden"
      }
    }, c.map(function (t, e) {
      return s["default"].createElement("line", r({
        className: "speech-bubble-pop-line",
        ref: function ref(t) {
          return u.push(t);
        },
        key: e
      }, t));
    }));
  }), e.PopLines.displayName = "PopLines";
}, function (t, e, n) {
  "use strict";

  n.r(e), n.d(e, "DrawSVGPlugin", function () {
    return w;
  }), n.d(e, "default", function () {
    return w;
  });
  /*!
   * DrawSVGPlugin 3.2.6
   * https://greensock.com
   *
   * @license Copyright 2008-2020, GreenSock. All rights reserved.
   * Subject to the terms at https://greensock.com/standard-license or for
   * Club GreenSock members, the agreement issued with that membership.
   * @author: Jack Doyle, jack@greensock.com
   */

  var r,
      i,
      a,
      o,
      s,
      l = function l() {
    return "undefined" != typeof window;
  },
      u = function u() {
    return r || l() && (r = window.gsap) && r.registerPlugin && r;
  },
      c = /[-+=\.]*\d+[\.e\-\+]*\d*[e\-\+]*\d*/gi,
      f = {
    rect: ["width", "height"],
    circle: ["r", "r"],
    ellipse: ["rx", "ry"],
    line: ["x2", "y2"]
  },
      h = function h(t) {
    return Math.round(1e4 * t) / 1e4;
  },
      d = function d(t) {
    return parseFloat(t || 0);
  },
      p = function p(t, e) {
    return d(t.getAttribute(e));
  },
      g = Math.sqrt,
      m = function m(t, e, n, r, i, a) {
    return g(Math.pow((d(n) - d(t)) * i, 2) + Math.pow((d(r) - d(e)) * a, 2));
  },
      _ = function _(t) {
    return console.warn(t);
  },
      v = function v(t) {
    return "non-scaling-stroke" === t.getAttribute("vector-effect");
  },
      y = function y(t) {
    if (!(t = i(t)[0])) return 0;
    var e,
        n,
        r,
        a,
        o,
        s,
        l,
        u = t.tagName.toLowerCase(),
        h = t.style,
        d = 1,
        y = 1;
    v(t) && (y = t.getScreenCTM(), d = g(y.a * y.a + y.b * y.b), y = g(y.d * y.d + y.c * y.c));

    try {
      n = t.getBBox();
    } catch (t) {
      _("Some browsers won't measure invisible elements (like display:none or masks inside defs).");
    }

    var x = n || {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    },
        b = x.x,
        w = x.y,
        M = x.width,
        T = x.height;
    if (n && (M || T) || !f[u] || (M = p(t, f[u][0]), T = p(t, f[u][1]), "rect" !== u && "line" !== u && (M *= 2, T *= 2), "line" === u && (b = p(t, "x1"), w = p(t, "y1"), M = Math.abs(M - b), T = Math.abs(T - w))), "path" === u) a = h.strokeDasharray, h.strokeDasharray = "none", e = t.getTotalLength() || 0, d !== y && _("Warning: <path> length cannot be measured when vector-effect is non-scaling-stroke and the element isn't proportionally scaled."), e *= (d + y) / 2, h.strokeDasharray = a;else if ("rect" === u) e = 2 * M * d + 2 * T * y;else if ("line" === u) e = m(b, w, b + M, w + T, d, y);else if ("polyline" === u || "polygon" === u) for (r = t.getAttribute("points").match(c) || [], "polygon" === u && r.push(r[0], r[1]), e = 0, o = 2; o < r.length; o += 2) {
      e += m(r[o - 2], r[o - 1], r[o], r[o + 1], d, y) || 0;
    } else "circle" !== u && "ellipse" !== u || (s = M / 2 * d, l = T / 2 * y, e = Math.PI * (3 * (s + l) - g((3 * s + l) * (s + 3 * l))));
    return e || 0;
  },
      x = function x(t, e) {
    if (!(t = i(t)[0])) return [0, 0];
    e || (e = y(t) + 1);
    var n = a.getComputedStyle(t),
        r = n.strokeDasharray || "",
        o = d(n.strokeDashoffset),
        s = r.indexOf(",");
    return s < 0 && (s = r.indexOf(" ")), (r = s < 0 ? e : d(r.substr(0, s)) || 1e-5) > e && (r = e), [Math.max(0, -o), Math.max(0, r - o)];
  },
      b = function b() {
    l() && (document, a = window, s = r = u(), i = r.utils.toArray, o = -1 !== ((a.navigator || {}).userAgent || "").indexOf("Edge"));
  },
      w = {
    version: "3.2.6",
    name: "drawSVG",
    register: function register(t) {
      r = t, b();
    },
    init: function init(t, e, n, r, i) {
      if (!t.getBBox) return !1;
      s || b();
      var l,
          u,
          c,
          f,
          p = y(t) + 1;
      return this._style = t.style, this._target = t, e + "" == "true" ? e = "0 100%" : e ? -1 === (e + "").indexOf(" ") && (e = "0 " + e) : e = "0 0", u = function (t, e, n) {
        var r,
            i,
            a = t.indexOf(" ");
        return a < 0 ? (r = void 0 !== n ? n + "" : t, i = t) : (r = t.substr(0, a), i = t.substr(a + 1)), (r = ~r.indexOf("%") ? d(r) / 100 * e : d(r)) > (i = ~i.indexOf("%") ? d(i) / 100 * e : d(i)) ? [i, r] : [r, i];
      }(e, p, (l = x(t, p))[0]), this._length = h(p + 10), 0 === l[0] && 0 === u[0] ? (c = Math.max(1e-5, u[1] - p), this._dash = h(p + c), this._offset = h(p - l[1] + c), this._offsetPT = this.add(this, "_offset", this._offset, h(p - u[1] + c))) : (this._dash = h(l[1] - l[0]) || 1e-6, this._offset = h(-l[0]), this._dashPT = this.add(this, "_dash", this._dash, h(u[1] - u[0]) || 1e-5), this._offsetPT = this.add(this, "_offset", this._offset, h(-u[0]))), o && (f = a.getComputedStyle(t)).strokeLinecap !== f.strokeLinejoin && (u = d(f.strokeMiterlimit), this.add(t.style, "strokeMiterlimit", u, u + .01)), this._live = v(t) || ~(e + "").indexOf("live"), this._props.push("drawSVG"), 1;
    },
    render: function render(t, e) {
      var n,
          r,
          i,
          a,
          o = e._pt,
          s = e._style;

      if (o) {
        for (e._live && (n = y(e._target) + 11) !== e._length && (r = n / e._length, e._length = n, e._offsetPT.s *= r, e._offsetPT.c *= r, e._dashPT ? (e._dashPT.s *= r, e._dashPT.c *= r) : e._dash *= r); o;) {
          o.r(t, o.d), o = o._next;
        }

        i = e._dash, a = e._offset, n = e._length, s.strokeDashoffset = e._offset, 1 !== t && t ? s.strokeDasharray = i + "px," + n + "px" : (i - a < .001 && n - i <= 10 && (s.strokeDashoffset = a + 1), s.strokeDasharray = a < .001 && n - i <= 10 ? "none" : a === i ? "0px, 999999px" : i + "px," + n + "px");
      }
    },
    getLength: y,
    getPosition: x
  };

  u() && r.registerPlugin(w);
}, function (t, e, n) {
  "use strict";

  var r = this && this.__createBinding || (Object.create ? function (t, e, n, r) {
    void 0 === r && (r = n), Object.defineProperty(t, r, {
      enumerable: !0,
      get: function get() {
        return e[n];
      }
    });
  } : function (t, e, n, r) {
    void 0 === r && (r = n), t[r] = e[n];
  }),
      i = this && this.__setModuleDefault || (Object.create ? function (t, e) {
    Object.defineProperty(t, "default", {
      enumerable: !0,
      value: e
    });
  } : function (t, e) {
    t["default"] = e;
  }),
      a = this && this.__importStar || function (t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for (var n in t) {
      "default" !== n && Object.hasOwnProperty.call(t, n) && r(e, t, n);
    }
    return i(e, t), e;
  };

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.SpeechBubble = void 0;
  var o = a(n(0)),
      s = n(1);
  e.SpeechBubble = o.memo(function (t) {
    var e = t.primaryColor,
        n = t.secondaryColor,
        r = t.viewBoxWidth,
        i = t.currentReaction,
        a = t.isAnimating,
        l = o.useRef(null),
        u = o.useState({
      timeline: s.gsap.timeline({
        paused: !0
      })
    })[0];
    return o.useEffect(function () {
      u.timeline.set(l.current, {
        rotation: 45,
        visibility: "hidden",
        scale: 0,
        y: 80,
        transformOrigin: "50% 100%"
      }).to(l.current, .9, {
        rotation: 0,
        visibility: "visible",
        ease: "elastic(1, 0.6)",
        scale: .9,
        y: 45
      }).to(l.current, .6, {
        ease: "easltic(1, 0.6)",
        scale: 1
      }, "-=1");
    }, []), o.useEffect(function () {
      a ? u.timeline.pause() && u.timeline.seek(0) : u.timeline.play();
    }, [a]), o["default"].createElement("g", {
      ref: l,
      style: {
        pointerEvents: "none",
        visibility: "hidden"
      },
      transform: "matrix(0.8,0,0,0.8," + (r / 2 - 68) + ",80)"
    }, o["default"].createElement("path", {
      className: "speech-bubble-stroke",
      stroke: e,
      strokeWidth: "14",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: "10",
      d: "\n\t\tM69.361,112.063l16.377,28.99l16.562-28.94c37.277-5.125,65.195-27.13,65.195-53.494C167.496,28.456,130.766,4,85.515,4\n\t\tC40.275,4,4,28.456,4,58.619c0,26.291,27.361,48.249,65.361,53.448V112.063z"
    }), o["default"].createElement("path", {
      className: "speech-bubble-fill",
      d: "M69.361,109.063l16.377,28.99l16.562-28.94\n\t\tc37.277-5.125,65.195-27.13,65.195-53.494C167.496,25.456,130.766,1,85.515,1C40.275,1,4,25.456,4,55.619\n    c0,26.291,27.361,48.249,65.361,53.448V109.063z",
      fill: n
    }), o["default"].createElement("text", {
      className: "speech-bubble-text",
      x: "85",
      y: "67",
      fill: e,
      style: {
        textAnchor: "middle"
      }
    }, i));
  }), e.SpeechBubble.displayName = "SpeechBubble";
}, function (t, e, n) {
  "use strict";

  var r = this && this.__createBinding || (Object.create ? function (t, e, n, r) {
    void 0 === r && (r = n), Object.defineProperty(t, r, {
      enumerable: !0,
      get: function get() {
        return e[n];
      }
    });
  } : function (t, e, n, r) {
    void 0 === r && (r = n), t[r] = e[n];
  }),
      i = this && this.__setModuleDefault || (Object.create ? function (t, e) {
    Object.defineProperty(t, "default", {
      enumerable: !0,
      value: e
    });
  } : function (t, e) {
    t["default"] = e;
  }),
      a = this && this.__importStar || function (t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for (var n in t) {
      "default" !== n && Object.hasOwnProperty.call(t, n) && r(e, t, n);
    }
    return i(e, t), e;
  };

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Path = void 0;
  var o = a(n(0)),
      s = n(5);
  e.Path = o.memo(function (t) {
    var e = t.paths;
    return o["default"].createElement("g", {
      dangerouslySetInnerHTML: s.createIconPathsMarkup(e)
    });
  }), e.Path.displayName = "Path";
}, function (t, e, n) {
  "use strict";

  var r = this && this.__createBinding || (Object.create ? function (t, e, n, r) {
    void 0 === r && (r = n), Object.defineProperty(t, r, {
      enumerable: !0,
      get: function get() {
        return e[n];
      }
    });
  } : function (t, e, n, r) {
    void 0 === r && (r = n), t[r] = e[n];
  }),
      i = this && this.__setModuleDefault || (Object.create ? function (t, e) {
    Object.defineProperty(t, "default", {
      enumerable: !0,
      value: e
    });
  } : function (t, e) {
    t["default"] = e;
  }),
      a = this && this.__importStar || function (t) {
    if (t && t.__esModule) return t;
    var e = {};
    if (null != t) for (var n in t) {
      "default" !== n && Object.hasOwnProperty.call(t, n) && r(e, t, n);
    }
    return i(e, t), e;
  };

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.Defs = void 0;
  var o = a(n(0));
  e.Defs = o.memo(function () {
    return o["default"].createElement("defs", null, o["default"].createElement("filter", {
      id: "goo",
      colorInterpolationFilters: "sRGB"
    }, o["default"].createElement("feGaussianBlur", {
      "in": "SourceGraphic",
      stdDeviation: "8",
      result: "blur"
    }), o["default"].createElement("feColorMatrix", {
      "in": "blur",
      mode: "matrix",
      values: "1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 31 -12",
      result: "cm"
    })));
  }), e.Defs.displayName = "Defs";
}, function (t, e, n) {
  "use strict";

  Object.defineProperty(e, "__esModule", {
    value: !0
  });
  var r = n(16);
  Object.defineProperty(e, "SvgIcon", {
    enumerable: !0,
    get: function get() {
      return r.SvgIcon;
    }
  });
}, function (t, e, n) {
  "use strict";

  var r = this && this.__importDefault || function (t) {
    return t && t.__esModule ? t : {
      "default": t
    };
  };

  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.SvgIcon = void 0;
  var i = r(n(0)),
      a = n(2),
      o = n(4),
      s = n(5),
      l = r(n(3));
  e.SvgIcon = function (t) {
    var e = t.name,
        n = t.size,
        r = void 0 === n ? 32 : n,
        u = t.color,
        c = void 0 === u ? l["default"].colors.primary : u,
        f = t.iconSet,
        h = void 0 === f ? a.IconSetOptions.chrisGannon : f;
    if (r < 32) throw new Error("Icon size must be at least 32");
    return i["default"].createElement("svg", {
      className: "svg-icon",
      xmlns: "http://www.w3.org/2000/svg",
      width: r,
      height: r,
      color: c,
      fill: "currentcolor",
      viewBox: "0 0 32 32",
      preserveAspectRatio: "xMidYMid meet",
      x: "0",
      y: "0"
    }, o.iconPaths[h].filter(function (t) {
      return t.name === e;
    }).map(function (t, e) {
      var n = t.paths;
      return i["default"].createElement("g", {
        key: e,
        dangerouslySetInnerHTML: s.createIconPathsMarkup(n),
        fill: "currentcolor"
      });
    }));
  }, e.SvgIcon.displayName = "SvgIcon";
}, function (t, e, n) {
  "use strict";

  n.r(e), n.d(e, "Draggable", function () {
    return Xt;
  }), n.d(e, "default", function () {
    return Xt;
  });
  /*!
   * matrix 3.3.4
   * https://greensock.com
   *
   * Copyright 2008-2020, GreenSock. All rights reserved.
   * Subject to the terms at https://greensock.com/standard-license or for
   * Club GreenSock members, the agreement issued with that membership.
   * @author: Jack Doyle, jack@greensock.com
  */

  var r,
      i,
      a,
      o,
      s,
      l,
      u,
      c,
      f = "transform",
      h = f + "Origin",
      d = function d(t) {
    var e = t.ownerDocument || t;
    !(f in t.style) && "msTransform" in t.style && (h = (f = "msTransform") + "Origin");

    for (; e.parentNode && (e = e.parentNode);) {
      ;
    }

    if (i = window, u = new x(), e) {
      r = e, a = e.documentElement, o = e.body;
      var n = e.createElement("div"),
          s = e.createElement("div");
      o.appendChild(n), n.appendChild(s), n.style.position = "static", n.style[f] = "translate3d(0,0,1px)", c = s.offsetParent !== n, o.removeChild(n);
    }

    return e;
  },
      p = [],
      g = [],
      m = function m(t) {
    return t.ownerSVGElement || ("svg" === (t.tagName + "").toLowerCase() ? t : null);
  },
      _ = function t(e, n) {
    if (e.parentNode && (r || d(e))) {
      var i = m(e),
          a = i ? i.getAttribute("xmlns") || "http://www.w3.org/2000/svg" : "http://www.w3.org/1999/xhtml",
          o = i ? n ? "rect" : "g" : "div",
          u = 2 !== n ? 0 : 100,
          c = 3 === n ? 100 : 0,
          f = "position:absolute;display:block;pointer-events:none;",
          h = r.createElementNS ? r.createElementNS(a.replace(/^https/, "http"), o) : r.createElement(o);
      return n && (i ? (l || (l = t(e)), h.setAttribute("width", .01), h.setAttribute("height", .01), h.setAttribute("transform", "translate(" + u + "," + c + ")"), l.appendChild(h)) : (s || ((s = t(e)).style.cssText = f), h.style.cssText = f + "width:0.1px;height:0.1px;top:" + c + "px;left:" + u + "px", s.appendChild(h))), h;
    }

    throw "Need document and parent.";
  },
      v = function v(t, e) {
    var n,
        r,
        a,
        o,
        d,
        v = m(t),
        y = t === v,
        b = v ? p : g;
    if (t === i) return t;
    if (b.length || b.push(_(t, 1), _(t, 2), _(t, 3)), n = v ? l : s, v) a = y ? {
      x: 0,
      y: 0
    } : t.getBBox(), (r = t.transform ? t.transform.baseVal : {}).numberOfItems ? (o = (r = r.numberOfItems > 1 ? function (t) {
      for (var e = new x(), n = 0; n < t.numberOfItems; n++) {
        e.multiply(t.getItem(n).matrix);
      }

      return e;
    }(r) : r.getItem(0).matrix).a * a.x + r.c * a.y, d = r.b * a.x + r.d * a.y) : (r = u, o = a.x, d = a.y), e && "g" === t.tagName.toLowerCase() && (o = d = 0), n.setAttribute("transform", "matrix(" + r.a + "," + r.b + "," + r.c + "," + r.d + "," + (r.e + o) + "," + (r.f + d) + ")"), (y ? v : t.parentNode).appendChild(n);else {
      if (o = d = 0, c) for (r = t.offsetParent, a = t; a && (a = a.parentNode) && a !== r && a.parentNode;) {
        (i.getComputedStyle(a)[f] + "").length > 4 && (o = a.offsetLeft, d = a.offsetTop, a = 0);
      }
      (a = n.style).top = t.offsetTop - d + "px", a.left = t.offsetLeft - o + "px", r = i.getComputedStyle(t), a[f] = r[f], a[h] = r[h], a.border = r.border, a.borderLeftStyle = r.borderLeftStyle, a.borderTopStyle = r.borderTopStyle, a.borderLeftWidth = r.borderLeftWidth, a.borderTopWidth = r.borderTopWidth, a.position = "fixed" === r.position ? "fixed" : "absolute", t.parentNode.appendChild(n);
    }
    return n;
  },
      y = function y(t, e, n, r, i, a, o) {
    return t.a = e, t.b = n, t.c = r, t.d = i, t.e = a, t.f = o, t;
  },
      x = function () {
    function t(t, e, n, r, i, a) {
      void 0 === t && (t = 1), void 0 === e && (e = 0), void 0 === n && (n = 0), void 0 === r && (r = 1), void 0 === i && (i = 0), void 0 === a && (a = 0), y(this, t, e, n, r, i, a);
    }

    var e = t.prototype;
    return e.inverse = function () {
      var t = this.a,
          e = this.b,
          n = this.c,
          r = this.d,
          i = this.e,
          a = this.f,
          o = t * r - e * n || 1e-10;
      return y(this, r / o, -e / o, -n / o, t / o, (n * a - r * i) / o, -(t * a - e * i) / o);
    }, e.multiply = function (t) {
      var e = this.a,
          n = this.b,
          r = this.c,
          i = this.d,
          a = this.e,
          o = this.f,
          s = t.a,
          l = t.c,
          u = t.b,
          c = t.d,
          f = t.e,
          h = t.f;
      return y(this, s * e + u * r, s * n + u * i, l * e + c * r, l * n + c * i, a + f * e + h * r, o + f * n + h * i);
    }, e.clone = function () {
      return new t(this.a, this.b, this.c, this.d, this.e, this.f);
    }, e.equals = function (t) {
      var e = this.a,
          n = this.b,
          r = this.c,
          i = this.d,
          a = this.e,
          o = this.f;
      return e === t.a && n === t.b && r === t.c && i === t.d && a === t.e && o === t.f;
    }, e.apply = function (t, e) {
      void 0 === e && (e = {});
      var n = t.x,
          r = t.y,
          i = this.a,
          a = this.b,
          o = this.c,
          s = this.d,
          l = this.e,
          u = this.f;
      return e.x = n * i + r * o + l || 0, e.y = n * a + r * s + u || 0, e;
    }, t;
  }();

  function b(t, e, n) {
    if (!t || !t.parentNode || (r || d(t)).documentElement === t) return new x();

    var s = function (t) {
      for (var e, n; t && t !== o;) {
        (n = t._gsap) && !n.scaleX && !n.scaleY && n.renderTransform && (n.scaleX = n.scaleY = 1e-4, n.renderTransform(1, n), e ? e.push(n) : e = [n]), t = t.parentNode;
      }

      return e;
    }(t.parentNode),
        l = m(t) ? p : g,
        u = v(t, n),
        c = l[0].getBoundingClientRect(),
        f = l[1].getBoundingClientRect(),
        h = l[2].getBoundingClientRect(),
        _ = u.parentNode,
        y = function t(e) {
      return "fixed" === i.getComputedStyle(e).position || ((e = e.parentNode) && 1 === e.nodeType ? t(e) : void 0);
    }(t),
        b = new x((f.left - c.left) / 100, (f.top - c.top) / 100, (h.left - c.left) / 100, (h.top - c.top) / 100, c.left + (y ? 0 : i.pageXOffset || r.scrollLeft || a.scrollLeft || o.scrollLeft || 0), c.top + (y ? 0 : i.pageYOffset || r.scrollTop || a.scrollTop || o.scrollTop || 0));

    if (_.removeChild(u), s) for (c = s.length; c--;) {
      (f = s[c]).scaleX = f.scaleY = 0, f.renderTransform(1, f);
    }
    return e ? b.inverse() : b;
  }
  /*!
   * Draggable 3.3.4
   * https://greensock.com
   *
   * @license Copyright 2008-2020, GreenSock. All rights reserved.
   * Subject to the terms at https://greensock.com/standard-license or for
   * Club GreenSock members, the agreement issued with that membership.
   * @author: Jack Doyle, jack@greensock.com
   */


  var w,
      M,
      T,
      S,
      C,
      k,
      O,
      P,
      A,
      E,
      D,
      L,
      z,
      N,
      B,
      R,
      F,
      Y,
      X,
      I,
      j,
      Z = function Z() {
    return "undefined" != typeof window;
  },
      W = function W() {
    return w || Z() && (w = window.gsap) && w.registerPlugin && w;
  },
      H = function H(t) {
    return "function" == typeof t;
  },
      V = function V(t) {
    return "object" == typeof t;
  },
      U = function U(t) {
    return void 0 === t;
  },
      G = function G() {
    return !1;
  },
      q = "transform",
      Q = "transformOrigin",
      K = function K(t) {
    return Math.round(1e4 * t) / 1e4;
  },
      $ = Array.isArray,
      J = function J(t, e) {
    var n = T.createElementNS ? T.createElementNS((e || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), t) : T.createElement(t);
    return n.style ? n : T.createElement(t);
  },
      tt = 180 / Math.PI,
      et = 1e20,
      nt = new x(),
      rt = Date.now || function () {
    return new Date().getTime();
  },
      it = [],
      at = {},
      ot = 0,
      st = /^(?:a|input|textarea|button|select)$/i,
      lt = 0,
      ut = {},
      ct = {},
      ft = function ft(t, e) {
    var n,
        r = {};

    for (n in t) {
      r[n] = e ? t[n] * e : t[n];
    }

    return r;
  },
      ht = function ht() {
    return it.forEach(function (t) {
      return t();
    });
  },
      dt = function dt() {
    return !it.length && w.ticker.remove(ht);
  },
      pt = function pt(t) {
    for (var e = it.length; e--;) {
      it[e] === t && it.splice(e, 1);
    }

    w.to(dt, {
      overwrite: !0,
      delay: 15,
      duration: 0,
      onComplete: dt,
      data: "_draggable"
    });
  },
      gt = function gt(t, e, n, r) {
    if (t.addEventListener) {
      var i = z[e];
      r = r || (D ? {
        passive: !1
      } : null), t.addEventListener(i || e, n, r), i && e !== i && t.addEventListener(e, n, r);
    }
  },
      mt = function mt(t, e, n) {
    if (t.removeEventListener) {
      var r = z[e];
      t.removeEventListener(r || e, n), r && e !== r && t.removeEventListener(e, n);
    }
  },
      _t = function _t(t) {
    t.preventDefault && t.preventDefault(), t.preventManipulation && t.preventManipulation();
  },
      vt = function t(e) {
    B = e.touches && N < e.touches.length, mt(e.target, "touchend", t);
  },
      yt = function yt(t) {
    B = t.touches && N < t.touches.length, gt(t.target, "touchend", vt);
  },
      xt = function xt(t) {
    return M.pageYOffset || t.scrollTop || t.documentElement.scrollTop || t.body.scrollTop || 0;
  },
      bt = function bt(t) {
    return M.pageXOffset || t.scrollLeft || t.documentElement.scrollLeft || t.body.scrollLeft || 0;
  },
      wt = function t(e, n) {
    gt(e, "scroll", n), Tt(e.parentNode) || t(e.parentNode, n);
  },
      Mt = function t(e, n) {
    mt(e, "scroll", n), Tt(e.parentNode) || t(e.parentNode, n);
  },
      Tt = function Tt(t) {
    return !(t && t !== S && 9 !== t.nodeType && t !== T.body && t !== M && t.nodeType && t.parentNode);
  },
      St = function St(t, e) {
    var n = "x" === e ? "Width" : "Height",
        r = "scroll" + n,
        i = "client" + n;
    return Math.max(0, Tt(t) ? Math.max(S[r], C[r]) - (M["inner" + n] || S[i] || C[i]) : t[r] - t[i]);
  },
      Ct = function t(e, n) {
    var r = St(e, "x"),
        i = St(e, "y");
    Tt(e) ? e = ct : t(e.parentNode, n), e._gsMaxScrollX = r, e._gsMaxScrollY = i, n || (e._gsScrollX = e.scrollLeft || 0, e._gsScrollY = e.scrollTop || 0);
  },
      kt = function kt(t, e, n) {
    var r = t.style;
    r && (U(r[e]) && (e = A(e, t) || e), null == n ? r.removeProperty && r.removeProperty(e.replace(/([A-Z])/g, "-$1").toLowerCase()) : r[e] = n);
  },
      Ot = function Ot(t) {
    return M.getComputedStyle(t instanceof Element ? t : t.host || (t.parentNode || {}).host || t);
  },
      Pt = {},
      At = function At(t) {
    if (t === M) return Pt.left = Pt.top = 0, Pt.width = Pt.right = S.clientWidth || t.innerWidth || C.clientWidth || 0, Pt.height = Pt.bottom = (t.innerHeight || 0) - 20 < S.clientHeight ? S.clientHeight : t.innerHeight || C.clientHeight || 0, Pt;
    var e = t.ownerDocument || T,
        n = U(t.pageX) ? t.nodeType || U(t.left) || U(t.top) ? E(t)[0].getBoundingClientRect() : t : {
      left: t.pageX - bt(e),
      top: t.pageY - xt(e),
      right: t.pageX - bt(e) + 1,
      bottom: t.pageY - xt(e) + 1
    };
    return U(n.right) && !U(n.width) ? (n.right = n.left + n.width, n.bottom = n.top + n.height) : U(n.width) && (n = {
      width: n.right - n.left,
      height: n.bottom - n.top,
      right: n.right,
      left: n.left,
      bottom: n.bottom,
      top: n.top
    }), n;
  },
      Et = function Et(t, e, n) {
    var r,
        i = t.vars,
        a = i[n],
        o = t._listeners[e];
    return H(a) && (r = a.apply(i.callbackScope || t, i[n + "Params"] || [t.pointerEvent])), o && !1 === t.dispatchEvent(e) && (r = !1), r;
  },
      Dt = function Dt(t, e) {
    var n,
        r,
        i,
        a = E(t)[0];
    return a.nodeType || a === M ? zt(a, e) : U(t.left) ? {
      left: r = t.min || t.minX || t.minRotation || 0,
      top: n = t.min || t.minY || 0,
      width: (t.max || t.maxX || t.maxRotation || 0) - r,
      height: (t.max || t.maxY || 0) - n
    } : (i = {
      x: 0,
      y: 0
    }, {
      left: t.left - i.x,
      top: t.top - i.y,
      width: t.width,
      height: t.height
    });
  },
      Lt = {},
      zt = function zt(t, e) {
    e = E(e)[0];

    var n,
        r,
        i,
        a,
        o,
        s,
        l,
        u,
        c,
        f,
        h,
        d,
        p,
        g,
        m = t.getBBox && t.ownerSVGElement,
        _ = t.ownerDocument || T;

    if (t === M) i = xt(_), r = (n = bt(_)) + (_.documentElement.clientWidth || t.innerWidth || _.body.clientWidth || 0), a = i + ((t.innerHeight || 0) - 20 < _.documentElement.clientHeight ? _.documentElement.clientHeight : t.innerHeight || _.body.clientHeight || 0);else {
      if (e === M || U(e)) return t.getBoundingClientRect();
      n = i = 0, m ? (h = (f = t.getBBox()).width, d = f.height) : (t.viewBox && (f = t.viewBox.baseVal) && (n = f.x || 0, i = f.y || 0, h = f.width, d = f.height), h || (f = "border-box" === (p = Ot(t)).boxSizing, h = (parseFloat(p.width) || t.clientWidth || 0) + (f ? 0 : parseFloat(p.borderLeftWidth) + parseFloat(p.borderRightWidth)), d = (parseFloat(p.height) || t.clientHeight || 0) + (f ? 0 : parseFloat(p.borderTopWidth) + parseFloat(p.borderBottomWidth)))), r = h, a = d;
    }
    return t === e ? {
      left: n,
      top: i,
      width: r - n,
      height: a - i
    } : (s = (o = b(e, !0).multiply(b(t))).apply({
      x: n,
      y: i
    }), l = o.apply({
      x: r,
      y: i
    }), u = o.apply({
      x: r,
      y: a
    }), c = o.apply({
      x: n,
      y: a
    }), n = Math.min(s.x, l.x, u.x, c.x), i = Math.min(s.y, l.y, u.y, c.y), {
      left: n + ((g = e.parentNode || {}).scrollLeft || 0),
      top: i + (g.scrollTop || 0),
      width: Math.max(s.x, l.x, u.x, c.x) - n,
      height: Math.max(s.y, l.y, u.y, c.y) - i
    });
  },
      Nt = function Nt(t, e, n, r, i, a) {
    var o,
        s,
        l,
        u = {};
    if (e) if (1 !== i && e instanceof Array) {
      if (u.end = o = [], l = e.length, V(e[0])) for (s = 0; s < l; s++) {
        o[s] = ft(e[s], i);
      } else for (s = 0; s < l; s++) {
        o[s] = e[s] * i;
      }
      n += 1.1, r -= 1.1;
    } else H(e) ? u.end = function (n) {
      var r,
          a,
          o = e.call(t, n);
      if (1 !== i) if (V(o)) {
        for (a in r = {}, o) {
          r[a] = o[a] * i;
        }

        o = r;
      } else o *= i;
      return o;
    } : u.end = e;
    return (n || 0 === n) && (u.max = n), (r || 0 === r) && (u.min = r), a && (u.velocity = 0), u;
  },
      Bt = function t(e) {
    var n;
    return !(!e || !e.getAttribute || e === C) && (!("true" !== (n = e.getAttribute("data-clickable")) && ("false" === n || !e.onclick && !st.test(e.nodeName + "") && "true" !== e.getAttribute("contentEditable"))) || t(e.parentNode));
  },
      Rt = function Rt(t, e) {
    for (var n, r = t.length; r--;) {
      (n = t[r]).ondragstart = n.onselectstart = e ? null : G, w.set(n, {
        lazy: !0,
        userSelect: e ? "text" : "none"
      });
    }
  },
      Ft = function Ft(t, e) {
    t = w.utils.toArray(t)[0], e = e || {};
    var n,
        r,
        i,
        a,
        o,
        s,
        l = document.createElement("div"),
        u = l.style,
        c = t.firstChild,
        f = 0,
        h = 0,
        d = t.scrollTop,
        p = t.scrollLeft,
        g = t.scrollWidth,
        m = t.scrollHeight,
        _ = 0,
        v = 0,
        y = 0;
    I && !1 !== e.force3D ? (o = "translate3d(", s = "px,0px)") : q && (o = "translate(", s = "px)"), this.scrollTop = function (t, e) {
      if (!arguments.length) return -this.top();
      this.top(-t, e);
    }, this.scrollLeft = function (t, e) {
      if (!arguments.length) return -this.left();
      this.left(-t, e);
    }, this.left = function (n, r) {
      if (!arguments.length) return -(t.scrollLeft + h);
      var i = t.scrollLeft - p,
          a = h;
      if ((i > 2 || i < -2) && !r) return p = t.scrollLeft, w.killTweensOf(this, {
        left: 1,
        scrollLeft: 1
      }), this.left(-p), void (e.onKill && e.onKill());
      (n = -n) < 0 ? (h = n - .5 | 0, n = 0) : n > v ? (h = n - v | 0, n = v) : h = 0, (h || a) && (this._skip || (u[q] = o + -h + "px," + -f + s), h + _ >= 0 && (u.paddingRight = h + _ + "px")), t.scrollLeft = 0 | n, p = t.scrollLeft;
    }, this.top = function (n, r) {
      if (!arguments.length) return -(t.scrollTop + f);
      var i = t.scrollTop - d,
          a = f;
      if ((i > 2 || i < -2) && !r) return d = t.scrollTop, w.killTweensOf(this, {
        top: 1,
        scrollTop: 1
      }), this.top(-d), void (e.onKill && e.onKill());
      (n = -n) < 0 ? (f = n - .5 | 0, n = 0) : n > y ? (f = n - y | 0, n = y) : f = 0, (f || a) && (this._skip || (u[q] = o + -h + "px," + -f + s)), t.scrollTop = 0 | n, d = t.scrollTop;
    }, this.maxScrollTop = function () {
      return y;
    }, this.maxScrollLeft = function () {
      return v;
    }, this.disable = function () {
      for (c = l.firstChild; c;) {
        a = c.nextSibling, t.appendChild(c), c = a;
      }

      t === l.parentNode && t.removeChild(l);
    }, this.enable = function () {
      if ((c = t.firstChild) !== l) {
        for (; c;) {
          a = c.nextSibling, l.appendChild(c), c = a;
        }

        t.appendChild(l), this.calibrate();
      }
    }, this.calibrate = function (e) {
      var a,
          o,
          s,
          c = t.clientWidth === n;
      d = t.scrollTop, p = t.scrollLeft, c && t.clientHeight === r && l.offsetHeight === i && g === t.scrollWidth && m === t.scrollHeight && !e || ((f || h) && (o = this.left(), s = this.top(), this.left(-t.scrollLeft), this.top(-t.scrollTop)), a = Ot(t), c && !e || (u.display = "block", u.width = "auto", u.paddingRight = "0px", (_ = Math.max(0, t.scrollWidth - t.clientWidth)) && (_ += parseFloat(a.paddingLeft) + (j ? parseFloat(a.paddingRight) : 0))), u.display = "inline-block", u.position = "relative", u.overflow = "visible", u.verticalAlign = "top", u.boxSizing = "content-box", u.width = "100%", u.paddingRight = _ + "px", j && (u.paddingBottom = a.paddingBottom), n = t.clientWidth, r = t.clientHeight, g = t.scrollWidth, m = t.scrollHeight, v = t.scrollWidth - n, y = t.scrollHeight - r, i = l.offsetHeight, u.display = "block", (o || s) && (this.left(o), this.top(s)));
    }, this.content = l, this.element = t, this._skip = !1, this.enable();
  },
      Yt = function Yt(t) {
    if (Z() && document.body) {
      var e = window && window.navigator;
      M = window, T = document, S = T.documentElement, C = T.body, k = J("div"), X = !!window.PointerEvent, (O = J("div")).style.cssText = "visibility:hidden;height:1px;top:-1px;pointer-events:none;position:relative;clear:both;cursor:grab", Y = "grab" === O.style.cursor ? "grab" : "move", R = e && -1 !== e.userAgent.toLowerCase().indexOf("android"), L = "ontouchstart" in S && "orientation" in M || e && (e.MaxTouchPoints > 0 || e.msMaxTouchPoints > 0), r = J("div"), i = J("div"), a = i.style, o = C, a.display = "inline-block", a.position = "relative", r.style.cssText = i.innerHTML = "width:90px;height:40px;padding:10px;overflow:auto;visibility:hidden", r.appendChild(i), o.appendChild(r), n = i.offsetHeight + 18 > r.scrollHeight, o.removeChild(r), j = n, z = function (t) {
        for (var e = t.split(","), n = (U(k.onpointerdown) ? U(k.onmspointerdown) ? t : "MSPointerDown,MSPointerMove,MSPointerUp,MSPointerCancel" : "pointerdown,pointermove,pointerup,pointercancel").split(","), r = {}, i = 4; --i > -1;) {
          r[e[i]] = n[i], r[n[i]] = e[i];
        }

        try {
          S.addEventListener("test", null, Object.defineProperty({}, "passive", {
            get: function get() {
              D = 1;
            }
          }));
        } catch (t) {}

        return r;
      }("touchstart,touchmove,touchend,touchcancel"), gt(T, "touchcancel", G), gt(M, "touchmove", G), C && C.addEventListener("touchstart", G), gt(T, "contextmenu", function () {
        for (var t in at) {
          at[t].isPressed && at[t].endDrag();
        }
      }), w = P = W();
    }

    var n, r, i, a, o;
    w ? (F = w.plugins.inertia, A = w.utils.checkPrefix, q = A(q), Q = A(Q), E = w.utils.toArray, I = !!A("perspective")) : t && console.warn("Please gsap.registerPlugin(Draggable)");
  },
      Xt = function (t) {
    var e, n;

    function r(e, n) {
      var i;
      i = t.call(this) || this, w || Yt(1), e = E(e)[0], F || (F = w.plugins.inertia), i.vars = n = ft(n || {}), i.target = e, i.x = i.y = i.rotation = 0, i.dragResistance = parseFloat(n.dragResistance) || 0, i.edgeResistance = isNaN(n.edgeResistance) ? 1 : parseFloat(n.edgeResistance) || 0, i.lockAxis = n.lockAxis, i.autoScroll = n.autoScroll || 0, i.lockedAxis = null, i.allowEventDefault = !!n.allowEventDefault, w.getProperty(e, "x");

      var a,
          o,
          s,
          l,
          u,
          c,
          f,
          h,
          d,
          p,
          g,
          m,
          _,
          v,
          y,
          C,
          k,
          P,
          A,
          D,
          I,
          j,
          Z,
          W,
          G,
          q,
          J,
          st,
          dt,
          vt,
          St,
          Pt = (n.type || "x,y").toLowerCase(),
          zt = ~Pt.indexOf("x") || ~Pt.indexOf("y"),
          Xt = -1 !== Pt.indexOf("rotation"),
          It = Xt ? "rotation" : zt ? "x" : "left",
          jt = zt ? "y" : "top",
          Zt = !(!~Pt.indexOf("x") && !~Pt.indexOf("left") && "scroll" !== Pt),
          Wt = !(!~Pt.indexOf("y") && !~Pt.indexOf("top") && "scroll" !== Pt),
          Ht = n.minimumMovement || 2,
          Vt = function (t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t;
      }(i),
          Ut = E(n.trigger || n.handle || e),
          Gt = {},
          qt = 0,
          Qt = !1,
          Kt = n.autoScrollMarginTop || 40,
          $t = n.autoScrollMarginRight || 40,
          Jt = n.autoScrollMarginBottom || 40,
          te = n.autoScrollMarginLeft || 40,
          ee = n.clickableTest || Bt,
          ne = 0,
          re = e._gsap || w.core.getCache(e),
          ie = function t(e) {
        return "fixed" === Ot(e).position || ((e = e.parentNode) && 1 === e.nodeType ? t(e) : void 0);
      }(e),
          ae = function ae(t, n) {
        return parseFloat(re.get(e, t, n));
      },
          oe = e.ownerDocument || T,
          se = function se(t) {
        return _t(t), t.stopImmediatePropagation && t.stopImmediatePropagation(), !1;
      },
          le = function t(n) {
        if (Vt.autoScroll && Vt.isDragging && (Qt || k)) {
          var r,
              i,
              a,
              s,
              l,
              u,
              c,
              f,
              d = e,
              p = 15 * Vt.autoScroll;

          for (Qt = !1, ct.scrollTop = null != M.pageYOffset ? M.pageYOffset : null != oe.documentElement.scrollTop ? oe.documentElement.scrollTop : oe.body.scrollTop, ct.scrollLeft = null != M.pageXOffset ? M.pageXOffset : null != oe.documentElement.scrollLeft ? oe.documentElement.scrollLeft : oe.body.scrollLeft, s = Vt.pointerX - ct.scrollLeft, l = Vt.pointerY - ct.scrollTop; d && !i;) {
            r = (i = Tt(d.parentNode)) ? ct : d.parentNode, a = i ? {
              bottom: Math.max(S.clientHeight, M.innerHeight || 0),
              right: Math.max(S.clientWidth, M.innerWidth || 0),
              left: 0,
              top: 0
            } : r.getBoundingClientRect(), u = c = 0, Wt && ((f = r._gsMaxScrollY - r.scrollTop) < 0 ? c = f : l > a.bottom - Jt && f ? (Qt = !0, c = Math.min(f, p * (1 - Math.max(0, a.bottom - l) / Jt) | 0)) : l < a.top + Kt && r.scrollTop && (Qt = !0, c = -Math.min(r.scrollTop, p * (1 - Math.max(0, l - a.top) / Kt) | 0)), c && (r.scrollTop += c)), Zt && ((f = r._gsMaxScrollX - r.scrollLeft) < 0 ? u = f : s > a.right - $t && f ? (Qt = !0, u = Math.min(f, p * (1 - Math.max(0, a.right - s) / $t) | 0)) : s < a.left + te && r.scrollLeft && (Qt = !0, u = -Math.min(r.scrollLeft, p * (1 - Math.max(0, s - a.left) / te) | 0)), u && (r.scrollLeft += u)), i && (u || c) && (M.scrollTo(r.scrollLeft, r.scrollTop), be(Vt.pointerX + u, Vt.pointerY + c)), d = r;
          }
        }

        if (k) {
          var g = Vt.x,
              m = Vt.y;
          Xt ? (Vt.deltaX = g - parseFloat(re.rotation), Vt.rotation = g, re.rotation = g + "deg", re.renderTransform(1, re)) : o ? (Wt && (Vt.deltaY = m - o.top(), o.top(m)), Zt && (Vt.deltaX = g - o.left(), o.left(g))) : zt ? (Wt && (Vt.deltaY = m - parseFloat(re.y), re.y = m + "px"), Zt && (Vt.deltaX = g - parseFloat(re.x), re.x = g + "px"), re.renderTransform(1, re)) : (Wt && (Vt.deltaY = m - parseFloat(e.style.top || 0), e.style.top = m + "px"), Zt && (Vt.deltaY = g - parseFloat(e.style.left || 0), e.style.left = g + "px")), !h || n || st || (st = !0, !1 === Et(Vt, "drag", "onDrag") && (Zt && (Vt.x -= Vt.deltaX), Wt && (Vt.y -= Vt.deltaY), t(!0)), st = !1);
        }

        k = !1;
      },
          ue = function ue(t, n) {
        var r,
            i,
            a = Vt.x,
            s = Vt.y;
        e._gsap || (re = w.core.getCache(e)), zt ? (Vt.x = parseFloat(re.x), Vt.y = parseFloat(re.y)) : Xt ? Vt.x = Vt.rotation = parseFloat(re.rotation) : o ? (Vt.y = o.top(), Vt.x = o.left()) : (Vt.y = parseInt(e.style.top || (i = Ot(e)) && i.top, 10) || 0, Vt.x = parseInt(e.style.left || (i || {}).left, 10) || 0), (A || D || I) && !n && (Vt.isDragging || Vt.isThrowing) && (I && (ut.x = Vt.x, ut.y = Vt.y, (r = I(ut)).x !== Vt.x && (Vt.x = r.x, k = !0), r.y !== Vt.y && (Vt.y = r.y, k = !0)), A && (r = A(Vt.x)) !== Vt.x && (Vt.x = r, Xt && (Vt.rotation = r), k = !0), D && ((r = D(Vt.y)) !== Vt.y && (Vt.y = r), k = !0)), k && le(!0), t || (Vt.deltaX = Vt.x - a, Vt.deltaY = Vt.y - s, Et(Vt, "throwupdate", "onThrowUpdate"));
      },
          ce = function ce(t, e, n, r) {
        return null == e && (e = -et), null == n && (n = et), H(t) ? function (i) {
          var a = Vt.isPressed ? 1 - Vt.edgeResistance : 1;
          return t.call(Vt, i > n ? n + (i - n) * a : i < e ? e + (i - e) * a : i) * r;
        } : $(t) ? function (r) {
          for (var i, a, o = t.length, s = 0, l = et; --o > -1;) {
            (a = (i = t[o]) - r) < 0 && (a = -a), a < l && i >= e && i <= n && (s = o, l = a);
          }

          return t[s];
        } : isNaN(t) ? function (t) {
          return t;
        } : function () {
          return t * r;
        };
      },
          fe = function fe() {
        var t, r, i, a;
        f = !1, o ? (o.calibrate(), Vt.minX = g = -o.maxScrollLeft(), Vt.minY = _ = -o.maxScrollTop(), Vt.maxX = p = Vt.maxY = m = 0, f = !0) : n.bounds && (t = Dt(n.bounds, e.parentNode), Xt ? (Vt.minX = g = t.left, Vt.maxX = p = t.left + t.width, Vt.minY = _ = Vt.maxY = m = 0) : U(n.bounds.maxX) && U(n.bounds.maxY) ? (r = Dt(e, e.parentNode), Vt.minX = g = Math.round(ae(It, "px") + t.left - r.left - .5), Vt.minY = _ = Math.round(ae(jt, "px") + t.top - r.top - .5), Vt.maxX = p = Math.round(g + (t.width - r.width)), Vt.maxY = m = Math.round(_ + (t.height - r.height))) : (t = n.bounds, Vt.minX = g = t.minX, Vt.minY = _ = t.minY, Vt.maxX = p = t.maxX, Vt.maxY = m = t.maxY), g > p && (Vt.minX = p, Vt.maxX = p = g, g = Vt.minX), _ > m && (Vt.minY = m, Vt.maxY = m = _, _ = Vt.minY), Xt && (Vt.minRotation = g, Vt.maxRotation = p), f = !0), n.liveSnap && (i = !0 === n.liveSnap ? n.snap || {} : n.liveSnap, a = $(i) || H(i), Xt ? (A = ce(a ? i : i.rotation, g, p, 1), D = null) : i.points ? I = function (t, e, n, r, i, a, o) {
          return a = a && a < et ? a * a : et, H(t) ? function (s) {
            var l,
                u,
                c,
                f = Vt.isPressed ? 1 - Vt.edgeResistance : 1,
                h = s.x,
                d = s.y;
            return s.x = h = h > n ? n + (h - n) * f : h < e ? e + (h - e) * f : h, s.y = d = d > i ? i + (d - i) * f : d < r ? r + (d - r) * f : d, (l = t.call(Vt, s)) !== s && (s.x = l.x, s.y = l.y), 1 !== o && (s.x *= o, s.y *= o), a < et && (u = s.x - h) * u + (c = s.y - d) * c > a && (s.x = h, s.y = d), s;
          } : $(t) ? function (e) {
            for (var n, r, i, o, s = t.length, l = 0, u = et; --s > -1;) {
              (o = (n = (i = t[s]).x - e.x) * n + (r = i.y - e.y) * r) < u && (l = s, u = o);
            }

            return u <= a ? t[l] : e;
          } : function (t) {
            return t;
          };
        }(a ? i : i.points, g, p, _, m, i.radius, o ? -1 : 1) : (Zt && (A = ce(a ? i : i.x || i.left || i.scrollLeft, g, p, o ? -1 : 1)), Wt && (D = ce(a ? i : i.y || i.top || i.scrollTop, _, m, o ? -1 : 1))));
      },
          he = function he() {
        Vt.isThrowing = !1, Et(Vt, "throwcomplete", "onThrowComplete");
      },
          de = function de() {
        Vt.isThrowing = !1;
      },
          pe = function pe(t, r) {
        var i, a, s, l;
        t && F ? (!0 === t && (i = n.snap || n.liveSnap || {}, a = $(i) || H(i), t = {
          resistance: (n.throwResistance || n.resistance || 1e3) / (Xt ? 10 : 1)
        }, Xt ? t.rotation = Nt(Vt, a ? i : i.rotation, p, g, 1, r) : (Zt && (t[It] = Nt(Vt, a ? i : i.points || i.x || i.left, p, g, o ? -1 : 1, r || "x" === Vt.lockedAxis)), Wt && (t[jt] = Nt(Vt, a ? i : i.points || i.y || i.top, m, _, o ? -1 : 1, r || "y" === Vt.lockedAxis)), (i.points || $(i) && V(i[0])) && (t.linkedProps = It + "," + jt, t.radius = i.radius))), Vt.isThrowing = !0, l = isNaN(n.overshootTolerance) ? 1 === n.edgeResistance ? 0 : 1 - Vt.edgeResistance + .2 : n.overshootTolerance, t.duration || (t.duration = {
          max: Math.max(n.minDuration || 0, "maxDuration" in n ? n.maxDuration : 2),
          min: isNaN(n.minDuration) ? 0 === l || V(t) && t.resistance > 1e3 ? 0 : .5 : n.minDuration,
          overshoot: l
        }), Vt.tween = s = w.to(o || e, {
          inertia: t,
          data: "_draggable",
          onComplete: he,
          onInterrupt: de,
          onUpdate: n.fastMode ? Et : ue,
          onUpdateParams: n.fastMode ? [Vt, "onthrowupdate", "onThrowUpdate"] : i && i.radius ? [!1, !0] : []
        }), n.fastMode || (o && (o._skip = !0), s.render(1e9, !0, !0), ue(!0, !0), Vt.endX = Vt.x, Vt.endY = Vt.y, Xt && (Vt.endRotation = Vt.x), s.play(0), ue(!0, !0), o && (o._skip = !1))) : f && Vt.applyBounds();
      },
          ge = function ge(t) {
        var n,
            r = W;
        W = b(e.parentNode, !0), t && Vt.isPressed && !W.equals(r || new x()) && (n = r.inverse().apply({
          x: s,
          y: l
        }), W.apply(n, n), s = n.x, l = n.y), W.equals(nt) && (W = null);
      },
          me = function me() {
        var t,
            n,
            r,
            i = 1 - Vt.edgeResistance;
        ge(!1), W && (Lt.x = Vt.pointerX, Lt.y = Vt.pointerY, W.apply(Lt, Lt), s = Lt.x, l = Lt.y), k && (be(Vt.pointerX, Vt.pointerY), le(!0)), o ? (fe(), c = o.top(), u = o.left()) : (_e() ? (ue(!0, !0), fe()) : Vt.applyBounds(), Xt ? (t = e.ownerSVGElement ? [re.xOrigin - e.getBBox().x, re.yOrigin - e.getBBox().y] : (Ot(e)[Q] || "0 0").split(" "), C = Vt.rotationOrigin = b(e).apply({
          x: parseFloat(t[0]) || 0,
          y: parseFloat(t[1]) || 0
        }), ue(!0, !0), n = Vt.pointerX - C.x, r = C.y - Vt.pointerY, ie && (n -= bt(oe), r += xt(oe)), u = Vt.x, c = Vt.y = Math.atan2(r, n) * tt) : (c = ae(jt, "px"), u = ae(It, "px"))), f && i && (u > p ? u = p + (u - p) / i : u < g && (u = g - (g - u) / i), Xt || (c > m ? c = m + (c - m) / i : c < _ && (c = _ - (_ - c) / i))), Vt.startX = u, Vt.startY = c;
      },
          _e = function _e() {
        return Vt.tween && Vt.tween.isActive();
      },
          ve = function ve() {
        !O.parentNode || _e() || Vt.isDragging || O.parentNode.removeChild(O);
      },
          ye = function ye(t, i) {
        var u;
        if (!a || Vt.isPressed || !t || !("mousedown" !== t.type && "pointerdown" !== t.type || i) && rt() - ne < 30 && z[Vt.pointerEvent.type]) St && t && a && _t(t);else {
          if (G = _e(), Vt.pointerEvent = t, z[t.type] ? (Z = ~t.type.indexOf("touch") ? t.currentTarget || t.target : oe, gt(Z, "touchend", we), gt(Z, "touchmove", xe), gt(Z, "touchcancel", we), gt(oe, "touchstart", yt)) : (Z = null, gt(oe, "mousemove", xe)), J = null, X && Z || (gt(oe, "mouseup", we), t && t.target && gt(t.target, "mouseup", we)), j = ee.call(Vt, t.target) && !1 === n.dragClickables && !i) return gt(t.target, "change", we), Et(Vt, "pressInit", "onPressInit"), Et(Vt, "press", "onPress"), void Rt(Ut, !0);
          var c;
          if (q = !(!Z || Zt === Wt || !1 === Vt.vars.allowNativeTouchScrolling || Vt.vars.allowContextMenu && t && (t.ctrlKey || t.which > 2)) && (Zt ? "y" : "x"), (St = !q && !Vt.allowEventDefault) && (_t(t), gt(M, "touchforcechange", _t)), t.changedTouches ? (t = v = t.changedTouches[0], y = t.identifier) : t.pointerId ? y = t.pointerId : v = y = null, N++, c = le, it.push(c), 1 === it.length && w.ticker.add(ht), l = Vt.pointerY = t.pageY, s = Vt.pointerX = t.pageX, Et(Vt, "pressInit", "onPressInit"), (q || Vt.autoScroll) && Ct(e.parentNode), !e.parentNode || !Vt.autoScroll || o || Xt || !e.parentNode._gsMaxScrollX || O.parentNode || e.getBBox || (O.style.width = e.parentNode.scrollWidth + "px", e.parentNode.appendChild(O)), me(), Vt.tween && Vt.tween.kill(), Vt.isThrowing = !1, w.killTweensOf(o || e, Gt, !0), o && w.killTweensOf(e, {
            scrollTo: 1
          }, !0), Vt.tween = Vt.lockedAxis = null, (n.zIndexBoost || !Xt && !o && !1 !== n.zIndexBoost) && (e.style.zIndex = r.zIndex++), Vt.isPressed = !0, h = !(!n.onDrag && !Vt._listeners.drag), d = !(!n.onMove && !Vt._listeners.move), !Xt && (!1 !== n.cursor || n.activeCursor)) for (u = Ut.length; --u > -1;) {
            w.set(Ut[u], {
              cursor: n.activeCursor || n.cursor || ("grab" === Y ? "grabbing" : Y)
            });
          }
          Et(Vt, "press", "onPress");
        }
      },
          xe = function xe(t) {
        var e,
            n,
            r,
            i,
            o,
            u,
            c = t;

        if (a && !B && Vt.isPressed && t) {
          if (Vt.pointerEvent = t, e = t.changedTouches) {
            if ((t = e[0]) !== v && t.identifier !== y) {
              for (i = e.length; --i > -1 && (t = e[i]).identifier !== y;) {
                ;
              }

              if (i < 0) return;
            }
          } else if (t.pointerId && y && t.pointerId !== y) return;

          Z && q && !J && (Lt.x = t.pageX, Lt.y = t.pageY, W && W.apply(Lt, Lt), n = Lt.x, r = Lt.y, ((o = Math.abs(n - s)) !== (u = Math.abs(r - l)) && (o > Ht || u > Ht) || R && q === J) && (J = o > u && Zt ? "x" : "y", q && J !== q && gt(M, "touchforcechange", _t), !1 !== Vt.vars.lockAxisOnTouchScroll && Zt && Wt && (Vt.lockedAxis = "x" === J ? "y" : "x", H(Vt.vars.onLockAxis) && Vt.vars.onLockAxis.call(Vt, c)), R && q === J)) ? we(c) : (Vt.allowEventDefault || q && (!J || q === J) || !1 === c.cancelable ? St && (St = !1) : (_t(c), St = !0), Vt.autoScroll && (Qt = !0), be(t.pageX - (ie && Xt ? bt(oe) : 0), t.pageY - (ie && Xt ? xt(oe) : 0), d));
        } else St && t && a && _t(t);
      },
          be = function be(t, e, n) {
        var r,
            i,
            a,
            o,
            h,
            d,
            v = 1 - Vt.dragResistance,
            y = 1 - Vt.edgeResistance,
            x = Vt.pointerX,
            b = Vt.pointerY,
            w = c,
            M = Vt.x,
            T = Vt.y,
            S = Vt.endX,
            O = Vt.endY,
            P = Vt.endRotation,
            E = k;
        Vt.pointerX = t, Vt.pointerY = e, Xt ? (o = Math.atan2(C.y - e, t - C.x) * tt, (h = Vt.y - o) > 180 ? (c -= 360, Vt.y = o) : h < -180 && (c += 360, Vt.y = o), Vt.x !== u || Math.abs(c - o) > Ht ? (Vt.y = o, a = u + (c - o) * v) : a = u) : (W && (d = t * W.a + e * W.c + W.e, e = t * W.b + e * W.d + W.f, t = d), (i = e - l) < Ht && i > -Ht && (i = 0), (r = t - s) < Ht && r > -Ht && (r = 0), (Vt.lockAxis || Vt.lockedAxis) && (r || i) && ((d = Vt.lockedAxis) || (Vt.lockedAxis = d = Zt && Math.abs(r) > Math.abs(i) ? "y" : Wt ? "x" : null, d && H(Vt.vars.onLockAxis) && Vt.vars.onLockAxis.call(Vt, Vt.pointerEvent)), "y" === d ? i = 0 : "x" === d && (r = 0)), a = K(u + r * v), o = K(c + i * v)), (A || D || I) && (Vt.x !== a || Vt.y !== o && !Xt) ? (I && (ut.x = a, ut.y = o, d = I(ut), a = K(d.x), o = K(d.y)), A && (a = K(A(a))), D && (o = K(D(o)))) : f && (a > p ? a = p + Math.round((a - p) * y) : a < g && (a = g + Math.round((a - g) * y)), Xt || (o > m ? o = Math.round(m + (o - m) * y) : o < _ && (o = Math.round(_ + (o - _) * y)))), (Vt.x !== a || Vt.y !== o && !Xt) && (Xt ? (Vt.endRotation = Vt.x = Vt.endX = a, k = !0) : (Wt && (Vt.y = Vt.endY = o, k = !0), Zt && (Vt.x = Vt.endX = a, k = !0)), n && !1 === Et(Vt, "move", "onMove") ? (Vt.pointerX = x, Vt.pointerY = b, c = w, Vt.x = M, Vt.y = T, Vt.endX = S, Vt.endY = O, Vt.endRotation = P, k = E) : !Vt.isDragging && Vt.isPressed && (Vt.isDragging = !0, Et(Vt, "dragstart", "onDragStart")));
      },
          we = function t(r, i) {
        if (a && Vt.isPressed && (!r || null == y || i || !(r.pointerId && r.pointerId !== y || r.changedTouches && !function (t, e) {
          for (var n = t.length; n--;) {
            if (t[n].identifier === e) return !0;
          }
        }(r.changedTouches, y)))) {
          Vt.isPressed = !1;
          var o,
              s,
              l,
              u,
              c,
              f = r,
              h = Vt.isDragging,
              d = Vt.vars.allowContextMenu && r && (r.ctrlKey || r.which > 2),
              p = w.delayedCall(.001, ve);
          if (Z ? (mt(Z, "touchend", t), mt(Z, "touchmove", xe), mt(Z, "touchcancel", t), mt(oe, "touchstart", yt)) : mt(oe, "mousemove", xe), mt(M, "touchforcechange", _t), X && Z || (mt(oe, "mouseup", t), r && r.target && mt(r.target, "mouseup", t)), k = !1, j && !d) return r && (mt(r.target, "change", t), Vt.pointerEvent = f), Rt(Ut, !1), Et(Vt, "release", "onRelease"), Et(Vt, "click", "onClick"), void (j = !1);
          if (pt(le), !Xt) for (s = Ut.length; --s > -1;) {
            kt(Ut[s], "cursor", n.cursor || (!1 !== n.cursor ? Y : null));
          }

          if (h && (qt = lt = rt(), Vt.isDragging = !1), N--, r) {
            if ((o = r.changedTouches) && (r = o[0]) !== v && r.identifier !== y) {
              for (s = o.length; --s > -1 && (r = o[s]).identifier !== y;) {
                ;
              }

              if (s < 0) return;
            }

            Vt.pointerEvent = f, Vt.pointerX = r.pageX, Vt.pointerY = r.pageY;
          }

          return d && f ? (_t(f), St = !0, Et(Vt, "release", "onRelease")) : f && !h ? (St = !1, G && (n.snap || n.bounds) && pe(n.inertia || n.throwProps), Et(Vt, "release", "onRelease"), R && "touchmove" === f.type || -1 !== f.type.indexOf("cancel") || (Et(Vt, "click", "onClick"), rt() - ne < 300 && Et(Vt, "doubleclick", "onDoubleClick"), u = f.target || e, ne = rt(), c = function c() {
            ne === dt || !Vt.enabled() || Vt.isPressed || f.defaultPrevented || (u.click ? u.click() : oe.createEvent && ((l = oe.createEvent("MouseEvents")).initMouseEvent("click", !0, !0, M, 1, Vt.pointerEvent.screenX, Vt.pointerEvent.screenY, Vt.pointerX, Vt.pointerY, !1, !1, !1, !1, 0, null), u.dispatchEvent(l)));
          }, R || f.defaultPrevented || w.delayedCall(.05, c))) : (pe(n.inertia || n.throwProps), Vt.allowEventDefault || !f || !1 === n.dragClickables && ee.call(Vt, f.target) || !h || q && (!J || q !== J) || !1 === f.cancelable ? St = !1 : (St = !0, _t(f)), Et(Vt, "release", "onRelease")), _e() && p.duration(Vt.tween.duration()), h && Et(Vt, "dragend", "onDragEnd"), !0;
        }

        St && r && a && _t(r);
      },
          Me = function Me(t) {
        if (t && Vt.isDragging && !o) {
          var n = t.target || e.parentNode,
              r = n.scrollLeft - n._gsScrollX,
              i = n.scrollTop - n._gsScrollY;
          (r || i) && (W ? (s -= r * W.a + i * W.c, l -= i * W.d + r * W.b) : (s -= r, l -= i), n._gsScrollX += r, n._gsScrollY += i, be(Vt.pointerX, Vt.pointerY));
        }
      },
          Te = function Te(t) {
        var e = rt(),
            n = e - ne < 40,
            r = e - qt < 40,
            i = n && dt === ne,
            a = Vt.pointerEvent && Vt.pointerEvent.defaultPrevented,
            o = n && vt === ne,
            s = t.isTrusted || null == t.isTrusted && n && i;
        if ((i || r && !1 !== Vt.vars.suppressClickOnDrag) && t.stopImmediatePropagation && t.stopImmediatePropagation(), n && (!Vt.pointerEvent || !Vt.pointerEvent.defaultPrevented) && (!i || s && !o)) return s && i && (vt = ne), void (dt = ne);
        (Vt.isPressed || r || n) && (s && t.detail && n && !a || _t(t));
      },
          Se = function Se(t) {
        return W ? {
          x: t.x * W.a + t.y * W.c + W.e,
          y: t.x * W.b + t.y * W.d + W.f
        } : {
          x: t.x,
          y: t.y
        };
      };

      return (P = r.get(e)) && P.kill(), i.startDrag = function (t, n) {
        var r, i, a, o;
        ye(t || Vt.pointerEvent, !0), n && !Vt.hitTest(t || Vt.pointerEvent) && (r = At(t || Vt.pointerEvent), i = At(e), a = Se({
          x: r.left + r.width / 2,
          y: r.top + r.height / 2
        }), o = Se({
          x: i.left + i.width / 2,
          y: i.top + i.height / 2
        }), s -= a.x - o.x, l -= a.y - o.y), Vt.isDragging || (Vt.isDragging = !0, Et(Vt, "dragstart", "onDragStart"));
      }, i.drag = xe, i.endDrag = function (t) {
        return we(t || Vt.pointerEvent, !0);
      }, i.timeSinceDrag = function () {
        return Vt.isDragging ? 0 : (rt() - qt) / 1e3;
      }, i.timeSinceClick = function () {
        return (rt() - ne) / 1e3;
      }, i.hitTest = function (t, e) {
        return r.hitTest(Vt.target, t, e);
      }, i.getDirection = function (t, n) {
        var r,
            i,
            a,
            o,
            s,
            l,
            f = "velocity" === t && F ? t : V(t) && !Xt ? "element" : "start";
        return "element" === f && (s = At(Vt.target), l = At(t)), r = "start" === f ? Vt.x - u : "velocity" === f ? F.getVelocity(e, It) : s.left + s.width / 2 - (l.left + l.width / 2), Xt ? r < 0 ? "counter-clockwise" : "clockwise" : (n = n || 2, i = "start" === f ? Vt.y - c : "velocity" === f ? F.getVelocity(e, jt) : s.top + s.height / 2 - (l.top + l.height / 2), o = (a = Math.abs(r / i)) < 1 / n ? "" : r < 0 ? "left" : "right", a < n && ("" !== o && (o += "-"), o += i < 0 ? "up" : "down"), o);
      }, i.applyBounds = function (t, r) {
        var i, a, o, s, l, u;
        if (t && n.bounds !== t) return n.bounds = t, Vt.update(!0, r);

        if (ue(!0), fe(), f && !_e()) {
          if (i = Vt.x, a = Vt.y, i > p ? i = p : i < g && (i = g), a > m ? a = m : a < _ && (a = _), (Vt.x !== i || Vt.y !== a) && (o = !0, Vt.x = Vt.endX = i, Xt ? Vt.endRotation = i : Vt.y = Vt.endY = a, k = !0, le(!0), Vt.autoScroll && !Vt.isDragging)) for (Ct(e.parentNode), s = e, ct.scrollTop = null != M.pageYOffset ? M.pageYOffset : null != oe.documentElement.scrollTop ? oe.documentElement.scrollTop : oe.body.scrollTop, ct.scrollLeft = null != M.pageXOffset ? M.pageXOffset : null != oe.documentElement.scrollLeft ? oe.documentElement.scrollLeft : oe.body.scrollLeft; s && !u;) {
            l = (u = Tt(s.parentNode)) ? ct : s.parentNode, Wt && l.scrollTop > l._gsMaxScrollY && (l.scrollTop = l._gsMaxScrollY), Zt && l.scrollLeft > l._gsMaxScrollX && (l.scrollLeft = l._gsMaxScrollX), s = l;
          }
          Vt.isThrowing && (o || Vt.endX > p || Vt.endX < g || Vt.endY > m || Vt.endY < _) && pe(n.inertia || n.throwProps, o);
        }

        return Vt;
      }, i.update = function (t, n, r) {
        var i = Vt.x,
            a = Vt.y;
        return ge(!n), t ? Vt.applyBounds() : (k && r && le(!0), ue(!0)), n && (be(Vt.pointerX, Vt.pointerY), k && le(!0)), Vt.isPressed && !n && (Zt && Math.abs(i - Vt.x) > .01 || Wt && Math.abs(a - Vt.y) > .01 && !Xt) && me(), Vt.autoScroll && (Ct(e.parentNode, Vt.isDragging), Qt = Vt.isDragging, le(!0), Mt(e, Me), wt(e, Me)), Vt;
      }, i.enable = function (t) {
        var r,
            i,
            s,
            l = {
          lazy: !0
        };

        if (Xt || !1 === n.cursor || (l.cursor = n.cursor || Y), w.utils.checkPrefix("touchCallout") && (l.touchCallout = "none"), l.touchAction = Zt === Wt ? "none" : n.allowNativeTouchScrolling || n.allowEventDefault ? "manipulation" : Zt ? "pan-y" : "pan-x", "soft" !== t) {
          for (i = Ut.length; --i > -1;) {
            s = Ut[i], X || gt(s, "mousedown", ye), gt(s, "touchstart", ye), gt(s, "click", Te, !0), w.set(s, l), s.getBBox && s.ownerSVGElement && w.set(s.ownerSVGElement, {
              touchAction: Zt === Wt ? "none" : n.allowNativeTouchScrolling || n.allowEventDefault ? "manipulation" : Zt ? "pan-y" : "pan-x"
            }), n.allowContextMenu || gt(s, "contextmenu", se);
          }

          Rt(Ut, !1);
        }

        return wt(e, Me), a = !0, F && "soft" !== t && F.track(o || e, zt ? "x,y" : Xt ? "rotation" : "top,left"), e._gsDragID = r = "d" + ot++, at[r] = Vt, o && (o.enable(), o.element._gsDragID = r), (n.bounds || Xt) && me(), n.bounds && Vt.applyBounds(), Vt;
      }, i.disable = function (t) {
        var n,
            r,
            i = Vt.isDragging;
        if (!Xt) for (n = Ut.length; --n > -1;) {
          kt(Ut[n], "cursor", null);
        }

        if ("soft" !== t) {
          for (n = Ut.length; --n > -1;) {
            r = Ut[n], kt(r, "touchCallout", null), kt(r, "touchAction", null), mt(r, "mousedown", ye), mt(r, "touchstart", ye), mt(r, "click", Te), mt(r, "contextmenu", se);
          }

          Rt(Ut, !0), Z && (mt(Z, "touchcancel", we), mt(Z, "touchend", we), mt(Z, "touchmove", xe)), mt(oe, "mouseup", we), mt(oe, "mousemove", xe);
        }

        return Mt(e, Me), a = !1, F && "soft" !== t && F.untrack(o || e, zt ? "x,y" : Xt ? "rotation" : "top,left"), o && o.disable(), pt(le), Vt.isDragging = Vt.isPressed = j = !1, i && Et(Vt, "dragend", "onDragEnd"), Vt;
      }, i.enabled = function (t, e) {
        return arguments.length ? t ? Vt.enable(e) : Vt.disable(e) : a;
      }, i.kill = function () {
        return Vt.isThrowing = !1, Vt.tween && Vt.tween.kill(), Vt.disable(), w.set(Ut, {
          clearProps: "userSelect"
        }), delete at[e._gsDragID], Vt;
      }, ~Pt.indexOf("scroll") && (o = i.scrollProxy = new Ft(e, function (t, e) {
        for (var n in e) {
          n in t || (t[n] = e[n]);
        }

        return t;
      }({
        onKill: function onKill() {
          Vt.isPressed && we(null);
        }
      }, n)), e.style.overflowY = Wt && !L ? "auto" : "hidden", e.style.overflowX = Zt && !L ? "auto" : "hidden", e = o.content), Xt ? Gt.rotation = 1 : (Zt && (Gt[It] = 1), Wt && (Gt[jt] = 1)), re.force3D = !("force3D" in n) || n.force3D, i.enable(), i;
    }

    return n = t, (e = r).prototype = Object.create(n.prototype), e.prototype.constructor = e, e.__proto__ = n, r.register = function (t) {
      w = t, Yt();
    }, r.create = function (t, e) {
      return P || Yt(!0), E(t).map(function (t) {
        return new r(t, e);
      });
    }, r.get = function (t) {
      return at[(E(t)[0] || {})._gsDragID];
    }, r.timeSinceDrag = function () {
      return (rt() - lt) / 1e3;
    }, r.hitTest = function (t, e, n) {
      if (t === e) return !1;
      var r,
          i,
          a,
          o = At(t),
          s = At(e),
          l = o.top,
          u = o.left,
          c = o.right,
          f = o.bottom,
          h = o.width,
          d = o.height,
          p = s.left > c || s.right < u || s.top > f || s.bottom < l;
      return p || !n ? !p : (a = -1 !== (n + "").indexOf("%"), n = parseFloat(n) || 0, (r = {
        left: Math.max(u, s.left),
        top: Math.max(l, s.top)
      }).width = Math.min(c, s.right) - r.left, r.height = Math.min(f, s.bottom) - r.top, !(r.width < 0 || r.height < 0) && (a ? (n *= .01, (i = r.width * r.height) >= h * d * n || i >= s.width * s.height * n) : r.width > n && r.height > n));
    }, r;
  }(function () {
    function t(t) {
      this._listeners = {}, this.target = t || this;
    }

    var e = t.prototype;
    return e.addEventListener = function (t, e) {
      var n = this._listeners[t] || (this._listeners[t] = []);
      ~n.indexOf(e) || n.push(e);
    }, e.removeEventListener = function (t, e) {
      var n = this._listeners[t],
          r = n && n.indexOf(e) || -1;
      r > -1 && n.splice(r, 1);
    }, e.dispatchEvent = function (t) {
      var e,
          n = this;
      return (this._listeners[t] || []).forEach(function (r) {
        return !1 === r.call(n, {
          type: t,
          target: n.target
        }) && (e = !1);
      }), e;
    }, t;
  }());

  !function (t, e) {
    for (var n in e) {
      n in t || (t[n] = e[n]);
    }
  }(Xt.prototype, {
    pointerX: 0,
    pointerY: 0,
    startX: 0,
    startY: 0,
    deltaX: 0,
    deltaY: 0,
    isDragging: !1,
    isPressed: !1
  }), Xt.zIndex = 1e3, Xt.version = "3.3.4", W() && w.registerPlugin(Xt);
}, function (t, e, n) {
  "use strict";

  n.r(e), n.d(e, "InertiaPlugin", function () {
    return G;
  }), n.d(e, "default", function () {
    return G;
  }), n.d(e, "VelocityTracker", function () {
    return y;
  });
  /*!
   * VelocityTracker: 3.2.6
   * https://greensock.com
   *
   * Copyright 2008-2020, GreenSock. All rights reserved.
   * Subject to the terms at https://greensock.com/standard-license or for
   * Club GreenSock members, the agreement issued with that membership.
   * @author: Jack Doyle, jack@greensock.com
   */

  var r,
      i,
      a,
      o,
      s,
      l,
      u,
      c,
      f = function f() {
    return r || "undefined" != typeof window && (r = window.gsap);
  },
      h = {},
      d = function d(t) {
    return c(t).id;
  },
      p = function p(t) {
    return h[d("string" == typeof t ? a(t)[0] : t)];
  },
      g = function g(t) {
    var e,
        n = s;
    if (t - u >= .05) for (u, u = t; n;) {
      ((e = n.g(n.t, n.p)) !== n.v1 || t - n.t1 > .2) && (n.v2 = n.v1, n.v1 = e, n.t2 = n.t1, n.t1 = t), n = n._next;
    }
  },
      m = {
    deg: 360,
    rad: 2 * Math.PI
  },
      _ = function _() {
    (r = f()) && (a = r.utils.toArray, o = r.utils.getUnit, c = r.core.getCache, l = r.ticker, i = 1);
  },
      v = function v(t, e, n, r) {
    this.t = t, this.p = e, this.g = t._gsap.get, this.rCap = m[n || o(this.g(t, e))], this.v1 = this.v2 = 0, this.t1 = this.t2 = l.time, r && (this._next = r, r._prev = this);
  },
      y = function () {
    function t(t, e) {
      i || _(), this.target = a(t)[0], h[d(this.target)] = this, this._props = {}, e && this.add(e);
    }

    t.register = function (t) {
      r = t, _();
    };

    var e = t.prototype;
    return e.get = function (t, e) {
      var n,
          r,
          i,
          a = this._props[t];
      return a || console.warn("Not tracking " + t + " velocity."), n = parseFloat(e ? a.v1 : a.g(a.t, a.p)) - parseFloat(a.v2), (r = a.rCap) && (n %= r) !== n % (r / 2) && (n = n < 0 ? n + r : n - r), i = n / ((e ? a.t1 : l.time) - a.t2), Math.round(1e4 * i) / 1e4;
    }, e.getAll = function () {
      var t,
          e = {},
          n = this._props;

      for (t in n) {
        e[t] = this.get(t);
      }

      return e;
    }, e.isTracking = function (t) {
      return t in this._props;
    }, e.add = function (t, e) {
      t in this._props || (s || (l.add(g), u = l.time), s = this._props[t] = new v(this.target, t, e, s));
    }, e.remove = function (t) {
      var e,
          n,
          r = this._props[t];
      r && (e = r._prev, n = r._next, e && (e._next = n), n ? n._prev = e : s === r && (l.remove(g), s = 0), delete this._props[t]);
    }, e.kill = function (t) {
      for (var e in this._props) {
        this.remove(e);
      }

      t || delete h[d(this.target)];
    }, t.track = function (e, n, r) {
      i || _();

      for (var o, s, l = [], u = a(e), c = n.split(","), f = (r || "").split(","), h = u.length; h--;) {
        for (o = p(u[h]) || new t(u[h]), s = c.length; s--;) {
          o.add(c[s], f[s] || f[0]);
        }

        l.push(o);
      }

      return l;
    }, t.untrack = function (t, e) {
      var n = (e || "").split(",");
      a(t).forEach(function (t) {
        var e = p(t);
        e && (n.length ? n.forEach(function (t) {
          return e.remove(t);
        }) : e.kill(1));
      });
    }, t.isTracking = function (t, e) {
      var n = p(t);
      return n && n.isTracking(e);
    }, t.getVelocity = function (t, e) {
      var n = p(t);
      return n && n.isTracking(e) ? n.get(e) : console.warn("Not tracking velocity of " + e);
    }, t;
  }();

  y.getByTarget = p, f() && r.registerPlugin(y);
  /*!
   * InertiaPlugin 3.2.6
   * https://greensock.com
   *
   * @license Copyright 2008-2020, GreenSock. All rights reserved.
   * Subject to the terms at https://greensock.com/standard-license or for
   * Club GreenSock members, the agreement issued with that membership.
   * @author: Jack Doyle, jack@greensock.com
   */

  var x,
      b,
      w,
      M,
      T,
      S,
      C,
      k,
      O,
      P,
      A,
      E = y.getByTarget,
      D = function D() {
    return x || "undefined" != typeof window && (x = window.gsap) && x.registerPlugin && x;
  },
      L = function L(t) {
    return "number" == typeof t;
  },
      z = function z(t) {
    return "object" == typeof t;
  },
      N = function N(t) {
    return "function" == typeof t;
  },
      B = Array.isArray,
      R = function R(t) {
    return t;
  },
      F = 1e10,
      Y = function Y(t, e, n) {
    for (var r in e) {
      r in t || r === n || (t[r] = e[r]);
    }

    return t;
  },
      X = function X(t, e, n, r, i) {
    var a,
        o,
        s,
        l,
        u = e.length,
        c = 0,
        f = F;

    if (z(t)) {
      for (; u--;) {
        for (s in a = e[u], o = 0, t) {
          o += (l = a[s] - t[s]) * l;
        }

        o < f && (c = u, f = o);
      }

      if ((i || F) < F && i < Math.sqrt(f)) return t;
    } else for (; u--;) {
      (o = (a = e[u]) - t) < 0 && (o = -o), o < f && a >= r && a <= n && (c = u, f = o);
    }

    return e[c];
  },
      I = function I(t, e, n, r, i, a) {
    if ("auto" === t.end) return t;
    var o,
        s,
        l = t.end;

    if (n = isNaN(n) ? F : n, r = isNaN(r) ? -F : r, z(e)) {
      if (o = e.calculated ? e : (N(l) ? l(e) : X(e, l, n, r, a)) || e, !e.calculated) {
        for (s in o) {
          e[s] = o[s];
        }

        e.calculated = !0;
      }

      o = o[i];
    } else o = N(l) ? l(e) : B(l) ? X(e, l, n, r, a) : parseFloat(l);

    return o > n ? o = n : o < r && (o = r), {
      max: o,
      min: o,
      unitFactor: t.unitFactor
    };
  },
      j = function j(t, e, n) {
    return isNaN(t[e]) ? n : +t[e];
  },
      Z = function Z(t, e) {
    return .05 * e * t / P;
  },
      W = function W(t, e, n) {
    return Math.abs((e - t) * P / n / .05);
  },
      H = {
    resistance: 1,
    checkpoint: 1,
    preventOvershoot: 1,
    linkedProps: 1,
    radius: 1,
    duration: 1
  },
      V = function V(t, e, n, r) {
    if (e.linkedProps) {
      var i,
          a,
          o,
          s,
          l,
          u,
          c = e.linkedProps.split(","),
          f = {};

      for (i = 0; i < c.length; i++) {
        (o = e[a = c[i]]) && (s = L(o.velocity) ? o.velocity : (l = l || E(t)) && l.isTracking(a) ? l.get(a) : 0, u = Math.abs(s / j(o, "resistance", r)), f[a] = parseFloat(n(t, a)) + Z(s, u));
      }

      return f;
    }
  },
      U = function U() {
    (x = D()) && (w = x.parseEase, M = x.utils.toArray, C = x.utils.getUnit, O = x.core.getCache, A = x.utils.clamp, T = w("power3"), P = T(.05), k = x.core.PropTween, x.config({
      resistance: 100,
      unitFactors: {
        time: 1e3,
        totalTime: 1e3
      }
    }), S = x.config(), x.registerPlugin(y), b = 1);
  },
      G = {
    version: "3.2.6",
    name: "inertia",
    register: function register(t) {
      x = t, U();
    },
    init: function init(t, e, n, r, i) {
      b || U();
      var a = E(t);

      if ("auto" === e) {
        if (!a) return void console.warn("No inertia tracking on " + t + ". InertiaPlugin.track(target) first.");
        e = a.getAll();
      }

      this.target = t, this.tween = n;
      var o,
          s,
          l,
          u,
          c,
          f,
          h,
          d,
          p,
          g = t._gsap,
          m = g.get,
          _ = e.duration,
          v = z(_),
          y = e.preventOvershoot || v && 0 === _.overshoot,
          x = j(e, "resistance", S.resistance),
          w = L(_) ? _ : function (t, e, n, r, i, a) {
        if (void 0 === n && (n = 10), void 0 === r && (r = .2), void 0 === i && (i = 1), void 0 === a && (a = 0), "string" == typeof t && (t = M(t)[0]), !t) return 0;
        var o,
            s,
            l,
            u,
            c,
            f,
            h,
            d,
            p,
            g,
            m = 0,
            _ = F,
            v = e.inertia || e,
            y = O(t).get,
            x = j(v, "resistance", S.resistance);

        for (o in g = V(t, v, y, x), v) {
          H[o] || (s = v[o], z(s) || ((d = d || E(t)) && d.isTracking(o) ? s = L(s) ? {
            velocity: s
          } : {
            velocity: d.get(o)
          } : (u = +s || 0, l = Math.abs(u / x))), z(s) && (u = L(s.velocity) ? s.velocity : (d = d || E(t)) && d.isTracking(o) ? d.get(o) : 0, l = A(r, n, Math.abs(u / j(s, "resistance", x))), f = (c = parseFloat(y(t, o)) || 0) + Z(u, l), "end" in s && (s = I(s, g && o in g ? g : f, s.max, s.min, o, v.radius), a && (v[o] = Y(s, v[o], "end"))), "max" in s && f > +s.max + 1e-10 ? (p = s.unitFactor || S.unitFactors[o] || 1, (h = c > s.max && s.min !== s.max || u * p > -15 && u * p < 45 ? r + .1 * (n - r) : W(c, s.max, u)) + i < _ && (_ = h + i)) : "min" in s && f < +s.min - 1e-10 && (p = s.unitFactor || S.unitFactors[o] || 1, (h = c < s.min && s.min !== s.max || u * p > -45 && u * p < 15 ? r + .1 * (n - r) : W(c, s.min, u)) + i < _ && (_ = h + i)), h > m && (m = h)), l > m && (m = l));
        }

        return m > _ && (m = _), m > n ? n : m < r ? r : m;
      }(t, e, v && _.max || 10, v && _.min || .2, v && "overshoot" in _ ? +_.overshoot : y ? 0 : 1);

      for (o in p = V(t, e, m, x), e) {
        H[o] || (s = e[o], N(s) && (s = s(r, t, i)), L(s) ? c = s : z(s) && !isNaN(s.velocity) ? c = +s.velocity : a && a.isTracking(o) ? c = a.get(o) : console.warn("ERROR: No velocity was defined for " + t + " property: " + o), f = Z(c, w), d = 0, l = m(t, o), u = C(l), l = parseFloat(l), z(s) && (h = l + f, "end" in s && (s = I(s, p && o in p ? p : h, s.max, s.min, o, e.radius)), "max" in s && +s.max < h ? y || s.preventOvershoot ? f = s.max - l : d = s.max - l - f : "min" in s && +s.min > h && (y || s.preventOvershoot ? f = s.min - l : d = s.min - l - f)), this._props.push(o), this._pt = new k(this._pt, t, o, l, 0, R, 0, g.set(t, o, this)), this._pt.u = u || 0, this._pt.c1 = f, this._pt.c2 = d);
      }

      return n.duration(w), 1;
    },
    render: function render(t, e) {
      var n,
          r = e._pt;

      for (t = T(e.tween._time / e.tween._dur); r;) {
        r.set(r.t, r.p, (n = r.s + r.c1 * t + r.c2 * t * t, Math.round(1e4 * n) / 1e4 + r.u), r.d, t), r = r._next;
      }
    }
  };

  "track,untrack,isTracking,getVelocity,getByTarget".split(",").forEach(function (t) {
    return G[t] = y[t];
  }), D() && x.registerPlugin(G);
}]);